const generateOptions = (correctAnswer, category, allAnswers) => {
  let options = [correctAnswer];
  const incorrectOptions = allAnswers.filter(ans => ans !== correctAnswer);

  // Randomly pick 2 incorrect options
  while (options.length < 3 && incorrectOptions.length > 0) {
    const randomIndex = Math.floor(Math.random() * incorrectOptions.length);
    options.push(incorrectOptions[randomIndex]);
    incorrectOptions.splice(randomIndex, 1); // Remove to avoid duplicates
  }

  // If there are fewer than 3 unique options, fill with generic fillers
  while (options.length < 3) {
    options.push(`다른 ${options.length + 1}번 보기`);
  }

  // Shuffle options
  return options.sort(() => Math.random() - 0.5);
};


const allQuizAnswers = {
  fish_marine: [
    "금붕어", "돌고래", "상어", "복어", "고래", "흰동가리", "펭귄", "전기뱀장어",
    "해마", "가오리", "불가사리", "문어", "오징어", "피라냐", "연어", "참치",
    "방어", "메기", "장어", "해파리", "산호", "조개", "바다거북", "곰치", "바다코끼리",
    "게", "고등어", "가자미", "바다표범", "말미잘", "돛새치", "소라게", "물범",
    "바닷가재", "해삼", "다랑어", "청어", "멸치", "병어", "고래상어", "망치상어",
    "벨루가", "범고래", "매너티", "듀공", "아귀", "날치", "청새치",
    "넙치", "베타", "뱅어", "학꽁치", "전복", "밤게", "투구게", "심해어", "소라게", "먹장어",
    "앵무고기", "엔젤피쉬", "짱뚱어", "가시복", "실고기", "쏠종개", "멍게", "물개",
    "빨판상어", "쥐가오리", "전어", "금눈돔", "갈치", "대하", "킹크랩", "쭈꾸미",
    "갑오징어", "굴", "꼬막", "대나무조개", "도미", "미꾸라지", "송어", "은어",
    "물총고기", "배럴아이", "블롭피쉬", "초롱아귀"
  ],
  animals: [
    "사자", "기린", "코끼리", "얼룩말", "하이에나", "판다", "호랑이", "원숭이",
    "뱀", "악어", "토끼", "다람쥐", "여우", "곰", "사슴", "하마", "낙타",
    "펭귄", "부엉이", "기니피그", "늑대", "고릴라", "치타", "표범", "코뿔소",
    "캥거루", "고양이", "개", "말", "소", "양", "돼지", "닭", "오리",
    "독수리", "앵무새", "박쥐", "공작", "멧돼지", "수달", "참새", "산양",
    "두더지", "페넥여우", "딱따구리", "천산갑", "까마귀", "비버", "기러기",
    "순록", "염소", "당나귀", "누", "엘크", "사막여우", "안경곰", "레서판다",
    "북극여우", "고슴도치", "굴토끼", "왈라비", "코알라", "오리너구리", "바늘두더지",
    "하늘다람쥐", "스컹크", "개미핥기", "나무늘보", "오랑우탄", "보노보", "맨드릴",
    "피그미마모셋", "사자원숭이", "안경원숭이", "라쿤", "미어캣", "설표", "흑표범",
    "스라소니", "해달", "반달가슴곰"
  ],
  insects: [
    "나비", "개미", "무당벌레", "잠자리", "매미", "메뚜기", "베짱이", "사마귀",
    "반딧불이", "물방개", "풍뎅이", "거미", "꿀벌", "말벌", "나방", "하루살이",
    "모기", "파리", "바퀴벌레", "진딧물", "대나무벌레", "개미귀신", "물벼룩",
    "굼벵이", "송장벌레", "그리마", "누에나방", "하늘소", "게아재비", "장수말벌",
    "좀", "개똥벌레", "왕사마귀", "왕사슴벌레", "귀뚜라미", "뒤영벌", "고추잠자리",
    "소금쟁이", "꽃등에", "장수풍뎅이", "사슴벌레", "방울벌레", "배추흰나비",
    "애벌레", "번데기", "거위벌레", "날도래",
    "여치", "장구애비", "소똥구리", "비단벌레", "대벌레", "꽃사마귀", "노린재",
    "호리병벌", "좀나방", "늑대거미", "타란튤라", "전갈"
  ],
  dinosaurs: [
    "티라노사우루스", "트리케라톱스", "브라키오사우루스", "스테고사우루스", "벨로키랍토르",
    "파라사우롤로푸스", "안킬로사우루스", "프테라노돈", "딜로포사우루스", "스피노사우루스",
    "이구아노돈", "파키케팔로사우루스", "코리토사우루스", "알로사우루스", "콤프소그나투스",
    "마이아사우라", "카르노타우루스", "데이노니쿠스", "디플로도쿠스", "프로토케라톱스",
    "카스모사우루스", "모사사우루스", "갈리미무스", "아파토사우루스", "스티라코사우루스",
    "마멘키사우루스", "시조새", "켄트로사우루스", "테리지노사우루스", "엘라스모사우루스",
    "닉토사우루스", "헤스페로사우루스", "사르코수쿠스", "오르니토미무스", "기가노토사우루스",
    "우타랍토르", "케찰코아틀루스", "에드몬토니아", "람베오사우루스", "다스플레토사우루스",
    "케라토사우루스", "프시타코사우루스", "에이니오사우루스", "에오랍토르", "이크티오사우루스",
    "트로오돈", "파키리노사우루스", "가스토니아", "오비랍토르", "타페야라",
    "아마르가사우루스", "오로드로메우스", "타르보사우루스", "펜타케라톱스",
    "안세리미무스", "틸로사우루스", "메갈로사우루스", "유오플로케팔루스"
  ]
};

const quizQuestions = [
  // Fish/Marine Animals Quiz (60 questions)
  {
    id: "fish_marine001", category: "fish_marine", difficulty: "easy",
    question: "번쩍번쩍 금빛 옷을 입고 어항 속에서 살랑살랑 헤엄치는 친구야! 몸이 동글동글 작고 예뻐서 우리 집 작은 어항에서도 키울 수 있단다. 뻐끔뻐끔 입을 벌리며 말을 거는 것 같기도 하고, 커다란 꼬리 지느러미를 부채처럼 흔드는 이 귀여운 물고기는 누구일까요?",
    answer: "금붕어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Goldfish.jpg/500px-Goldfish.jpg",
  },
  {
    id: "fish_marine002", category: "fish_marine", difficulty: "easy",
    question: "매끄러운 몸으로 바다를 슉슉 누비며 사람처럼 공기로 숨을 쉬는 멋진 친구야! 머리가 아주 좋아서 친구들과 신호를 주고받으며 대화도 할 수 있단다. 물 위로 높이 점프하는 걸 좋아하고, 아기에게 젖을 먹여 키우는 바다의 똑똑이 포유류는 누구일까요?",
    answer: "돌고래",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/NMMP_dolphin_with_locator.jpeg/500px-NMMP_dolphin_with_locator.jpeg",
  },
  {
    id: "fish_marine003", category: "fish_marine", difficulty: "medium",
    question: "바다의 무시무시한 사냥꾼으로, 등에 뾰족한 삼각형 지느러미가 삐죽 나와 있어! 아주 멀리서도 냄새를 잘 맡을 수 있고, 이빨이 빠져도 금방 새 이빨이 돋아나는 신기한 몸을 가졌단다. 뼈가 아주 말랑말랑해서 헤엄을 더 잘 치는 이 무서운 바다 물고기는 누구일까요?",
    answer: "상어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Early_Shark.jpg",
  },
  {
    id: "fish_marine004", category: "fish_marine", difficulty: "easy",
    question: "깜짝 놀라면 배를 빵빵하게 부풀려서 동그란 공처럼 변신하는 친구야! 몸에는 따끔따끔한 가시가 튀어나오기도 하고, 적이 나를 먹지 못하게 무서운 독을 숨기고 있기도 해. 화가 나면 볼을 빵빵하게 만드는 귀여운 욕심쟁이 물고기는 누구일까요?",
    answer: "복어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Fugu_in_Tank.jpg/500px-Fugu_in_Tank.jpg",
  },
  {
    id: "fish_marine005", category: "fish_marine", difficulty: "easy",
    question: "지구에서 몸집이 가장 커다란 바다 생물로, 코가 정수리에 있어서 위로 물줄기를 쏴~ 하고 내뿜어! 덩치는 산만큼 크지만 아주 작은 먹이를 걸러 먹는 걸 좋아한단다. 깊은 바다를 여행하며 노래를 부르기도 하는 바다의 거인 친구는 누구일까요?",
    answer: "고래",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Baleine_%C3%A0_bosse_et_son_baleineau_2.jpg/500px-Baleine_%C3%A0_bosse_et_son_baleineau_2.jpg",
  },
  {
    id: "fish_marine006", category: "fish_marine", difficulty: "easy",
    question: "선명한 주황색 몸에 하얀 줄무늬가 세 개 그려진 바다의 멋쟁이야! 무시무시한 독이 있는 말미잘 텐트 속에 쏙 들어가서 안전하게 잠을 잔단다. 영화 '니모를 찾아서'에도 나왔던 아주 유명하고 용감한 이 작은 물고기는 누구일까요?",
    answer: "흰동가리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Amphiprion_clarkii_1.jpg/500px-Amphiprion_clarkii_1.jpg",
  },
  {
    id: "fish_marine007", category: "fish_marine", difficulty: "easy",
    question: "검은색 코트를 입고 하얀 셔츠를 입은 젠틀맨처럼 생겼지만, 사실은 땅 위를 아장아장 걷는 새야! 날개는 있지만 하늘을 날지는 못하고, 대신 물속에서는 로켓처럼 빠르게 수영할 수 있지. 추운 얼음 나라 남극에 살며 아기에게 맛있는 물고기를 가져다주는 이 친구는 누구일까요?",
    answer: "펭귄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg/500px-Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg",
  },
  {
    id: "fish_marine008", category: "fish_marine", difficulty: "medium",
    question: "길쭉한 뱀을 닮았는데, 몸에서 찌릿찌릿 전기를 만들어내는 아주 특별한 능력을 가졌어! 이 전기로 적을 쫓아내거나 먹이를 잡기도 하고, 어두운 물속에서 길을 찾기도 해. 아마존강 깊은 곳에 숨어 사는 신비롭고 조금은 무서운 이 물고기는 무엇일까요?",
    answer: "전기뱀장어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Electrophorus_electricus_4.jpg/500px-Electrophorus_electricus_4.jpg",
  },
  {
    id: "fish_marine009", category: "fish_marine", difficulty: "easy",
    question: "얼굴이랴랴 목 모양이랴 말이랑 아주 똑 닮은 신기한 바다 친구야! 꼬리를 돌돌 말아서 바다풀을 꼭 잡고 떠내려가지 않게 버틴단다. 아주 특이하게도 엄마가 아닌 아빠의 배 주머니에서 아기들이 태어나는 이 똑똑한 아빠 물고기는 누구일까요?",
    answer: "해마",
  },
  {
    id: "fish_marine010", category: "fish_marine", difficulty: "medium",
    question: "몸이 종이처럼 넓고 납작해서 바다 밑바닥을 미끄러지듯이 다닐 수 있어! 커다란 옆 지느러미를 날개처럼 펼쳐서 바다 하늘을 날아다니는 것 같지. 꼬리에는 무서운 독침이 숨겨져 있어 조심해야 하는 연을 닮은 이 바다 동물은 누구일까요?",
    answer: "가오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Dasyatis_americana_bonaire.jpg/500px-Dasyatis_americana_bonaire.jpg",
  },
  {
    id: "fish_marine011", category: "fish_marine", difficulty: "easy",
    question: "밤하늘에 떠 있는 별이 바닷속으로 퐁당 빠진 것 같은 모양을 하고 있어! 다리가 보통 다섯 개인데, 다리가 잘려도 다시 쑥쑥 자라나는 엄청난 생명력을 가졌지. 아주 천천히 바닥을 기어가다가 조개를 꽉 잡고 먹는 이 바다 별 친구는 누구일까요?",
    answer: "불가사리",
  },
  {
    id: "fish_marine012", category: "fish_marine", difficulty: "easy",
    question: "여덟 개의 긴 팔에 동글동글한 빨판이 가득 달려서 무엇이든 꽉 잡을 수 있어! 위험한 순간엔 시커먼 먹물을 뿜어서 적의 눈을 가리고 휙~ 하고 도망친단다. 뼈가 하나도 없어서 작은 틈새도 쏙 통과하는 변신의 귀재인 이 바다 생물은 누구일까요?",
    answer: "문어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Enteroctopus_dolfeini.jpg/500px-Enteroctopus_dolfeini.jpg",
  },
  {
    id: "fish_marine013", category: "fish_marine", difficulty: "easy",
    question: "다리가 10개나 되고 세모난 모자를 쓴 것처럼 머리가 뾰쪽하게 생겼어! 밤에 밝은 불빛을 아주 좋아해서 어부 아저씨들이 불을 켜고 잡으러 오신단다. 쫄깃쫄깃한 맛이 최고라 말려서 간식으로도 자주 먹는 이 바다 친구는 누구일까요?",
    answer: "오징어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/9/94/Squidu.jpg",
  },
  {
    id: "fish_marine014", category: "fish_marine", difficulty: "hard",
    question: "아마존강의 무법자로 통하며, 작지만 아주 날카롭고 튼튼한 이빨을 가지고 있어! 혼자가 아니라 수백 마리씩 떼를 지어 다니며 무엇이든 눈 깜짝할 새에 먹어 치운단다. '이빨이 있는 물고기'라는 뜻의 이름을 가진 이 무서운 담수어는 누구일까요?",
    answer: "피라냐",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Pirhana06.jpg/500px-Pirhana06.jpg",
  },
  {
    id: "fish_marine015", category: "fish_marine", difficulty: "medium",
    question: "넓은 바다에서 살다가 아기를 낳을 때가 되면 자신이 태어난 강으로 먼 길을 거슬러 올라와! 은빛 몸이 붉게 변하기도 하고, 곰들이 시냇가에서 낚시하길 기다리는 영양가 만점 물고기란다. 주황색 맛있는 속살을 가져 우리가 정말 좋아하는 이 물고기는 무엇일까요?",
    answer: "연어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Oncorhynchus_keta_336279549.jpg/500px-Oncorhynchus_keta_336279549.jpg",
  },
  {
    id: "fish_marine016", category: "fish_marine", difficulty: "medium",
    question: "바다에서 시속 70km가 넘는 속도로 아주 빠르게 헤엄치는 레이서 물고기야! 몸집이 어른보다도 훨씬 크게 자랄 수 있고, 반짝이는 은빛 등에 검은색 무늬가 멋지게 그려져 있지. 참치 샌드위치나 통조림으로 우리 식탁에 자주 올라오는 이 힘센 물고기는 누구일까요?",
    answer: "참치",
  },
  {
    id: "fish_marine017", category: "fish_marine", difficulty: "medium",
    question: "기름기가 좔좔 흐르는 은색 몸을 가졌으며, 겨울 바람이 불 때 가장 통통하고 맛있어지는 친구야! 힘이 아주 좋아서 낚시꾼들에게 인기가 많고, 떼를 지어 먼 바다를 아주 빠르게 이동한단다. 차가운 바다를 좋아하는 이 튼튼한 은빛 물고기는 무엇일까요?",
    answer: "방어",
  },
  {
    id: "fish_marine018", category: "fish_marine", difficulty: "easy",
    question: "강바닥의 진흙 속에 숨어 살며, 입 옆에 긴 수염이 고양이처럼 삐죽삐죽 나 있어! 몸은 미끈미끈해서 손으로 잡기 힘들고, 비늘이 없는 대신 아주 부드러운 피부를 가졌단다. 큰 입으로 무엇이든 꿀꺽 삼키는 조금은 못생겼지만 귀여운 이 물고기는 무엇일까요?",
    answer: "메기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Silurus.jpg/500px-Silurus.jpg",
  },
  {
    id: "fish_marine019", category: "fish_marine", difficulty: "easy",
    question: "뱀처럼 길쭉길쭉한 몸을 가졌는데 비늘이 없어서 엄청 미끄러운 친구야! 좁은 구멍 사이를 쏙쏙 잘 빠져나가고, 힘이 아주 세서 보양식으로도 인기가 정말 많지. 꼬리 힘 하나로 바다를 가로지르는 미끌미끌 수영 박사인 이 물고기는 누구일까요?",
    answer: "장어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Conger_conger_Gervais.jpg/500px-Conger_conger_Gervais.jpg",
  },
  {
    id: "fish_marine020", category: "fish_marine", difficulty: "easy",
    question: "몸이 유리처럼 투명해서 뱃속이 훤히 다 비쳐 보이는 신비로운 바다 친구야! 뼈도 눈도 없지만 물속에서 풍선처럼 둥둥 떠다니며 춤을 춘단다. 하지만 긴 촉수에 닿으면 따끔하고 아플 수 있으니 조심해야 하는 이 말랑말랑 친구는 누구일까요?",
    answer: "해파리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Jelly_Monterey.jpg/500px-Jelly_Monterey.jpg",
  },
  {
    id: "fish_marine021", category: "fish_marine", difficulty: "medium",
    question: "바다의 보석이라 불리며, 알록달록 꽃봉오리처럼 예쁜 모양을 하고 있어! 사실은 식물이 아니라 아주 작은 동물들이 모여서 만든 커다란 집이기도 하단다. 물고기들이 숨바꼭질하며 노는 소중한 놀이터가 되어주고, 따뜻하고 맑은 바다를 좋아하는 이 아름다운 바다 꽃은 무엇일까요?",
    answer: "산호",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/PillarCoral.jpg/500px-PillarCoral.jpg",
  },
  {
    id: "fish_marine022", category: "fish_marine", difficulty: "easy",
    question: "딱딱하고 매끄러운 두 개의 껍질 속에 부드러운 몸을 숨기고 사는 부끄럼쟁이야! 모래 속에 쏙 들어가서 숨어 지내기도 하고, 가끔은 반짝반짝 예쁜 진주를 품고 있기도 하단다. 바다 냄새가 물씬 풍기는 맛있는 국물을 만들어주는 이 껍데기 친구는 누구일까요?",
    answer: "조개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Seashells_in_the_basket.jpg/500px-Seashells_in_the_basket.jpg",
  },
  {
    id: "fish_marine023", category: "fish_marine", difficulty: "easy",
    question: "등에 커다란 방패처럼 생긴 딱딱한 집을 지고 푸른 바다를 느긋하게 헤엄쳐! 다리가 지느러미처럼 넓적해서 물속을 아주 잘 다니고, 아주아주 오래 살아서 바다의 지혜로운 할아버지 같단다. 육지로 올라와 모래사장에 소중한 알을 낳는 이 멋진 헤엄꾼은 누구일까요?",
    answer: "바다거북",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Hawaii_turtle_2.JPG/500px-Hawaii_turtle_2.JPG",
  },
  {
    id: "fish_marine024", category: "fish_marine", difficulty: "easy",
    question: "바닷속 어두운 바위 틈새에 숨어서 눈만 반짝이고 있는 무서운 사냥꾼이야! 뱀처럼 길쭉한 몸을 가졌지만 미끌미끈하고 힘이 아주 세서 무엇이든 한 번 물면 놓지 않는단다. 화려한 무늬를 뽐내며 입을 크게 벌려 위협하기도 하는 이 바다의 대장은 누구일까요?",
    answer: "곰치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Gymnothorax_kidako.jpg/500px-Gymnothorax_kidako.jpg",
  },
  {
    id: "fish_marine025", category: "fish_marine", difficulty: "easy",
    question: "딱딱한 갑옷을 입고 두 개의 커다란 집게발을 앞세워 옆으로 옆으로 걷는 장난꾸러기야! 등껍질은 아주 튼튼해서 몸을 잘 보호해주고, 위험할 땐 집게발로 꽉! 집어서 나를 방어한단다. 갯벌이나 바닷가 바위 위에서 뽀글뽀글 거품을 내뿜는 이 친구는 누구일까요?",
    answer: "게",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Eriphia_verrucosa_male_2009_G5.jpg/500px-Eriphia_verrucosa_male_2009_G5.jpg",
  },
  {
    id: "fish_marine026", category: "fish_marine", difficulty: "medium",
    question: "몸이 납작한 종잇장 같아서 모래 바닥에 착 붙어 있으면 아무도 찾지 못해! 두 눈이 얼굴 한쪽으로 쏠려 있는 아주 신기한 모습인데, 모래 속에 숨어 있다가 먹이가 지나가면 순식간에 낚아챈단다. 바다 밑바닥의 숨바꼭질 달인인 이 납작한 물고기는 무엇일까요?",
    answer: "가자미",
  },
  {
    id: "fish_marine027", category: "fish_marine", difficulty: "medium",
    question: "뱀의 머리를 닮았다고 해서 이름 붙여진, 강물의 아주 무서운 사냥꾼이야! 몸매가 미끈하고 이빨이 날카로워서 작은 물고기나 개구리까지 잡아먹는 힘센 친구란다. 물 밖에서도 한동안 숨을 쉴 수 있는 엄청난 생명력을 가진 이 민물고기는 무엇일까요?",
    answer: "가물치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Snakehead_-_Channa_argus.jpg/500px-Snakehead_-_Channa_argus.jpg",
  },
  {
    id: "fish_marine028", category: "fish_marine", difficulty: "medium",
    question: "등에 커다란 돛처럼 생긴 지느러미를 뽐내며 바다 위를 시속 100km 넘게 달리는 속도광이야! 입 부근이 뾰족한 창처럼 길쭉해서 물의 저항을 이겨내고 아주 날렵하게 헤엄을 칠 수 있단다. 푸른 바다의 번개라고 불리는 이 멋진 돛을 가진 물고기는 누구일까요?",
    answer: "돛새치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Istiophorus_platypterus.jpg/500px-Istiophorus_platypterus.jpg",
  },
  {
    id: "fish_marine029", category: "fish_marine", difficulty: "medium",
    question: "매끄러운 바다 모래 위를 걷다가 마음에 드는 조개껍질을 발견하면 쏙 들어가서 내 집처럼 사용하는 영리한 친구야! 원래 내 몸은 말랑말랑해서 딱딱한 껍질이 꼭 필요하단다. 집이 좁아지면 더 큰 껍질로 이사를 가기도 하는 바다의 이사왕은 누구일까요?",
    answer: "소라게",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Calliactis_and_Dardanus_001.JPG/500px-Calliactis_and_Dardanus_001.JPG",
  },
  {
    id: "fish_marine030", category: "fish_marine", difficulty: "easy",
    question: "알록달록 예쁜 색깔 옷을 입고 산호초 사이에서 숨바꼭질하는 걸 정말 좋아해! 말미잘의 독침에도 끄떡없어서 말미잘 텐트 속에 숨어 살며 서로 도와주는 친한 친구란다. 하얀 줄무늬가 세 개 그려진 바다의 귀염둥이인 이 작은 물고기는 누구일까요?",
    answer: "흰동가리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Amphiprion_clarkii_1.jpg/500px-Amphiprion_clarkii_1.jpg",
  },
  {
    id: "fish_marine031", category: "fish_marine", difficulty: "easy",
    question: "차가운 바닷속을 미끄러지듯 헤엄치는 매끄러운 몸과 큰 눈을 가진 바다의 강아지야! 앞다리가 지느러미처럼 변해서 물속에서는 아주 빠르지만 땅 위에서는 엉금엉금 배로 기어다닌단다. 귀여운 콧수염이 나 있고 매끈한 은빛 털을 가진 이 친구는 누구일까요?",
    answer: "바다표범",
  },
  {
    id: "fish_marine032", category: "fish_marine", difficulty: "medium",
    question: "할아버지처럼 긴 수염이 나 있고 입 밖으로 커다란 송곳니가 두 개 삐죽 나와 있어! 두꺼운 지방층 덕분에 꽁꽁 얼어붙은 얼음 위에서도 춥지 않게 잘 지낼 수 있단다. 덩치가 코끼리처럼 아주 커서 바다 위 얼음을 쿵쿵 밟고 다니는 이 친구는 누구일까요?",
    answer: "바다코끼리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Pacific_Walrus_-_Bull_%288247646168%29.jpg/500px-Pacific_Walrus_-_Bull_%288247646168%29.jpg",
  },
  {
    id: "fish_marine033", category: "fish_marine", difficulty: "easy",
    question: "등에는 푸른 줄무늬가 그려져 있고 배는 눈부시게 하얀색인, 바다의 아주 흔한 친구야! 수천 마리씩 떼를 지어 다니며 여행을 하고, 우리 몸에 좋은 영양분이 가득 들어있어 반찬으로도 인기가 많단다. 구워 먹어도 조려 먹어도 맛있는 이 국민 물고기는 무엇일까요?",
    answer: "고등어",
  },
  {
    id: "fish_marine034", category: "fish_marine", difficulty: "medium",
    question: "몸이 둥그란 달처럼 생겼는데 꼬리 지느러미가 거의 없어서 아주 느릿느릿 헤엄치는 잠꾸러기야! 덩치는 집채만큼 크지만 성격이 아주 온순해서 바다 위를 둥둥 떠다니며 일광욕하는 걸 좋아한단다. 이름처럼 해를 닮은 둥근 이 독특한 물고기는 누구일까요?",
    answer: "개복치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Sunfish2.jpg/500px-Sunfish2.jpg",
  },
  {
    id: "fish_marine035", category: "fish_marine", difficulty: "easy",
    question: "머리에 낚싯대 같은 긴 가시가 달려 있고 그 끝에서 반짝반짝 빛이 나는 신기한 친구야! 컴컴한 깊은 바다 속에서 이 빛으로 작은 물고기들을 유혹해서 커다란 입으로 꿀꺽 삼킨단다. 이빨이 아주 많고 얼굴이 조금 무섭게 생긴 이 심해 사냥꾼은 누구일까요?",
    answer: "아귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Chaunax_stigmaeus_dorsal_view2.jpg/500px-Chaunax_stigmaeus_dorsal_view2.jpg",
  },
  {
    id: "fish_marine036", category: "fish_marine", difficulty: "medium",
    question: "길쭉한 화살처럼 생겨서 물속을 아주 날카롭고 빠르게 헤엄쳐 다니는 무서운 칼잡이야! 입이 아주 크고 뾰족한 이빨이 가득해서 바다의 늑대라고 불릴 정도로 사나운 사냥꾼이기도 하지. 떼를 지어 순식간에 지나가는 이 날렵한 물고기는 무엇일까요?",
    answer: "꼬치고기",
  },
  {
    id: "fish_marine037", category: "fish_marine", difficulty: "easy",
    question: "물속에서 헤엄치다 날개 같은 지느러미를 활짝 펴고 물 위로 슝~ 하고 날아올라! 적이 나타나면 물 위를 100미터 넘게 쌩쌩 날아다니며 멋지게 도망을 친단다. 하늘을 날고 싶어 하는 꿈을 가진 것처럼 보이는 이 신기한 물고기는 무엇일까요?",
    answer: "날치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Pink-wing_flying_fish.jpg/500px-Pink-wing_flying_fish.jpg",
  },
  {
    id: "fish_marine038", category: "fish_marine", difficulty: "medium",
    question: "머리 모양이 T자 모양으로 넓적하게 생겨서 꼭 목공 도구인 망치를 닮았어! 눈이 양옆 끝에 달려 있어서 물속을 넓게 살펴볼 수 있고 먹이를 아주 잘 찾아내지. 독특한 머리 모양 때문에 멀리서도 금방 알아볼 수 있는 이 상어는 누구일까요?",
    answer: "망치상어",
  },
  {
    id: "fish_marine039", category: "fish_marine", difficulty: "easy",
    question: "지구에서 몸집이 가장 큰 상어지만, 성격은 아주 온순해서 사람과도 친구가 될 수 있어! 입을 크게 벌려 아주 작은 플랑크톤을 걸러 먹고 살며 몸에 예쁜 흰색 점무늬가 가득하단다. 바다의 평화로운 거대 친구인 이 상어는 누구일까요?",
    answer: "고래상어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Whale_shark_Georgia_aquarium.jpg/500px-Whale_shark_Georgia_aquarium.jpg",
  },
  {
    id: "fish_marine040", category: "fish_marine", difficulty: "medium",
    question: "온몸이 눈처럼 하얀색이고 이마가 뽀록하게 튀어나온 아주 귀여운 미소 천사야! 바다의 카나리아라고 불릴 정도로 아름답고 다양한 소리를 내어 친구들과 대화를 나눈단다. 사람을 아주 좋아하고 장난치기를 즐기는 이 하얀 고래는 누구일까요?",
    answer: "벨루가",
  },
  {
    id: "fish_marine041", category: "fish_marine", difficulty: "medium",
    question: "바다의 호랑이라 불리는 가장 힘센 포식자로, 검은색 몸에 하얀색 눈 사탕 같은 무늬가 아주 멋져! 머리가 엄청 좋아서 가족들과 힘을 합쳐 똑똑하게 사냥을 한단다. 커다란 등지느러미를 꼿꼿이 세우고 물 위로 점프하는 모습이 정말 위엄 넘치는 이 바다의 왕은 누구일까요?",
    answer: "범고래",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Killerwhales_jumping.jpg/500px-37/Killerwhales_jumping.jpg",
  },
  {
    id: "fish_marine042", category: "fish_marine", difficulty: "easy",
    question: "물속에 사는 커다랗고 순한 소처럼 생겨서 '바다소'라고도 불리는 느긋한 친구야! 강이나 얕은 바다의 바닥에서 살랑살랑 헤엄치며 맛있는 수초를 뜯어 먹고 지낸단다. 꼬리 지느러미가 둥근 부채 모양이고, 사람을 무서워하지 않는 아주 착한 이 거대 동물은 누구일까요?",
    answer: "매너티",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Manatee_photo.jpg/500px-Manatee_photo.jpg",
  },
  {
    id: "fish_marine043", category: "fish_marine", difficulty: "medium",
    question: "주둥이가 날카로운 칼이나 창처럼 길게 뻗어 있는 바다의 용감한 검객이야! 물속에서 엄청나게 빠른 속도로 헤엄치며 이 긴 주둥이로 먹이를 사냥하기도 한단다. 온몸이 푸른 은빛으로 빛나고 성격이 아주 급해서 '바다의 폭주족'이라는 별명도 있는 이 물고기는 누구일까요?",
    answer: "청새치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Stripe_marlin_right_off_the_coast_of_Carrillo.jpg/500px-Stripe_marlin_right_off_the_coast_of_Carrillo.jpg",
  },
  {
    id: "fish_marine044", category: "fish_marine", difficulty: "easy",
    question: "바다 밑 모래 바닥에서 꼼지락꼼지락 기어 다니는, 오이나 소시지처럼 길쭉하게 생긴 생물이야! 건드리면 몸을 꽉 오므리거나 내장을 퉤 뱉어서 도망가는 아주 신기한 방어 기술을 가졌단다. 몸 전체가 울퉁불퉁하고 말랑말랑해서 바다의 청소부라고도 불리는 이 친구는 누구일까요?",
    answer: "해삼",
  },
  {
    id: "fish_marine045", category: "fish_marine", difficulty: "medium",
    question: "까만색 밤송이가 바닷속에 퐁당 빠진 것 같은 모양을 하고 있어! 온몸에 돋아난 길고 뾰족한 가시들은 적으로부터 몸을 지켜주는 아주 튼튼한 가시 갑옷이란다. 바위 사이에 꼭 붙어서 미역이나 다시마 같은 바다 풀을 맛있게 갉아 먹고 사는 이 친구는 무엇일까요?",
    answer: "성게",
  },
  {
    id: "fish_marine046", category: "fish_marine", difficulty: "easy",
    question: "바닷속 바위 틈에 숨어서 커다란 집게발을 흔들고 있는 아주 튼튼한 바다의 기사야! 꼬리를 탁탁 치며 뒤로 빠르게 헤엄칠 수 있고, 몸 전체가 아주 단단한 껍질로 덮여 있단다. 빨간색으로 변하면 정말 맛있어 보여서 많은 사람이 좋아하는 이 커다란 갑각류는 누구일까요?",
    answer: "바닷가재",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Bugre_americanu.jpg",
  },
  {
    id: "fish_marine047", category: "fish_marine", difficulty: "medium",
    question: "은빛 칼처럼 길쭉하고 매끄러운 몸을 뽐내며 깊은 바닷속을 헤엄치는 멋쟁이야! 비늘이 하나도 없어서 반짝반짝 빛이 나고, 밤에는 거울처럼 주변을 비추기도 한단다. 주둥이가 뾰족하고 성격이 아주 예민하지만, 구워 먹으면 살이 사르르 녹는 이 물고기는 무엇일까요?",
    answer: "갈치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Trichiurus_lepturus_by_OpenCage.jpg/500px-Trichiurus_lepturus_by_OpenCage.jpg",
  },
  {
    id: "fish_marine048", category: "fish_marine", difficulty: "easy",
    question: "검지 손가락보다 작은 몸집을 가졌지만 바다에서 엄청나게 큰 떼를 지어 노래하며 다녀! 어두운 밤바다에서도 은색 비늘이 반짝반짝 빛나고, 고래나 갈매기들의 아주 훌륭한 식사가 되어준단다. 볶음 반찬으로 우리가 정말 자주 먹는 영양 만점 이 작은 친구는 누구일까요?",
    answer: "멸치",
  },
  {
    id: "fish_marine049", category: "fish_marine", difficulty: "medium",
    question: "입이 어른 주먹보다 훨씬 크게 벙긋벙긋 열리는, 차가운 바다를 좋아하는 물고기야! 주둥이 아래에 아주 짧은 수염이 하나 달려 있고, 몸 전체에 예쁜 얼룩무늬가 그려져 있단다. 탕으로 끓이면 국물이 시원해서 아빠들이 아주 좋아하시는 이 듬직한 물고기는 누구일까요?",
    answer: "대구",
  },
  {
    id: "fish_marine050", category: "fish_marine", difficulty: "medium",
    question: "바닷속 모래 구멍 속에 쏙 들어가서 얼굴만 빼꼼히 내밀고 바람에 흔들리는 꽃처럼 지내! 수천 마리가 함께 모여 있으면 꼭 바닷속에 정원이 생긴 것 같아서 '정원 장어'라고도 불린단다. 적이 나타나면 순식간에 구멍 속으로 쏙~ 하고 숨어버리는 이 부끄럼쟁이 친구는 누구일까요?",
    answer: "정원장어",
    customOptions: ["정원장어", "해마", "실고기"],
  },
  {
    id: "fish_marine051", category: "fish_marine", difficulty: "easy",
    question: "지구에서 가장 커다란 거북이로, 등에 딱딱한 껍질 대신 가죽처럼 부드러운 피부를 가졌어! 발이 아주 넓은 노처럼 생겨서 먼 바다를 아주 빠르게 헤엄쳐 다닐 수 있단다. 해파리를 가장 좋아해서 많이 먹고 살며 아주 깊은 바다까지 잠수할 수 있는 이 거북 왕은 누구일까요?",
    answer: "장수거북",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Leatherback_sea_turtle_Tinglar%2C_USVI_%285839996547%29.jpg/500px-Leatherback_sea_turtle_Tinglar%2C_USVI_%285839996547%29.jpg",
  },
  {
    id: "fish_marine052", category: "fish_marine", difficulty: "medium",
    question: "하늘하늘한 리본을 닮은 몸을 가졌으며, 자라면서 몸의 색깔이 노란색에서 파란색으로 변하는 신비한 물고기야! 입을 크게 벙긋거리며 숨어 있다가 먹이가 오면 슉! 하고 튀어나온단다. 바닷속에서 춤을 추는 것 같은 아름다운 모습 때문에 '바다의 요정'이라고도 불리는 이 친구는 누구일까요?",
    answer: "리본장어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Blue_ribbon_Eel_fish_on_Pom_Pom_Island%2C_Celebes_resort%2C_Sabah.jpg/500px-Blue_ribbon_Eel_fish_on_Pom_Pom_Island%2C_Celebes_resort%2C_Sabah.jpg",
  },
  {
    id: "fish_marine053", category: "fish_marine", difficulty: "easy",
    question: "바닷속 바위 위에서 화려한 꽃잎처럼 촉수를 살랑살랑 흔들고 있는 바다의 꽃이야! 겉보기엔 정말 예쁘지만 촉수에는 무서운 독침이 숨겨져 있어 조심해야 한단다. 흰동가리와는 아주 친한 단짝 친구라서 서로 지켜주며 행복하게 사는 이 식물 닮은 동물은 무엇일까요?",
    answer: "말미잘",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Haeckel_Actiniae.jpg/500px-Haeckel_Actiniae.jpg",
  },
  {
    id: "fish_marine054", category: "fish_marine", difficulty: "medium",
    question: "나비처럼 넓은 지느러미에 알록달록 화려한 그림이 그려져 있는 바다의 패셔니스타야! 입이 작고 뾰족해서 산호 틈새에 있는 작은 먹이들을 쏙쏙 잘 찾아 먹는단다. 산호초 사이를 우아하게 날아다니는 모습이 꼭 꽃밭 위의 나비 같아서 이름 붙여진 이 예쁜 물고기는 누구일까요?",
    answer: "나비고기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Oriental_butterflyfish.jpg/500px-Oriental_butterflyfish.jpg",
  },
  {
    id: "fish_marine055", category: "fish_marine", difficulty: "easy",
    question: "머리 위에 혹부리 영감처럼 뽈록한 혹이 솟아나 있는 아주 독특하고 개성 넘치는 친구야! 어릴 때는 평범하지만 자라면서 이 커다란 혹이 생기고 턱도 튼튼해져서 딱딱한 조개도 잘 씹어 먹는단다. 바다의 대장처럼 듬직하고 멋진 이마를 가진 이 물고기는 누구일까요?",
    answer: "혹돔",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Semicossyphus_reticulatus.jpg/500px-Semicossyphus_reticulatus.jpg",
  },
  {
    id: "fish_marine056", category: "fish_marine", difficulty: "medium",
    question: "몸 전체가 초록색 잎사귀처럼 생겨서 바다 풀 사이에 숨으면 아무도 찾을 수 없는 변신의 달인이야! 지느러미 하나하나가 나뭇잎처럼 팔랑팔랑 흔들려서 꼭 물에 떠다니는 풀 조각처럼 보인단다. 바닷속 숲을 지키는 작고 신비로운 용처럼 생긴 이 친구는 누구일까요?",
    answer: "나뭇잎해룡",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Leafy_Seadragon_on_Kangaroo_Island.jpg/500px-Leafy_Seadragon_on_Kangaroo_Island.jpg",
  },
  {
    id: "fish_marine057", category: "fish_marine", difficulty: "easy",
    question: "아기 때는 눈처럼 하얗고 보들보들한 털을 가졌지만 커가면서 예쁜 무늬가 생기는 귀염둥이야! 얼음 위를 배로 슥슥 미끄러지며 이동하고 차가운 물속에서도 아주 즐겁게 수영을 한단다. 동그랗고 까만 눈이 보석처럼 반짝이는 얼음 나라의 귀여운 이 친구는 누구일까요?",
    answer: "하프물범",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Blanchon-idlm2006.jpg/500px-Blanchon-idlm2006.jpg",
  },
  {
    id: "fish_marine058", category: "fish_marine", difficulty: "medium",
    question: "몸 주위에 화려한 부채 같은 지느러미를 펴고 바다를 유유히 헤엄치는 바다의 사자 같은 친구야! 줄무늬 무늬가 아주 강렬하고 멋지지만, 지느러미 끝에는 아주 무서운 독침이 있어서 절대 만지면 안 된단다. 우아한 모습 속에 비밀 무기를 숨긴 이 화려한 물고기는 누구일까요?",
    answer: "쏠배감펭",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Lion_Fish_Rensai_Park_Aquarium%2C_Tokyo.jpg/500px-51/Lion_Fish_Rensai_Park_Aquarium%2C_Tokyo.jpg",
  },
  {
    id: "fish_marine059", category: "fish_marine", difficulty: "easy",
    question: "갯벌 위를 지느러미 다리로 엉금엉금 기어 다니기도 하고 껑충껑충 뛰어다니기도 하는 재주꾼이야! 눈이 머리 위에 뽈록 튀어나와 있어서 주변을 아주 잘 살피고 먹이를 낚아챈단다. 물 밖에서도 피부로 숨을 쉴 수 있어서 육지와 바다를 오가는 이 신기한 물고기는 누구일까요?",
    answer: "짱뚱어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Bluespotted_mud_hopper.jpg/500px-Bluespotted_mud_hopper.jpg",
  },
  {
    id: "fish_marine060", category: "fish_marine", difficulty: "medium",
    question: "등에 달린 거대한 지느러미가 혹처럼 뽈록해서 이름 붙여진, 아주 상냥하고 노래 부르기를 좋아하는 거인이야! 공중으로 높이 점프해서 바다 위로 펑! 하고 떨어지는 모습이 정말 장관이란다. 전 세계 바다를 여행하며 가족들과 대화를 나누는 따뜻한 마음을 가진 이 고래는 누구일까요?",
    answer: "혹등고래",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Humpback_Whale_underwater_shot.jpg/500px-Humpback_Whale_underwater_shot.jpg",
  },
  // Animals Quiz Continued (Total 60 for Animals)
  // Animals Quiz (60 questions)
  {
    id: "animals001", category: "animals", difficulty: "easy",
    question: "멋진 갈기를 목에 두르고 '어흥!' 하고 크게 포효하는 동물의 왕이야! 황금빛 털을 가졌으며 아프리카 사바나 평원에서 가족들과 함께 무리 지어 살지. 햇볕 아래서 낮잠 자는 걸 좋아하지만 사냥할 때는 누구보다 용감한 이 들판의 대장은 누구일까요?",
    answer: "사자",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/020_The_lion_king_Snyggve_in_the_Serengeti_National_Park_Photo_by_Giles_Laurent.jpg/500px-a6/020_The_lion_king_Snyggve_in_the_Serengeti_National_Park_Photo_by_Giles_Laurent.jpg",
  },
  {
    id: "animals002", category: "animals", difficulty: "easy",
    question: "목이 아주아주 길어서 높은 나무 꼭대기에 있는 맛있는 잎사귀도 냠냠 잘 먹어! 몸에는 예쁜 갈색 얼룩무늬가 있고, 다리가 길어서 성큼성큼 멋지게 걷는단다. 혀가 아주 길고 튼튼해서 가시 돋친 가지도 잘 먹는 세 상에서 가장 키가 큰 이 친구는 누구일까요?",
    answer: "기린",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Giraffen.jpg/500px-Giraffen.jpg",
  },
  {
    id: "animals003", category: "animals", difficulty: "easy",
    question: "코가 손인 것처럼 아주 길어서 물을 뿜거나 음식을 집어 먹을 수 있는 듬직한 거인이야! 커다란 귀를 부채처럼 파닥거리며 몸을 식히고, 이빨인 상아가 입 밖으로 멋지게 뻗어 있단다. 덩치는 산만큼 크지만 친구를 아주 아끼고 영리한 이 회색빛 동물은 누구일까요?",
    answer: "코끼리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Elephant_near_ndutu.jpg/500px-Elephant_near_ndutu.jpg",
  },
  {
    id: "animals004", category: "animals", difficulty: "easy",
    question: "하얀색 바탕에 검은색 줄무늬 옷을 멋지게 차려입은 들판의 패셔니스타야! 말처럼 생겼지만 길들여지지 않는 야생의 용기를 가졌고, 무리 지어 다니며 사자로부터 서로를 지켜준단다. 줄무늬 모양이 사람의 지문처럼 저마다 다 다른 이 신기한 동물은 누구일까요?",
    answer: "얼룩말",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Zebra_Kruger.jpg/500px-Zebra_Kruger.jpg",
  },
  {
    id: "animals005", category: "animals", difficulty: "medium",
    question: "개와 닮았지만 '키득키득' 웃는 것 같은 희한한 울음소리를 내는 밤의 사냥꾼이야! 앞다리가 뒷다리보다 길어서 걸음걸이가 독특하고, 뼈까지 씹어 먹을 수 있는 아주 강력한 턱을 가졌단다. 무리 지어 다니며 영리하게 먹이를 찾는 사바나의 청소부인 이 동물은 누구일까요?",
    answer: "하이에나",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/b/be/Crocuta-hejda.jpg",
  },
  {
    id: "animals006", category: "animals", difficulty: "easy",
    question: "눈 주위가 까맣고 몸은 하얀, 털이 보들보들한 곰의 친구야! 하루 종일 아삭아삭 맛있는 대나무를 먹는 걸 가장 좋아하고 나무 위에서 잠자는 것도 즐긴단다. 굴러다니는 공처럼 동글동글 귀여운 모습으로 많은 사랑을 받는 이 동물은 누구일까요?",
    answer: "판다",
  },
  {
    id: "animals007", category: "animals", difficulty: "easy",
    question: "주황색 털에 검은색 줄무늬가 빽빽하게 그려진 용맹한 산 속의 왕이야! 깊은 숲이나 높은 산에 혼자 살며 사냥을 하고, 물속에서 수영하는 것도 아주 좋아한단다. '어흥!' 하고 소리 지르면 온 산이 쩌렁쩌렁 울리는 이 힘센 동물은 누구일까요?",
    answer: "호랑이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Siberian_Tiger_by_Malene_Th.jpg/500px-Siberian_Tiger_by_Malene_Th.jpg",
  },
  {
    id: "animals008", category: "animals", difficulty: "easy",
    question: "나무와 나무 사이를 휙휙 건너뛰며 장난치는 걸 정말 좋아하는 장난꾸러기야! 긴 꼬리로 나뭇가지를 꽉 잡을 수 있고, 노란 바나나를 제일 맛있게 먹는단다. 사람과 닮은 손가락으로 털을 골라주며 사이좋게 지내는 이 영리한 친구는 누구일까요?",
    answer: "원숭이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Cebus_albifrons_edit.jpg/500px-64/Cebus_albifrons_edit.jpg",
  },
  {
    id: "animals009", category: "animals", difficulty: "medium",
    question: "다리는 하나도 없지만 몸 전체를 구불구불 움직여서 어디든 기어갈 수 있는 친구야! 혀를 날름날름하며 냄새를 맡고, 허물을 벗으면서 쑥쑥 자라나는 신기한 몸을 가졌단다. 소리 없이 풀숲을 지나다니는 매끄러운 피부의 이 바닥 친구는 누구일까요?",
    answer: "뱀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Snakes_Diversity.jpg/500px-Snakes_Diversity.jpg",
  },
  {
    id: "animals010", category: "animals", difficulty: "medium",
    question: "입이 아주 길쭉하고 날카로운 이빨이 가득한 무시무시한 물속 사냥꾼이야! 땅 위에서도 엉금엉금 잘 걷고 물속에서는 꼬리를 흔들며 아주 빠르게 수영할 수 있단다. 몸 전체가 딱딱한 비늘 갑옷으로 덮여 있는 이 공룡을 닮은 무서운 동물은 누구일까요?",
    answer: "악어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Crocodilia_montage.jpg/500px-Crocodilia_montage.jpg",
  },
  {
    id: "animals011", category: "animals", difficulty: "easy",
    question: "귀가 하늘 높이 쫑긋 솟아 있고 동그랗고 까만 눈을 가진 평화로운 친구야! 뒷다리가 아주 튼튼해서 깡충깡충 높이 뛸 수 있고 보들보들한 털을 가졌단다. 주황색 당근과 싱싱한 풀을 무척 좋아하는 이 겁 많은 귀요미는 누구일까요?",
    answer: "토끼",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Arctic_Hare.jpg/500px-Arctic_Hare.jpg",
  },
  {
    id: "animals012", category: "animals", difficulty: "easy",
    question: "등에 예쁜 줄무늬가 있고 꼬리를 살랑거리며 나무 위를 쌩쌩 달리는 작은 친구야! 볼을 빵빵하게 만들 정도로 도토리를 가득 물어다가 땅속 비밀 창고에 숨겨둔단다. 아주 부지런하고 눈이 똘망똘망한 이 숲속의 요리사는 누구 일까요?",
    answer: "다람쥐",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Streifenhoernchen.jpg/500px-Streifenhoernchen.jpg",
  },
  {
    id: "animals013", category: "animals", difficulty: "easy",
    question: "붉은색 탐스러운 털과 풍성한 꼬리를 살랑이며 산책하는 아주 영리한 친구야! 귀가 쫑긋 솟아 있고 코가 뾰족해서 냄새를 아주 잘 맡으며 숨바꼭질의 달인이란다. 동화책 속에서 지혜로운 꾀돌이로 자주 등장하는 이 멋진 동물은 누구일까요?",
    answer: "여우",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Vulpes_vulpes_laying_in_snow.jpg/500px-Vulpes_vulpes_laying_in_snow.jpg",
  },
  {
    id: "animals014", category: "animals", difficulty: "easy",
    question: "몸집이 아주 크고 힘이 센 듬직한 대장님인데, 겨울이 오면 동굴이나 굴속에서 쿨쿨 잠을 자! 털이 복슬복슬하고 때로는 꿀을 따 먹으러 나무에 오르기도 하는 장난꾸러기 같은 면도 있단다. 큰 발바닥으로 강물을 찰랑이며 연어를 낚아채는 이 동물은 누구일까요?",
    answer: "곰",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Ours_brown_parcanimalierpyrenees_1.jpg/500px-9e/Ours_brun_parcanimalierpyrenees_1.jpg",
  },
  {
    id: "animals015", category: "animals", difficulty: "easy",
    question: "수컷의 머리 위에 멋진 나뭇가지 모양의 뿔이 쑥쑥 솟아나 있는 숲속의 신사야! 다리가 가늘고 길어서 아주 우아하게 껑충껑충 잘 뛰고 겁이 많아서 귀를 쫑긋거리며 살핀단다. 예쁜 무늬와 맑은 눈망울을 가진 이 착한 풀보 보는 누구일까요?",
    answer: "사슴",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Red_deer_stag_2009_denmark.jpg/500px-Red_deer_stag_2009_denmark.jpg",
  },
  {
    id: "animals016", category: "animals", difficulty: "medium",
    question: "몸이 엄청나게 크고 무거워서 물속에서 둥둥 떠 있는 걸 가장 좋아하는 수영 박사야! 입을 세상에서 가장 크게 '아~' 하고 벌릴 수 있고, 분홍색 땀을 흘리는 신기한 능력도 가졌단다. 겉보기엔 온순해 보여도 아주 힘이 세고 용감한 이 바다소 친구는 누구일까요?",
    answer: "하마",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Portrait_Hippopotamus_in_the_water.jpg/500px-f2/Portrait_Hippopotamus_in_the_water.jpg",
  },
  {
    id: "animals017", category: "animals", difficulty: "medium",
    question: "등에 뽈록한 혹이 있어서 뜨거운 사막에서도 며칠 동안 물 없이 잘 견딜 수 있어! 발바닥이 넓고 푹신해서 뜨거운 모래 위를 아주 잘 걷고 눈썹이 길어서 모래바람도 잘 막아준단다. 사람의 짐을 싣고 끝없는 모래 언덕을 여행하는 이 사막의 배는 누구일까요?",
    answer: "낙타",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/07._Camel_Profile%2C_near_Silverton%2C_NSW%2C_07.07.2007.jpg/500px-43/07._Camel_Profile%2C_near_Silverton%2C_NSW%2C_07.07.2007.jpg",
  },
  {
    id: "animals018", category: "animals", difficulty: "easy",
    question: "검은 코트와 하얀 셔츠를 입은 것처럼 생긴 남극의 멋쟁이 신사 물리치료사야! 날개가 있지만 하늘을 날지 못하는 대신, 얼음 물 위를 펭귄처럼 슝슝 잘 헤엄쳐 다닌단다. 아장아장 걷는 모습이 정말 귀엽고 배로 얼음을 미끄러져 내려가는 이 친구는 누구일까요?",
    answer: "펭귄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg/500px-a3/Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg",
  },
  {
    id: "animals019", category: "animals", difficulty: "easy",
    question: "해가 지고 컴컴한 밤이 되면 큰 눈을 번쩍이며 사냥을 시작하는 밤의 파수꾼이야! 목을 휙휙 뒤집어서 뒤쪽까지 다 볼 수 있는 아주 유연한 목을 가졌으며 발톱이 엄청 날카롭단다. 머리에 깃털이 뿔처럼 쫑긋 솟아나 있는 이 지혜로운 새는 누구일까요?",
    answer: "부엉이",
  },
  {
    id: "animals020", category: "animals", difficulty: "easy",
    question: "햄스터처럼 작고 통통하지만 꼬리가 없는 아주 보들보들하고 귀여운 친구야! '꾸잉꾸잉' 하고 소리를 내며 말을 걸기도 하고, 야채와 과일을 아삭아삭 맛있게 먹는단다. 성격이 아주 온순해서 우리들의 소중한 애완동물이 되어주는 이 친구는 누구일까요?",
    answer: "기니피그",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Two_adult_Guinea_Pigs_%28Cavia_porcellus%29.jpg/500px-00/Two_adult_Guinea_Pigs_%28Cavia_porcellus%29.jpg",
  },
  {
    id: "animals021", category: "animals", difficulty: "easy",
    question: "꼬리를 살랑살랑 흔들며 '멍멍!' 소리로 우리를 반겨주는 사람의 가장 친한 친구야! 후각이 아주 발달해서 냄새를 정말 잘 맡고, 우리가 슬플 때는 곁에서 위로해주기도 하는 마음 따뜻한 친구지. 집도 잘 지키고 공놀이하는 것도 정말 좋아하는 이 귀여운 동물은 누구일까요?",
    answer: "강아지",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Golde33443.jpg/500px-Golde33443.jpg",
  },
  {
    id: "animals022", category: "animals", difficulty: "easy",
    question: "하늘 높이 쓩쓩 날아다니며 아주 먼 곳까지 볼 수 있는 밝은 눈을 가진 새들의 왕이야! 날카로운 부리와 튼튼한 발톱으로 사냥을 아주 잘 하고, 산 꼭대기 높은 곳에 둥지를 틀고 산단다. 바람을 타고 우아하게 날개짓하는 이 용맹하고 멋진 새는 누구일까요?",
    answer: "독수리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Aegypius_monachus.jpg/500px-Aegypius_monachus.jpg",
  },
  {
    id: "animals023", category: "animals", difficulty: "easy",
    question: "눈처럼 하얗고 보들보들한 털을 가졌으며 추운 북극 얼음 나라에 사는 세상에서 가장 큰 곰이야! 발바닥에 털이 있어서 미끄러운 얼음 위도 잘 걷고, 물속에서 수영도 잠수도 아주 수준급으로 잘 한단다. 까만 코가 매력적인 이 거대하고 튼튼한 하얀 친구는 누구일까요?",
    answer: "북극곰",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Polarb%C3%A4r_12_2004-11-17.jpg/500px-Polarb%C3%A4r_12_2004-11-17.jpg",
  },
  {
    id: "animals024", category: "animals", difficulty: "medium",
    question: "세상에서 가장 느릿느릿 움직이며 하루의 대부분을 나무에 매달려 잠자는 잠꾸러기야! 얼굴이 웃는 것처럼 생겨서 보는 사람도 기분이 좋아지고, 아주 가끔 땅으로 내려와 용변을 본단다. 털 사이에 이끼가 자랄 정도로 가만히 있는 걸 좋아하는 이 느림보 친구는 누구일까요?",
    answer: "나무늘보",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Bradypus.jpg/500px-Bradypus.jpg",
  },
  {
    id: "animals025", category: "animals", difficulty: "medium",
    question: "코 위에 아주 단단하고 커다란 뿔이 삐죽 솟아 있는 듬직한 바위 같은 동물이야! 피부가 가죽처럼 아주 두툼하고 튼튼해서 사냥꾼들도 쉽게 덤비지 못하며, 덩치에 비해 달리기 속도가 아주 빠르단다. 콧바람을 씽씽 내뿜는 늠름한 들판의 장군은 누구일까요?",
    answer: "코뿔소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Rhinoceros_in_South_Africa_adjusted.jpg/500px-Rhinoceros_in_South_Africa_adjusted.jpg",
  },
  {
    id: "animals026", category: "animals", difficulty: "easy",
    question: "우리가 매일 마시는 고소하고 맛있는 우유를 짜내어 주는 아주 고마운 농장의 친구야! 하얀색 몸에 검은색 커다란 얼룩무늬가 있고 '음매~' 하고 평화롭게 우는 목소리를 가졌단다. 커다란 눈망울로 여물을 맛있게 씹어 먹는 이 상냥한 동물은 누구일까요?",
    answer: "젖소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Cow_female_black_white.jpg/500px-0c/Cow_female_black_white.jpg",
  },
  {
    id: "animals027", category: "animals", difficulty: "medium",
    question: "등에 날카롭고 뾰족한 가시가 밤송이처럼 가득 돋아 있는 신기한 친구야! 무서운 적이 나타나면 몸을 동글게 말아서 가시 공으로 변신해 자신을 지킨단다. 밤에 주로 활동하며 작은 곤충들을 잡아먹는 귀여우면서도 따끔따끔한 이 동물은 누구일까요?",
    answer: "고슴도치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d1/Erinaceus_amurensis.jpg",
  },
  {
    id: "animals028", category: "animals", difficulty: "easy",
    question: "아침마다 해가 뜨면 '꼬꼬댁 꼬꼬!' 하고 우렁차게 소리쳐 우리를 깨워주는 농장의 알람이야! 머리 위에 빨간 볏이 있고 부리로 땅을 콕콕 찍으며 맛있는 모이를 찾아 먹는단다. 깃털을 살랑거리며 마당을 바쁘게 돌아다니는 이 부지런한 친구는 누구일까요?",
    answer: "닭",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Male_and_female_chicken_sitting_together.jpg/500px-84/Male_and_female_chicken_sitting_together.jpg",
  },
  {
    id: "animals029", category: "animals", difficulty: "medium",
    question: "둥글고 커다란 코와 보들보들한 털을 가진, 인형처럼 귀엽게 생긴 호주의 친구야! 유칼립투스 나뭇잎만 아주 맛있게 먹으며 나무 위에 꼭 매달려 거의 온종일 잠을 잔단다. 아기 코알라를 등에 업고 다니는 상냥하고 느릿한 이 동물은 누구일까요?",
    answer: "코알라",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/A_koala_at_Featherdale_Wildlife_Park_2025_%286%29.jpg/500px-69/A_koala_at_Featherdale_Wildlife_Park_2025_%286%29.jpg",
  },
  {
    id: "animals030", category: "animals", difficulty: "easy",
    question: "조그만 몸집에 동그란 귀를 가졌으며 아주 빠르게 도망치는 도망의 고수야! 수염을 파르르 떨며 맛있는 치즈나 곡식을 찾아 먹고, 구석진 틈새로 쏙쏙 잘 숨어버린단다. '찍찍' 소리를 내며 밤마다 바쁘게 돌아다니는 작고 소심한 이 동물은 누구일까요?",
    answer: "생쥐",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/%D0%94%D0%BE%D0%BC%D0%BE%D0%B2%D0%B0%D1%8F_%D0%BC%D1%8B%D1%88%D1%8C_%28Mus_musculus%29%2C_%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0.jpg/500px-%D0%94%D0%BE%D0%BC%D0%BE%D0%B2%D0%B0%D1%8F_%D0%BC%D1%8B%D1%88%D1%8C_%28Mus_musculus%29%2C_%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0.jpg",
  },
  {
    id: "animals031", category: "animals", difficulty: "easy",
    question: "살랑살랑 꼬리를 흔들며 '야옹!' 하고 귀여운 목소리로 노래하는 우리의 소중한 친구야! 밤에도 밝게 빛나는 신비로운 눈을 가졌으며, 높은 곳도 한 번에 슝~ 하고 뛰어오르는 엄청난 점프력을 가졌단다. 부드러운 털을 쓰다듬어 주면 기분 좋게 가르릉거리는 이 동물은 누구일까요?",
    answer: "고양이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/500px-Cat03.jpg",
  },
  {
    id: "animals032", category: "animals", difficulty: "easy",
    question: "배에 달린 커다란 주머니 속에 아기를 쏙 넣고 다니는 호주의 점프 대왕이야! 튼튼한 뒷다리로 '피융~' 하고 높이 뛰어올라 멀리까지 순식간에 이동할 수 있단다. 꼬리로 중심을 잡고 풀밭을 신나게 누비는 이 용감한 엄마 동물은 누구일까요?",
    answer: "캥거루",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Kangaroo_with_joey_in_pouch.jpg/500px-4e/Kangaroo_with_joey_in_pouch.jpg",
  },
  {
    id: "animals033", category: "animals", difficulty: "medium",
    question: "눈 주위와 귀, 다리만 까만색이고 나머지는 하얀 아주 독특한 옷을 입은 숲의 귀요미야! 대나무 잎을 반찬으로 가장 맛있게 먹고 엉덩이를 씰룩거리며 걷는 모습이 정말 웃음 나게 한단다. 굴러다니는 공처럼 동글동글한 매력을 가진 이 곰의 사촌은 누구일까요?",
    answer: "판다",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Grosser_Panda.JPG/500px-Grosser_Panda.JPG",
  },
  {
    id: "animals034", category: "animals", difficulty: "easy",
    question: "보석 같은 꼬리 날개를 부채처럼 활짝 펴서 뽐내기 좋아하는 새는 누구일까요?",
    answer: "공작",
  },
  {
    id: "animals035", category: "animals", difficulty: "medium",
    question: "진흙 목욕을 좋아하고 숲속에서 아주 용감하게 사냥하는 돌격대장은 누구일까요?",
    answer: "멧돼지",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Locha_i_pasiaki.jpg/500px-Locha_i_pasiaki.jpg",
  },
  {
    id: "animals036", category: "animals", difficulty: "medium",
    question: "머리 위에 길고 튼튼한 뿔이 휘어져 있고, 절벽도 껑충껑충 잘 올라가는 용감한 바위 타기 명수야! 턱밑에 할아버지처럼 긴 수염이 나 있는 게 특징이고 '메에~' 하고 호기심 가득하게 운단다. 어떤 험한 산이라도 끄떡없는 이 튼튼한 친구는 누구일까요?",
    answer: "염소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Hausziege_04.jpg/500px-Hausziege_04.jpg",
  },
  {
    id: "animals037", category: "animals", difficulty: "easy",
    question: "코가 넙적해서 킁킁대며 맛있는 땅속 먹이를 아주 잘 찾아 먹는 먹보 대장이야! 꼬리가 돌돌 말려 있고 '꿀꿀' 하고 기분 좋게 콧노래를 부르며 진흙 목욕 하는 걸 정말 좋아한단다. 우리에게 소중한 고기를 선물해 주는 포동포동 귀여운 이 동물은 누구일까요?",
    answer: "돼지",
  },
  {
    id: "animals038", category: "animals", difficulty: "easy",
    question: "등 위에 안장을 얹고 사람을 태워 넓은 들판을 시원하게 달릴 수 있는 멋쟁이 친구야! '히히힝!' 하고 우렁차게 울고 튼튼한 다리로 흙먼지를 일으키며 아주 빠르게 뛰어간단다. 찰랑거리는 갈기와 긴 꼬리가 정말 아름다운 이 달리기 왕은 누구일까요?",
    answer: "말",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Nokota_Horses_cropped.jpg/500px-Nokota_Horses_cropped.jpg",
  },
  {
    id: "animals039", category: "animals", difficulty: "easy",
    question: "땅속에 터널을 아주 잘 파고 눈이 잘 안 보이지만 코가 발달한 동물은 누구일까요?",
    answer: "두더지",
  },
  {
    id: "animals040", category: "animals", difficulty: "medium",
    question: "사막에 살며 아주 큰 귀를 가지고 있어서 멀리서 나는 소리도 잘 듣는 친구는 누구일까요?",
    answer: "페넥여우",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Fennec_Fox_%40_Africa_Alive%2C_Lowestoft.jpg/500px-Fennec_Fox_%40_Africa_Alive%2C_Lowestoft.jpg",
  },
  {
    id: "animals041", category: "animals", difficulty: "easy",
    question: "나무줄기를 '딱딱딱' 하고 튼튼한 부리로 쪼아서 나무 속에 숨은 벌레를 잡아먹는 숲의 의사 선생님이야! 머리에 빨간 모자를 쓴 것처럼 예쁜 깃털이 있고, 꼬리로 몸을 단단히 지탱하며 나무에 꼭 붙어 있단다. 숲을 건강하게 지켜주는 아주 부지런하고 고마운 이 새는 누구일까요?",
    answer: "딱따구리",
  },
  {
    id: "animals042", category: "animals", difficulty: "medium",
    question: "온몸이 단단한 비늘로 덮여 있어서 적이 나타나면 공처럼 몸을 둥글게 말아 자신을 지키는 신기한 친구야! 이빨이 없는 대신 길고 끈적끈적한 혀를 쑥 내밀어 개미나 흰개미를 아주 맛있게 잡아먹는단다. '살아있는 소나무 열매'라고도 불리는 이 희귀한 동물은 누구일까요?",
    answer: "천산갑",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Manidae.jpg/500px-Manidae.jpg",
  },
  {
    id: "animals043", category: "animals", difficulty: "easy",
    question: "머리부터 발끝까지 까만 정장을 입은 것처럼 까맣고 반짝이는 깃털을 가진 아주 영리한 새야! 반짝이는 물건을 좋아해서 보물찾기하듯 모으기도 하고, 도구를 사용할 줄 알 정도로 머리가 아주 좋단다. '까악까악' 하고 크게 소리 내어 친구를 부르는 이 지혜로운 새는 누구일까요?",
    answer: "까마귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Corvus_corone_104047091.jpg/500px-Corvus_corone_104047091.jpg",
  },
  {
    id: "animals044", category: "animals", difficulty: "easy",
    question: "앞니가 아주 튼튼해서 나무를 갉아 쓰러뜨리고 강물에 멋진 댐을 짓는 바다의 건축가야! 꼬리가 노처럼 넓고 납작해서 물속에서 수영할 때 아주 유용하게 사용한단다. 물속에 아늑한 집을 짓고 가족들과 함께 오순도순 사는 이 부지런한 동물은 누구일까요?",
    answer: "비버",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Beaver.jpg/500px-Beaver.jpg",
  },
  {
    id: "animals045", category: "animals", difficulty: "easy",
    question: "추운 겨울이 오기 전에 따뜻한 남쪽 나라로 수천 킬로미터를 날아가는 아주 용감한 여행가야! 하늘 위에서 'V'자 모양으로 대열을 맞춰 날아가며 서로에게 힘을 북돋아 준단다. '끼룩끼룩' 소리를 내며 긴 여행을 떠나는 아름다운 이 철새는 누구일까요?",
    answer: "기러기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Canada_Goose_Lake_Union.JPG/500px-Canada_Goose_Lake_Union.JPG",
  },
  {
    id: "animals046", category: "animals", difficulty: "easy",
    question: "검은색 코트와 하얀 셔츠를 입은 젠틀맨처럼 생겼지만 아장아장 걷는 모습이 너무 귀여운 친구야! 날개는 있지만 하늘을 날지는 못하고 물속에서 로켓처럼 빠르게 수영할 수 있단다. 추운 남극 얼음 위에서 아기를 소중히 키우는 이 사랑스러운 친구는 누구일까요?",
    answer: "펭귄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg/500px-a3/Aptenodytes_forsteri_-Snow_Hill_Island%2C_Antarctica_-adults_and_juvenile-8.jpg",
  },
  {
    id: "animals047", category: "animals", difficulty: "medium",
    question: "귀 끝에 검은색 긴 털이 쫑긋 솟아 있는 아주 멋지고 신비로운 야생 고양이야! 발바닥이 넓어서 깊은 눈 위에서도 푹푹 빠지지 않고 아주 잘 달릴 수 있단다. 날카로운 눈매와 튼튼한 발톱으로 숲속을 누비는 은밀한 사냥꾼인 이 동물은 누구일까요?",
    answer: "스라소니",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Lynx_lynx2.jpg/500px-Lynx_lynx2.jpg",
  },
  {
    id: "animals048", category: "animals", difficulty: "easy",
    question: "부리가 넓적하고 발가락 사이에 물갈퀴가 있어서 물 위를 두둥실 잘 떠다니는 수영 천재야! '꽥꽥' 하고 노래를 부르며 엉덩이를 씰룩씰룩 흔들며 걷는 모습이 정말 웃음 나게 한단다. 깃털에 기름이 있어서 물에 젖지 않는 이 신기한 물새는 무엇일까요?",
    answer: "오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Anas_platyrhynchos_male_female_quadrat.jpg/500px-Anas_platyrhynchos_male_female_quadrat.jpg",
  },
  {
    id: "animals049", category: "animals", difficulty: "medium",
    question: "지구에서 땅 위를 달리는 동물 중에 가장 빠른 스피드를 자랑하는 레이서야! 얼굴에 눈물 자국 같은 검은 줄무늬가 있고 몸통에는 멋진 점박이 무늬가 빼곡하게 그려져 있단다. 아주 날렵한 몸매로 사바나 초원을 달리는 이 멋진 동물은 누구일까요?",
    answer: "치타",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cheetah_%28Acinonyx_jubatus%29_female_2.jpg/500px-Cheetah_%28Acinonyx_jubatus%29_female_2.jpg",
  },
  {
    id: "animals050", category: "animals", difficulty: "easy",
    question: "몸 전체에 예쁜 꽃 모양의 검은색 점무늬가 가득해서 아주 아름답고 멋진 사냥꾼이야! 나무를 오르는 실력이 대단해서 사냥한 먹이를 나무 위로 끌어올려 혼자 맛있게 먹기도 한단다. '어흥' 소리 내며 숲속을 은밀하게 걸어 다니는 이 멋쟁이 표범 친구는 누구일까요?",
    answer: "표범",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Amur_leopard._Frame_from_a_camera_trap_%28cropped%29.jpg/500px-Amur_leopard._Frame_from_a_camera_trap_%28cropped%29.jpg",
  },
  {
    id: "animals051", category: "animals", difficulty: "easy",
    question: "보슬보슬하고 하얀 털이 솜사탕처럼 온몸을 덮고 있는 아주 순하고 착한 친구야! '매~' 하고 평화롭게 울며 푸른 풀밭에서 친구들과 함께 풀을 뜯어 먹는 걸 좋아한단다. 우리에게 따뜻한 옷을 만들 수 있는 부드러운 양털을 선물해 주는 이 포근한 동물은 누구일까요?",
    answer: "양",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flock_of_sheep.jpg/500px-Flock_of_sheep.jpg",
  },
  {
    id: "animals052", category: "animals", difficulty: "easy",
    question: "코가 납작하고 둥글어서 킁킁대며 맛있는 냄새를 아주 잘 맡는 욕심쟁이 먹보 대장이야! 꼬리가 돌돌 말려 있고 '꿀꿀' 하고 노래하며 진흙 마사지 하는 걸 세상에서 제일 좋아한단다. 포동포동하고 분홍빛 살이 매력적인 이 귀여운 농장 친구는 누구일까요?",
    answer: "돼지",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Sow_with_piglet.jpg/500px-Sow_with_piglet.jpg",
  },
  {
    id: "animals053", category: "animals", difficulty: "medium",
    question: "캥거루와 아주 닮았지만 몸집이 훨씬 작고 귀여운 호주의 숲속 점프 대왕이야! 아기 주머니가 있어서 아기 왈라비를 쏙 넣고 다니며 껑충껑충 덤불 사이를 아주 잘 뛰어다닌단다. 긴 꼬리로 중심을 잡고 풀잎을 냠냠 먹는 이 소중한 친구는 누구일까요?",
    answer: "왈라비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Bennetwallaby.jpg",
  },
  {
    id: "animals054", category: "animals", difficulty: "easy",
    question: "나비와 아주 닮았지만 밤에 주로 활동하며 밝은 불빛을 찾아 날아드는 밤의 요정이야! 날개에 눈동자 같은 무늬가 있기도 하고, 앉아 있을 때 날개를 활짝 펴서 쉬는 특징이 있단다. 더듬이가 빗 모양처럼 화려하고 멋진 이 곤충 친구는 무엇일까요?",
    answer: "나방",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Polyphemus_Moth.jpg/500px-Polyphemus_Moth.jpg",
  },
  {
    id: "animals055", category: "animals", difficulty: "medium",
    question: "코가 코끼리처럼 약간 길쭉해서 자유롭게 움직일 수 있는 아주 신비로운 정글의 친구야! 몸은 돼지처럼 튼튼하고 털은 매끄러워서 빽빽한 풀숲도 슉슉 잘 지나다닌단다. 밤에 활동하며 맛있는 열매나 잎을 찾아 먹는 이 조용하고 듬직한 동물은 누구일까요?",
    answer: "맥",
  },
  {
    id: "animals056", category: "animals", difficulty: "easy",
    question: "몸보다 훨씬 커 보이는 화려한 노란색 부리를 가진 열대 우림의 멋쟁이 패셔니스타야! 부리가 크지만 아주 가벼워서 날아다니는 데 전혀 지장이 없고 과일을 톡톡 따 먹는단다. 커다란 눈망울과 알록달록한 깃털이 정말 아름다운 이 새는 누구일까요?",
    answer: "토코투칸",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Ramphastos_toco.jpg/500px-Ramphastos_toco.jpg",
  },
  {
    id: "animals057", category: "animals", difficulty: "medium",
    question: "바다 사자와 아주 닮았지만 귓바퀴가 쫑긋 나와 있는 것이 특징인 바다의 수영 대장이야! 앞지느러미가 발처럼 튼튼해서 땅 위에서도 엉금엉금 잘 걷고 물속에서는 아주 빠르게 헤엄친단다. 매끄러운 몸매로 바다를 누비는 이 듬직한 바다 동물은 누구일까요?",
    answer: "물개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Northfursealbull.jpg/500px-Northfursealbull.jpg",
  },
  {
    id: "animals058", category: "animals", difficulty: "easy",
    question: "눈 주위에 까만색 안경을 쓴 것 같은 무늬가 있어서 아주 똑똑하고 귀여워 보이는 친구야! 나무를 아주 잘 타고 밤이 되면 바쁘게 먹이를 찾아다니는 부지런한 장난꾸러기란다. 손을 잘 사용해서 음식을 씻어 먹기도 하는 이 영리한 동물은 누구일까요?",
    answer: "너구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Nyctereutes_procyonoides_16072008.jpg/500px-Nyctereutes_procyonoides_16072008.jpg",
  },
  {
    id: "animals059", category: "animals", difficulty: "medium",
    question: "뜨거운 사막에서 뒷다리로 꼿꼿이 서서 주변을 두리번두리번 살피는 용감한 파수꾼이야! 가족들이 밥을 먹는 동안 위험이 오는지 지켜주는 아주 책임감 강한 친구란다. 땅속에 복잡한 터널을 파고 사는 이 작고 귀여운 사막의 요정은 누구일까요?",
    answer: "미어캣",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Suricata.suricatta.6861.jpg/500px-Suricata.suricatta.6861.jpg",
  },
  {
    id: "animals060", category: "animals", difficulty: "easy",
    question: "조그만 몸집에 동그란 귀, 그리고 긴 꼬리를 살랑거리며 아주 빠르게 도망치는 도망의 고수야! 앞니가 쑥쑥 자라나서 무엇이든 '야금야금' 갉아먹는 걸 좋아하고 밤에 몰래 활동한단다. '찍찍' 소리를 내며 구석진 곳에 숨어 사는 작고 소심한 이 친구는 누구일까요?",
    answer: "생쥐",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/%D0%94%D0%BE%D0%BC%D0%BE%D0%B2%D0%B0%D1%8F_%D0%BC%D1%8B%D1%88%D1%8C_%28Mus_musculus%29%2C_%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0.jpg/500px-e5/%D0%94%D0%BE%D0%BC%D0%BE%D0%B2%D0%B0%D1%8F_%D0%BC%D1%8B%D1%88%D1%8C_%28Mus_musculus%29%2C_%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0.jpg",
  },
  // Dinosaurs Quiz (60 questions)
  {
    id: "dinosaurs001", category: "dinosaurs", difficulty: "easy",
    question: "머리에 커다란 뿔이 세 개나 있고 목 뒤에는 멋진 부채 모양의 '프릴'이라는 방패를 가졌어! 코뿔소처럼 듬직한 몸집을 가졌으며 아주 튼튼한 다리로 땅을 딛고 서 있는 초식 공룡의 수호신이란다. 부리처럼 생긴 입으로 풀과 열매를 맛있게 뜯어 먹는 이 삼각뿔 친구는 누구일까요?",
    answer: "트리케라톱스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Triceratops_BW.jpg/500px-Triceratops_BW.jpg",
  },
  {
    id: "dinosaurs002", category: "dinosaurs", difficulty: "easy",
    question: "공룡 세상의 무시무시한 왕으로 불리며, 바나나만큼 커다란 이빨이 입안에 가득해! 발자국 소리만 들어도 땅이 쿵쿵 울릴 정도로 힘이 세고 무엇이든 꽉 깨물 수 있는 강력한 턱을 가졌단다. 앞다리는 조금 짧지만 세상에서 가장 무서운 사냥꾼이었던 이 육식 공룡은 누구일까요?",
    answer: "티라노사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Stan_the_Trex_at_Manchester_Museum.jpg/500px-Stan_the_Trex_at_Manchester_Museum.jpg",
  },
  {
    id: "dinosaurs003", category: "dinosaurs", difficulty: "easy",
    question: "목이 기린보다 훨씬 길어서 아주 높은 나무 꼭대기에 있는 부드러운 잎사귀도 냠냠 잘 먹어! 덩치가 산만큼 커서 걸어 다닐 때마다 땅이 흔들리고 코가 정수리 근처에 뽈록 솟아 있단다. 앞다리가 뒷다리보다 긴 아주 듬직하고 순한 이 거인 공룡은 누구일까요?",
    answer: "브라키오사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Brachiosaurus_BW.jpg/500px-Brachiosaurus_BW.jpg",
  },
  {
    id: "dinosaurs004", category: "dinosaurs", difficulty: "easy",
    question: "등에 오각형 모양의 커다란 골판이 부채처럼 줄지어 솟아 있어 햇빛으로 체온을 조절해! 꼬리 끝에는 무시무시한 가시가 네 개나 달려 있어서 육식 공룡으로부터 몸을 지킨단다. 덩치에 비해 머리는 아주 작지만 정말 멋진 갑옷을 입은 이 초식 공룡은 누구일까요?",
    answer: "스테고사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Journal.pone.0138352.g001A.jpg/500px-Journal.pone.0138352.g001A.jpg",
  },
  {
    id: "dinosaurs005", category: "dinosaurs", difficulty: "medium",
    question: "몸집은 작지만 아주 똑똑하고 날렵해서 '날센 도둑'이라는 뜻의 이름을 가진 공룡이야! 뒷다리에 낫처럼 생긴 날카로운 갈고리 발톱이 있어서 사냥할 때 아주 무서운 무기가 된단다. 친구들과 힘을 합쳐 똑똑하게 사냥을 하던 이 날씬한 육식 공룡은 누구일까요?",
    answer: "벨로키랍토르",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Velociraptor_dinoguy2.jpg/500px-Velociraptor_dinoguy2.jpg",
  },
  {
    id: "dinosaurs006", category: "dinosaurs", difficulty: "medium",
    question: "트리케라톱스와 닮았지만 목 뒤의 프릴이 훨씬 더 크고 멋진 구멍이 숭숭 뚫려 있어! 머리에 세 개의 뿔이 있고 몸집이 아주 튼튼해서 사나운 포식자들도 쉽게 덤비지 못했단다. 숲속을 평화롭게 거닐며 부드러운 가문비나무 잎을 먹던 이 공룡은 누구일까요?",
    answer: "카스모사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Chasmosaurus_BW.jpg/500px-Chasmosaurus_BW.jpg",
  },
  {
    id: "dinosaurs007", category: "dinosaurs", difficulty: "easy",
    question: "지붕처럼 동그랗고 아주 두꺼운 머리뼈를 가져서 '두꺼운 머리 도마뱀'이라는 뜻을 가졌어! 친구들과 머리를 '쾅!' 하고 맞대며 힘겨루기를 하거나 무서운 적을 쫓아내기도 했단다. 머리에 뾰쪽뾰쪽한 돌기들이 왕관처럼 장식된 이 박치기 왕은 누구일까요?",
    answer: "파키케팔로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Pachycephalosaurus_wyomingensis_dinosaur_%28Upper_Cretaceous%3B_Montana%2C_USA%29.jpg/500px-36/Pachycephalosaurus_wyomingensis_dinosaur_%28Upper_Cretaceous%3B_Montana%2C_USA%29.jpg",
  },
  {
    id: "dinosaurs008", category: "dinosaurs", difficulty: "medium",
    question: "온몸이 딱딱한 뼈 갑옷으로 덮여 있고 꼬리 끝에는 커다란 철퇴 같은 뼈 뭉치가 달려 있어! 적이 나타나면 몸을 바닥에 착 붙여서 방어를 하거나 꼬리를 휘둘러 적의 다리를 공격했단다. 둥글둥글 튼튼한 몸을 가진 이 공룡 시대의 탱크는 누구일까요?",
    answer: "안킬로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Ankylosaurus_dinosaur.png/500px-Ankylosaurus_dinosaur.png",
  },
  {
    id: "dinosaurs009", category: "dinosaurs", difficulty: "medium",
    question: "머리 뒤로 아주 길쭉하게 뻗은 신기한 볏을 가졌는데, 이 볏으로 '뿌우~' 하고 나팔 같은 소리를 냈어! 이 소리로 친구들과 대화를 나누거나 위험을 알리며 무리 지어 평화롭게 살았단다. 오리처럼 넓적한 입부리를 가진 이 악기 연주자 공룡은 누구일까요?",
    answer: "파라사우롤로푸스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Parasaurolophus_cyrtocristatus.jpg/500px-Parasaurolophus_cyrtocristatus.jpg",
  },
  {
    id: "dinosaurs010", category: "dinosaurs", difficulty: "easy",
    question: "공룡 시대의 하늘을 지배하던 익룡으로, 박쥐처럼 넓고 튼튼한 날개를 활짝 펴서 날아다녔어! 머리 뒤에는 길쭉한 벼슬이 솟아 있고 부리가 아주 길어서 물고기를 아주 잘 잡아먹었단다. 숲이나 절벽 위에서 살며 바람을 타고 여행하던 이 친구는 누구일까요?",
    answer: "프테라노돈",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Pteranodon_amnh_martyniuk.jpg/500px-Pteranodon_amnh_martyniuk.jpg",
  },
  {
    id: "dinosaurs011", category: "dinosaurs", difficulty: "medium",
    question: "바닷속을 누비던 거대한 해양 파충류로, 악어처럼 긴 입에 날카로운 이빨이 가득 박혀 있어! 꼬리 지느러미가 아주 튼튼해서 물속에서 엄청나게 빠르게 요동치며 사냥을 하던 바다의 왕이란다. 지구상의 바다에서 가장 무서웠던 이 바다 괴물 공룡은 누구일까요?",
    answer: "모사사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Mosasaurus_21copy.jpg/500px-Mosasaurus_21copy.jpg",
  },
  {
    id: "dinosaurs012", category: "dinosaurs", difficulty: "easy",
    question: "등에 커다랗고 멋진 돛 모양의 돌기가 솟아 있는, 공룡 세상에서 가장 덩치가 컸던 육식 공룡이야! 입이 악어처럼 길어서 물속의 물고기를 잡아먹기도 하고 땅 위에서도 사냥을 하던 만능 사냥꾼이었단다. 수영도 아주 잘 해서 '바다의 폭군'이라고도 불리는 이 공룡은 누구일까요?",
    answer: "스피노사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Spinosaurus_aegyptiacus_by_PaleoGeek.png/500px-Spinosaurus_aegyptiacus_by_PaleoGeek.png",
  },
  {
    id: "dinosaurs013", category: "dinosaurs", difficulty: "medium",
    question: "타조처럼 다리가 아주 길어서 공룡 시대의 육상 선수로 불릴 만큼 엄청나게 빨리 달릴 수 있어! 부리가 있고 날씬한 몸을 가졌으며 무리 지어 다니며 알이나 작은 곤충들을 찾아 먹었단다. '닭을 닮은 도마뱀'이라는 뜻의 재미있는 이름을 가진 이 공룡은 누구일까요?",
    answer: "갈리미무스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Gallimimus_2_NHM.JPG/500px-Gallimimus_2_NHM.JPG",
  },
  {
    id: "dinosaurs014", category: "dinosaurs", difficulty: "medium",
    question: "엄지손가락에 아주 날카로운 가시가 삐죽 솟아 있어서 육식 공룡이 나타나면 무기로 사용했어! 앞발로 짚고 걷기도 하고 뒷다리로만 서서 높은 곳의 잎을 먹기도 하는 아주 힘센 초식 공룡이었단다. '이구아나의 이빨'이라는 뜻의 이름을 가진 이 듬직한 공룡은 누구일까요?",
    answer: "이구아노돈",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Iguanodon_Dinopark.jpg/500px-Iguanodon_Dinopark.jpg",
  },
  {
    id: "dinosaurs015", category: "dinosaurs", difficulty: "medium",
    question: "머리 위에 예쁜 부채 모양의 볏이 두 개나 나 있어서 아주 멋진 패셔니스타 같은 육식 공룡이야! 영화에서는 무서운 독을 뿜는 모습으로 나오기도 했지만 실제로는 아주 날렵하고 사나운 사냥꾼이었단다. 턱이 가늘고 목이 길어서 잽싸게 먹이를 낚아채던 이 공룡은 누구일까요?",
    answer: "딜로포사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Dilophosaurus_sinensis_mounts.jpg/500px-Dilophosaurus_sinensis_mounts.jpg",
  },
  {
    id: "dinosaurs016", category: "dinosaurs", difficulty: "easy",
    question: "몸집이 산만큼 거대하고 목과 꼬리가 아주 길어서 '속이는 도마뱀'이라는 뜻의 이름을 가졌어! 발가락에 커다란 갈고리 발톱이 하나 있고 꼬리를 채찍처럼 휘둘러 육식 공룡을 쫓아내기도 했단다. 아주 순하고 듬직하게 숲속을 다니던 이 거인 초식 공룡은 누구일까요?",
    answer: "아파토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Apatosaurus_-_Dinoparque%2C_Pachuca_de_Soto%2C_Hidalgo%2C_M%C3%A9xico.jpg/500px-Apatosaurus_-_Dinoparque%2C_Pachuca_de_Soto%2C_Hidalgo%2C_M%C3%A9xico.jpg",
  },
  {
    id: "dinosaurs017", category: "dinosaurs", difficulty: "medium",
    question: "티라노사우루스가 나타나기 전까지 공룡 세상을 주름잡던 아주 무서운 육식 공룡이야! 눈 위에 작은 볏이 솟아 있고 아주 날카롭고 튼튼한 이빨로 사냥감을 놓치지 않았단다. 지능이 높고 아주 민첩해서 숲속의 사냥꾼으로 통하던 이 무시무시한 공룡은 누구일까요?",
    answer: "알로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/WLA_hmns_Allosaurus.jpg/500px-WLA_hmns_Allosaurus.jpg",
  },
  {
    id: "dinosaurs018", category: "dinosaurs", difficulty: "easy",
    question: "머리 위에 헬멧처럼 생긴 커다랗고 둥근 볏을 가졌는데, 코와 연결되어 있어서 소리를 냈어! 물속에서도 수영을 잘 했을 것으로 추측되며 넓적한 입부리로 수초를 맛있게 뜯어 먹었단다. '투구 도마뱀'이라는 뜻의 이름을 가진 이 지혜로운 공룡은 누구일까요?",
    answer: "코리토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Corythosaurus3.jpg/500px-Corythosaurus3.jpg",
  },
  {
    id: "dinosaurs019", category: "dinosaurs", difficulty: "medium",
    question: "목 뒤의 프릴 가장자리에 긴 가시들이 뿔처럼 삐죽삐죽 솟아 있어서 아주 위엄 넘치는 모습이야! 코 위에는 아주 커다란 뿔 하나가 멋지게 솟아 있고 몸집이 아주 튼튼한 방어의 귀재란다. 트리케라톱스의 친척으로 뿔이 정말 화려한 이 공룡은 누구일까요?",
    answer: "스티라코사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Styracosaurus_dinosaur.png/500px-Styracosaurus_dinosaur.png",
  },
  {
    id: "dinosaurs020", category: "dinosaurs", difficulty: "medium",
    question: "지구상에 살았던 동물 중 목의 길이가 가장 길어서 몸 길이의 절반 이상이 목이었대! 아주 튼튼한 다리로 듬직하게 서서 높은 나무 꼭대기의 잎사귀들을 편안하게 먹고 지냈단다. 꼬리도 아주 길어서 채찍처럼 사용할 수 있었던 이 중국의 거인 공룡은 누구일까요?",
    answer: "마멘키사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Mamenchisaurus_youngi_steveoc_86.jpg/500px-Mamenchisaurus_youngi_steveoc_86.jpg",
  },
  {
    id: "dinosaurs021", category: "dinosaurs", difficulty: "easy",
    question: "공룡과 새의 특징을 모두 가진 아주 신기한 동물로, 날개에 깃털이 있고 입에는 날카로운 이빨이 있었어! 꼬리가 길쭉하고 발가락에는 갈고리 발톱이 달려 있어서 나무도 잘 탔을 것으로 생각된단다. 우리가 아는 예쁜 새들의 아주 먼 할아버지 격인 이 생물은 누구일까요?",
    answer: "시조새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Archaeopteryx_lithographica_%28Berlin_specimen%29.jpg/500px-Archaeopteryx_lithographica_%28Berlin_specimen%29.jpg",
  },
  {
    id: "dinosaurs022", category: "dinosaurs", difficulty: "medium",
    question: "머리에 황소처럼 뾰족한 뿔이 두 개나 나 있는 아주 사나운 '고기 먹는 황소'라는 뜻의 공룡이야! 몸은 울툴불퉁한 돌기로 덮여 있고 앞다리는 티라노사우루스보다도 훨씬 짧아서 거의 보이지도 않는단다. 뒷다리가 아주 튼튼해서 사냥감을 향해 돌진하던 이 공룡은 누구일까요?",
    answer: "카르노타우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Carnotaurus%2C_Chlup%C3%A1%C4%8D_Museum%2C_Prague-2.jpg/500px-c/cc/Carnotaurus%2C_Chlup%C3%A1%C4%8D_Museum%2C_Prague-2.jpg",
  },
  {
    id: "dinosaurs023", category: "dinosaurs", difficulty: "easy",
    question: "스테고사우루스처럼 등에 골판이 있지만, 꼬리 쪽으로 갈수록 골판이 길고 날카로운 가시로 변하는 공룡이야! 꼬리 끝에 네 개의 아주 튼튼한 가시가 있어서 육식 공룡을 물리치는 강력한 무기로 사용했단다. 몸집은 조금 작지만 방어력은 최고였던 이 뾰족 가시 공룡은 누구일까요?",
    answer: "켄트로사우루스",
  },
  {
    id: "dinosaurs024", category: "dinosaurs", difficulty: "medium",
    question: "세상에서 가장 긴 손발톱을 가졌는데, 그 모양이 커다란 낫처럼 생겨서 아주 무시무시해 보여! 하지만 무서운 모습과 달리 나무 위의 부드러운 잎을 따 먹는 순한 초식 공룡이었을 것으로 추측된단다. 배가 뽈록 튀어나오고 깃털이 있었을지도 모르는 이 신기한 공룡은 누구일까요?",
    answer: "테리지노사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Therizinosaurus_Restoration.png/500px-Therizinosaurus_Restoration.png",
  },
  {
    id: "dinosaurs025", category: "dinosaurs", difficulty: "medium",
    question: "뱀처럼 아주아주 길고 유연한 목을 가진 바다의 파충류로, 물속을 날아다니듯 헤엄쳤어! 지느러미가 네 개나 달려 있고 작은 머리로 물고기들을 잽싸게 잡아먹으며 평화롭게 지냈단다. 깊은 바닷속을 여행하던 아주 긴 목을 가진 이 친구는 누구일까요?",
    answer: "엘라스모사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Elasmosaurus2.jpg/500px-Elasmosaurus2.jpg",
  },
  {
    id: "dinosaurs026", category: "dinosaurs", difficulty: "easy",
    question: "머리 위에 몸 길이보다 더 길 수도 있는 엄청나게 커다란 'L'자 모양의 볏을 가졌던 하늘의 비행사야! 날개가 아주 넓고 꼬리는 거의 없어서 공중에 떠 있는 모습이 꼭 커다란 연처럼 보였단다. 숲속 높은 곳에서 멋지게 활강하던 이 신비로운 익룡은 누구일까요?",
    answer: "닉토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Nyctosaurus_DB.jpg/500px-Nyctosaurus_DB.jpg",
  },
  {
    id: "dinosaurs027", category: "dinosaurs", difficulty: "medium",
    question: "스테고사우루스와 사촌 사이지만, 등에 달린 골판이 더 둥글둥글하고 넓적하게 생겼어! 꼬리 끝에는 역시 네 개의 강력한 가시가 달려 있어서 무서운 육식 공룡으로부터 친구들을 지켜주었단다. 숲속에서 낮은 풀들을 맛있게 뜯어 먹던 이 단단한 친구는 누구일까요?",
    answer: "헤스페로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Hesperosaurus_mjosi_skeleton.JPG/500px-Hesperosaurus_mjosi_skeleton.JPG",
  },
  {
    id: "dinosaurs028", category: "dinosaurs", difficulty: "hard",
    question: "공룡 시대의 강가에서 살았던 산만큼 커다란 고대 악어로, 입이 아주 길고 이빨이 가득했어! 몸무게가 코끼리보다 무거울 정도로 거대했고 튼튼한 비늘 갑옷으로 온몸이 덮여 있었단다. 물속에서 숨어 있다가 물을 마시러 온 공룡들을 깜짝 놀라게 하던 이 왕 악어는 누구일까요?",
    answer: "사르코수쿠스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Sarcosuchus_BW.jpg/500px-Sarcosuchus_BW.jpg",
  },
  {
    id: "dinosaurs029", category: "dinosaurs", difficulty: "medium",
    question: "타조처럼 다리가 아주 길고 날씬해서 공룡 시대의 가장 빠른 달리기 왕 중 하나였어! 이빨이 없는 부리가 있고 목이 길어서 높은 곳도 잘 살폈으며 친구들과 무리 지어 빠르게 이동했단다. 깃털이 있었을 것으로 추측되는 이 호기심 많은 '새 닮은' 공룡은 누구일까요?",
    answer: "오르니토미무스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/ROM-OrnithomimusEdmontonicus.png/500px-44/ROM-OrnithomimusEdmontonicus.png",
  },
  {
    id: "dinosaurs030", category: "dinosaurs", difficulty: "medium",
    question: "남미 대륙에서 티라노사우루스보다도 더 크게 자랐던 세상에서 가장 거대한 육식 공룡 중 하나야! 아주 날카로운 칼 같은 이빨을 가졌으며 거대한 몸집으로 다른 큰 공룡들을 사냥했단다. 뒷다리가 아주 튼튼해서 듬직하게 걷던 이 남쪽나라의 폭군은 누구일까요?",
    answer: "기가노토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Giganotosaurus_at_Fernbank.jpg/500px-Giganotosaurus_at_Fernbank.jpg",
  },
  {
    id: "dinosaurs031", category: "dinosaurs", difficulty: "medium",
    question: "벨로키랍토르의 친척이지만 덩치가 훨씬 더 크고 사나웠던 영리한 사냥꾼 공룡이야! 뒷다리에 30센티미터가 넘는 아주 커다랗고 날카로운 갈고리 발톱을 가졌으며 무리 지어 전략적으로 사냥했단다. '유타주의 도둑'이라는 뜻의 이름을 가진 이 멋진 공룡은 누구일까요?",
    answer: "우타랍토르",
  },
  {
    id: "dinosaurs032", category: "dinosaurs", difficulty: "easy",
    question: "하늘을 날던 동물 중 역사상 가장 컸으며 날개를 펴면 비행기만큼이나 거대했어! 목이 아주 길고 부리가 가늘어서 물가에서 먹이를 찾아 먹기도 했고 땅 위에서는 네 발로 걸어 다녔단다. 하늘의 왕으로 불리는 이 어마어마한 크기의 익룡은 누구일까요?",
    answer: "케찰코아틀루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Quetzalcoatlus07.jpg/500px-Quetzalcoatlus07.jpg",
  },
  {
    id: "dinosaurs033", category: "dinosaurs", difficulty: "medium",
    question: "안킬로사우루스처럼 온몸에 단단한 뼈 갑옷을 입고 어깨에는 뾰족한 가시가 솟아 있는 친구야! 몸통이 아주 넓적하고 튼튼해서 사나운 육식 공룡이 나타나면 바닥에 몸을 꽉 붙여서 방어했단다. 숲속의 낮은 풀들을 오물오물 먹던 이 단단한 갑옷 공룡은 누구일까요?",
    answer: "에드몬토니아",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Edmontonia_dinosaur.png/500px-Edmontonia_dinosaur.png",
  },
  {
    id: "dinosaurs034", category: "dinosaurs", difficulty: "medium",
    question: "머리 위에 도끼나 장갑 같은 모양의 아주 독특한 볏을 가진 오리부리 공룡 친구야! 이 볏은 속이 비어 있어서 소리를 울려 친구들에게 신호를 보내거나 대화를 나눌 수 있었단다. 뒷다리가 아주 튼튼해서 이족 보행도 가능했던 이 신비로운 공룡은 누구일까요?",
    answer: "람베오사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Lambeosaurus_ROM.jpg/500px-a/af/Lambeosaurus_ROM.jpg",
  },
  {
    id: "dinosaurs035", category: "dinosaurs", difficulty: "medium",
    question: "티라노사우루스의 사촌으로 불리며 아주 사납고 날카로운 이빨을 가진 북미의 포식자야! 머리가 아주 크고 튼튼해서 먹잇감을 한 번 물면 절대 놓치지 않는 강력한 힘을 가졌단다. '무서운 도마뱀'이라는 뜻의 이름을 가진 이 용맹한 육식 공룡은 누구일까요?",
    answer: "다스플레토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Daspletosaurus_torosus_steveoc.jpg/500px-Daspletosaurus_torosus_steveoc.jpg",
  },
  {
    id: "dinosaurs036", category: "dinosaurs", difficulty: "easy",
    question: "코 위에 뽈록 솟은 뿔 하나와 눈 위에 작은 뿔 두 개가 있는 아주 개성 넘치는 육식 공룡이야! 등에 뾰족한 가시가 줄지어 나 있고 꼬리가 아주 길어 몸의 균형을 잘 잡았으며 아주 빠르게 달렸단다. '뿔 달린 도마뱀'이라는 뜻의 이름을 가진 이 친구는 누구일까요?",
    answer: "케라토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Ceratosaurus_nasicornis_DB.jpg/500px-Ceratosaurus_nasicornis_DB.jpg",
  },
  {
    id: "dinosaurs037", category: "dinosaurs", difficulty: "medium",
    question: "입부리가 앵무새처럼 예쁜 곡선으로 굽어 있는 아주 작고 귀여운 초식 공룡이야! 꼬리 쪽에 빳빳하고 긴 털 같은 돌기들이 솟아 있는 것이 특징이며 아주 평화로운 성격을 가졌단다. '앵무새 도마뱀'이라는 뜻의 이름을 가진 이 신비로운 친구는 누구일까요?",
    answer: "프시타코사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Psittacosaurus_mongoliensis_whole_BW.jpg/500px-e/ee/Psittacosaurus_mongoliensis_whole_BW.jpg",
  },
  {
    id: "dinosaurs038", category: "dinosaurs", difficulty: "medium",
    question: "코 위에 앞쪽으로 휘어진 독특한 뿔 하나가 콧수염처럼 솟아 있는 트리케라톱스의 친척이야! 목 뒤의 프릴에는 뒤쪽으로 뻗은 두 개의 큰 가시가 있어서 아주 위엄 넘치는 모습을 가졌단다. '들소 도마뱀'이라는 뜻의 이름을 가진 이 듬직한 공룡은 누구일까요?",
    answer: "에이니오사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Einiosaurus_BW.jpg/500px-c1/Einiosaurus_BW.jpg",
  },
  {
    id: "dinosaurs039", category: "dinosaurs", difficulty: "medium",
    question: "공룡 시대의 아주 초기인 '트라이아스기'에 살았던 세상에서 가장 오래된 공룡 중 하나야! 몸집은 강아지만큼 작았지만 뒷다리로 아주 빠르게 달릴 수 있는 아주 민첩한 사냥꾼이었단다. '새벽의 약탈자'라는 뜻의 예쁜 이름을 가진 이 공룡은 누구일까요?",
    answer: "에오랍토르",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Human-eoraptor_size_comparison.svg/500px-06/Human-eoraptor_size_comparison.svg.png",
  },
  {
    id: "dinosaurs040", category: "dinosaurs", difficulty: "easy",
    question: "바닷속에서 살았던 해양 파충류로 물고기를 너무 닮아서 커다란 상어처럼 보이기도 해! 몸매가 유선형이라 물속에서 아주 빠르게 헤엄칠 수 있었으며 수면 위로 올라와 공기로 숨을 쉬었단다. '물고기 도마뱀'이라는 뜻의 이름을 가진 이 바다 친구는 누구일까요?",
    answer: "이크티오사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3a/Ichthyooscale.png",
  },
  {
    id: "dinosaurs041", category: "dinosaurs", difficulty: "medium",
    question: "공룡 시대의 가장 영리한 똑똑이 중 하나로, 몸집에 비해 뇌가 아주 커서 지능이 높았을 거야! 커다란 눈 덕분에 어두운 곳에서도 잘 볼 수 있었고 친구들과 협력해서 사냥을 하기도 했단다. 깃털로 덮인 날씬한 몸을 가진 이 지혜로운 공룡은 누구일까요?",
    answer: "트로오돈",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Hand_drawn_Troodon.jpg/500px-Hand_drawn_Troodon.jpg",
  },
  {
    id: "dinosaurs042", category: "dinosaurs", difficulty: "medium",
    question: "트리케라톱스와 사촌이지만 코 위에 뾰족한 뿔 대신 아주 커다랗고 단단한 뼈 뭉치가 솟아 있어! 이 단단한 코뼈뭉치로 적을 밀어내거나 나무를 들이받으며 힘자랑을 하기도 했단다. 프릴 뒤쪽에는 두 개의 작은 뿔이 달린 이 듬직한 공룡은 누구일까요?",
    answer: "파키리노사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Pachyrhinosaurus_perotorum_skeleton.jpg/500px-Pachyrhinosaurus_perotorum_skeleton.jpg",
  },
  {
    id: "dinosaurs043", category: "dinosaurs", difficulty: "medium",
    question: "등에 아주 날카로운 가시들이 양옆으로 삐죽삐죽 솟아 있는 무시무시한 갑옷 공룡이야! 몸이 아주 넓적하고 단단한 뼈판으로 덮여 있어서 그 어떤 육식 공룡도 쉽게 공격하지 못했단다. 낮은 풀을 뜯어 먹으며 숲속을 천천히 걷던 이 방어의 대장은 누구일까요?",
    answer: "가스토니아",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Gastoniasaur.jpg/500px-Gastoniasaur.jpg",
  },
  {
    id: "dinosaurs044", category: "dinosaurs", difficulty: "easy",
    question: "부리가 앵무새처럼 예쁘게 굽어 있고 머리에 멋진 볏이 솟아 있는 아주 특별한 공룡이야! 예전엔 알을 훔쳐 먹는 나쁜 공룡인 줄 알았지만, 사실은 자기 알을 소중히 품어 지키던 사랑 많은 부모님이었단다. 깃털이 있고 아주 빠르게 달렸던 이 공룡은 누구일까요?",
    answer: "오비랍토르",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Oviraptor_philoceratops_skeleton.jpg/500px-Oviraptor_philoceratops_skeleton.jpg",
  },
  {
    id: "dinosaurs045", category: "dinosaurs", difficulty: "medium",
    question: "머리에 커다란 돛이나 부채 같은 아주 화려한 볏을 가졌던 공룡 시대의 익룡이야! 부리가 아주 짧고 뭉툭하며 날개를 활짝 펴서 해안가를 따라 멋지게 비행을 했단다. 화려한 색깔의 볏으로 친구들에게 뽐내기를 좋아했을 것 같은 이 신비로운 친구는 누구일까요?",
    answer: "타페야라",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/5/59/Tapejara_wellnoferi.jpg",
  },
  {
    id: "dinosaurs046", category: "dinosaurs", difficulty: "easy",
    question: "몸집이 닭이나 칠면조만큼 아주 작아서 공룡 세상에서 가장 귀여운 꼬마 육식 공룡 중 하나야! 다리가 아주 길고 가늘어서 덤불 사이를 슉슉 빠르게 도망치거나 작은 먹잇감을 사냥했단다. 꼬리가 아주 길어 몸의 균형을 잘 잡았던 이 날렵한 꼬마 공룡은 누구일까요?",
    answer: "콤프소그나투스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Compsognathus_BW.jpg/500px-Compsognathus_BW.jpg",
  },
  {
    id: "dinosaurs047", category: "dinosaurs", difficulty: "medium",
    question: "아기 공룡들을 위해 둥지를 짓고 맛있는 잎사귀를 끊임없이 물어다 주던 '착한 엄마' 공룡이야! 수백 마리씩 무리 지어 살며 아기들이 안전하게 자랄 수 있도록 정성껏 보살폈단다. 오리부리 공룡처럼 입이 넓적하고 성격이 아주 순했던 이 공룡은 누구일까요?",
    answer: "마이아사우라",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Maiasaura_BW.jpg/500px-Maiasaura_BW.jpg",
  },
  {
    id: "dinosaurs048", category: "dinosaurs", difficulty: "easy",
    question: "벨로키랍토르의 친척으로, 뒷다리에 아주 커다랗고 무시무시한 갈고리 발톱을 가진 사냥꾼이야! '무서운 발톱'이라는 뜻의 이름을 가졌으며 무리 지어 사냥하는 똑똑한 전술을 사용했단다. 날렵한 몸매와 긴 꼬리로 숲속을 빠르게 누비던 이 멋진 육식 공룡은 누구일까요?",
    answer: "데이노니쿠스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Deinonychus_Restoration.png/500px-Deinonychus_Restoration.png",
  },
  {
    id: "dinosaurs049", category: "dinosaurs", difficulty: "medium",
    question: "몸 길이의 절반 이상이 목과 꼬리일 정도로 아주 길쭉길쭉한 공룡 시대의 최장신 친구야! 꼬리가 아주 유연해서 채찍처럼 휘둘러 소리를 내거나 육식 공룡을 위협할 수 있었단다. 높은 구름 위까지 목을 뻗어 부드러운 잎을 먹던 이 상냥한 거인은 누구일까요?",
    answer: "디플로도쿠스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Diplodocus_longus%282%29.jpg/500px-Diplodocus_longus%282%29.jpg",
  },
  {
    id: "dinosaurs050", category: "dinosaurs", difficulty: "easy",
    question: "트리케라톱스와 닮았지만 뿔이 없고 몸집이 훨씬 작은 귀여운 뿔공룡의 조상님이야! 앵무새 같은 부리를 가졌으며 목 뒤에는 예쁜 프릴이 뽈록 솟아 있는 것이 특징이란다. 몽골의 넓은 벌판을 무리 지어 다니며 풀을 먹던 이 평화로운 공룡은 누구일까요?",
    answer: "프로토케라톱스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Protoceratops_BW.jpg/500px-Protoceratops_BW.jpg",
  },
  {
    id: "dinosaurs051", category: "dinosaurs", difficulty: "medium",
    question: "목부터 등까지 두 줄로 길쭉하고 뾰족한 뼈 가시들이 멋지게 돋아나 있는 아주 독특한 친구야! 몸집은 다른 긴 목 공룡들에 비해 작았지만 화려한 가시 장식 덕분에 아주 위풍당당해 보였단다. 남미 대륙의 숲속에서 살던 이 가시 돋친 공룡은 누구일까요?",
    answer: "아마르가사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Amargasaurus1_Melb_Museum_email.jpg/500px-Amargasaurus1_Melb_Museum_email.jpg",
  },
  {
    id: "dinosaurs052", category: "dinosaurs", difficulty: "easy",
    question: "공룡 시대의 숲속에서 살았던 아주 작고 민첩한 초식 공룡으로, '산의 달리기 선수'라는 이름을 가졌어! 뒷다리가 아주 길어서 위험이 닥치면 덤불 사이를 요리조리 아주 빠르게 빠져나갔단다. 무리 지어 다니며 맛있는 열매와 부드러운 잎을 먹던 이 귀여운 친구는 누구일까요?",
    answer: "오로드로메우스",
  },
  {
    id: "dinosaurs053", category: "dinosaurs", difficulty: "medium",
    question: "머리 위에 반원 모양의 아주 둥글고 멋진 볏을 가졌는데, 코와 연결되어 소리를 울리는 나팔 같았어! 이 볏 덕분에 '투구 도마뱀'이라는 멋진 이름을 얻었고 숲속 친구들과 즐겁게 노래하며 지냈단다. 뒷발가락에는 물갈퀴도 있었을 것 같은 이 순한 공룡은 누구일까요?",
    answer: "코리토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Corythosaurus3.jpg/500px-Corythosaurus3.jpg",
  },
  {
    id: "dinosaurs054", category: "dinosaurs", difficulty: "easy",
    question: "안킬로사우루스보다 더 크고 튼튼하며, 온몸이 돌기처럼 튀어나온 뼈 갑옷으로 덮여 있는 무결점 수비수야! 눈꺼풀조차 뼈로 되어 있어서 적이 공격해도 눈 하나 깜짝하지 않았을 정도로 단단했단다. 꼬리에 달린 무거운 철퇴가 무기였던 이 탱크 공룡은 누구일까요?",
    answer: "유오플로케팔루스",
  },
  {
    id: "dinosaurs055", category: "dinosaurs", difficulty: "medium",
    question: "티라노사우루스와 아주 닮았지만 아시아 대륙을 지배했던 무시무시한 폭군 육식 공룡이야! 아주 강력한 턱과 바나나처럼 큰 이빨을 가졌으며 거대한 몸집으로 숲속을 누비며 사냥을 했단다. '놀라게 하는 도마뱀'이라는 뜻의 이름을 가진 이 용맹한 왕은 누구일까요?",
    answer: "타르보사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Tarbosaurusbcn2.JPG/500px-Tarbosaurusbcn2.JPG",
  },
  {
    id: "dinosaurs056", category: "dinosaurs", difficulty: "easy",
    question: "트리케라톱스보다 뿔이 더 많아서 총 5개의 뿔을 가졌던 아주 화려하고 멋진 장식의 공룡이야! 뺨 쪽에도 작은 뿔들이 솟아 있고 목 뒤의 프릴은 아주 길고 높게 뻗어 있었단다. 이 화려한 뿔들로 자신을 멋지게 뽐내던 이 듬직한 초식 공룡은 누구일까요?",
    answer: "펜타케라톱스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Pentaceratops_BW.jpg/500px-Pentaceratops_BW.jpg",
  },
  {
    id: "dinosaurs057", category: "dinosaurs", difficulty: "medium",
    question: "타조 공룡의 일종으로, 가늘고 긴 다리 덕분에 초원을 아주 빠르게 질주하던 바람 같은 공룡이야! 앞발가락이 아주 길어서 물건을 쥐는 것도 잘했고 친구들과 떼를 지어 영리하게 이동했단다. '거위 닮은 도마뱀'이라는 뜻의 재미있는 이름을 가진 이 공룡은 누구일까요?",
    answer: "안세리미무스",
  },
  {
    id: "dinosaurs058", category: "dinosaurs", difficulty: "easy",
    question: "바닷속을 누비던 거대한 해양 파충류로, 모사사우루스의 친척이지만 훨씬 더 길쭉한 몸매를 가졌어! 코 근처의 뼈가 아주 튼튼하게 솟아 있어서 적을 들이받거나 사냥감을 공격할 때 사용했단다. 물속의 무법자로 통하던 이 무시무시한 바다 괴물 공룡은 누구일까요?",
    answer: "틸로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Tylosaurus_proriger_AMNH.jpg/500px-Tylosaurus_proriger_AMNH.jpg",
  },
  {
    id: "dinosaurs059", category: "dinosaurs", difficulty: "medium",
    question: "세상에서 처음으로 화석이 발견되어 공룡이라는 이름이 붙여진 아주 역사적인 육식 공룡이야! 튼튼한 다리와 날카로운 이빨을 가졌으며 중생대 초기를 호령하던 용맹한 사냥꾼이었단다. '커다란 도마뱀'이라는 뜻의 이름을 가진 이 전설적인 공룡은 누구일까요?",
    answer: "메갈로사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Megalosaurus_dinosaur.png/500px-Megalosaurus_dinosaur.png",
  },
  {
    id: "dinosaurs060", category: "dinosaurs", difficulty: "easy",
    question: "머리 뒤쪽으로 아주 커다란 'V'자 모양의 장식용 볏이 솟아 있는 하늘의 멋쟁이 익룡 친구야! 날개가 아주 넓고 꼬리는 거의 없어서 상승 기류를 타고 아주 높이 날아다닐 수 있었단다. '이빨 없는 도마뱀'이라는 뜻의 이름을 가진 이 신비로운 비행사는 누구일까요?",
    answer: "닉토사우루스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Nyctosaurus_DB.jpg/500px-Nyctosaurus_DB.jpg",
  },
  // Insects Quiz Expansion (need 55 more for 60)
  // Insects Quiz (60 questions)
  {
    id: "insects001", category: "insects", difficulty: "easy",
    question: "알록달록 화려하고 예쁜 날개를 활짝 펴서 꽃 사이를 춤추듯 날아다니는 숲속의 요정이야! 돌돌 말려 있는 긴 빨대 같은 입으로 달콤한 꽃꿀을 쏙쏙 빨아 먹는단다. 애벌레 시절을 지나 번데기에서 멋지게 변신해서 태어나는 이 예쁜 곤충은 누구일까요?",
    answer: "나비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Butterfly_macro_shot.jpg/500px-Butterfly_macro_shot.jpg",
  },
  {
    id: "insects002", category: "insects", difficulty: "easy",
    question: "땅속에 복잡한 미로 같은 집을 짓고 살며 자기 몸보다 엄청나게 무거운 것도 번쩍 드는 천하장사야! 친구들과 페로몬이라는 향기로 대화를 나누며 아주 줄지어 부지런히 행진을 한단다. 여왕님을 중심으로 가족들이 똘똘 뭉쳐 사는 이 협동의 왕은 누구일까요?",
    answer: "개미",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Meat_eater_ant_feeding_on_honey02.jpg/500px-Meat_eater_ant_feeding_on_honey02.jpg",
  },
  {
    id: "insects003", category: "insects", difficulty: "easy",
    question: "빨간색 동그란 등에 검은색 점무늬가 콕콕 박혀 있는 아주 귀엽고 고마운 농부의 친구야! 적이 나타나면 다리 사이에서 고약한 냄새가 나는 노란 액체를 내뿜어 자신을 지킨단다. 식물을 괴롭히는 진딧물을 맛있게 잡아먹어 주는 이 둥글둥글한 벌레는 누구일까요?",
    answer: "무당벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Asian_lady_beetle-%28Harmonia-axyridis%29.jpg/500px-Asian_lady_beetle-%28Harmonia-axyridis%29.jpg",
  },
  {
    id: "insects004", category: "insects", difficulty: "easy",
    question: "커다란 눈이 두 개나 달려서 세상의 모든 것을 잘 볼 수 있고 헬리콥터처럼 공중 정지를 할 수 있어! 얇고 투명한 네 개의 날개로 물 위를 슉슉 빠르게 날아다니며 파리나 모기를 잡아먹는단다. 가을 하늘을 멋지게 수놓는 이 비행의 고수는 누구일까요?",
    answer: "잠자리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Orthetrum_cancellatum.jpg/500px-Orthetrum_cancellatum.jpg",
  },
  {
    id: "insects005", category: "insects", difficulty: "easy",
    question: "뜨거운 여름날 나무에 찰딱 붙어서 '맴맴' 하고 아주 크게 소리 내어 노래를 부르는 가수야! 땅속에서 수년 동안 애벌레로 살다가 겨우 밖으로 나와 짧지만 아주 뜨겁고 열정적으로 산단다. 투명한 날개를 가졌으며 수컷만 노래를 부를 수 있는 이 곤충은 누구일까요?",
    answer: "매미",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Neotibicen_linnei.jpg/500px-Neotibicen_linnei.jpg",
  },
  {
    id: "insects006", category: "insects", difficulty: "easy",
    question: "뒷다리가 자기 몸무게의 수십 배를 견딜 만큼 아주 튼튼해서 껑충껑충 엄청난 높이로 점프할 수 있어! 온몸이 초록색이나 갈색이라 풀숲에 숨으면 아무도 찾지 못하는 위장의 달인이란다. 길쭉한 더듬이를 휘저으며 풀잎을 먹는 이 점프 대장은 누구일까요?",
    answer: "메뚜기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Acrididae_grasshopper-2.jpg/500px-Acrididae_grasshopper-2.jpg",
  },
  {
    id: "insects007", category: "insects", difficulty: "medium",
    question: "메뚜기와 닮았지만 날개가 아주 길고 뒷다리를 비벼서 '지이익' 하고 특별한 소리를 내는 가을의 연주가야! 날개 모양이 나뭇잎과 아주 똑 닮아서 숲속에 조용히 앉아 있으면 찾기가 정말 힘들단다. 여름에는 개미와 달리 매일 노래만 불렀다는 동화의 주인공은 누구일까요?",
    answer: "베짱이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Grasshopper_on_the_stairs_-_2.jpg/500px-Grasshopper_on_the_stairs_-_2.jpg",
  },
  {
    id: "insects008", category: "insects", difficulty: "medium",
    question: "앞다리가 날카로운 톱니가 달린 낫 모양으로 생겨서 곤충들 사이에서는 아주 무서운 사냥꾼으로 통행해! 머리를 360도 휙휙 돌리며 주변을 살필 수 있고 아주 사나운 눈매를 가졌단다. 기도하듯 앞다리를 모으고 숨어 있다 잽싸게 사냥하는 이 곤충은 누구일까요?",
    answer: "사마귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Tenodera_angustipennis_Saussure%28Pregnant%29_DSCN9575.jpg/500px-Tenodera_angustipennis_Saussure%28Pregnant%29_DSCN9575.jpg",
  },
  {
    id: "insects009", category: "insects", difficulty: "easy",
    question: "깜깜한 밤하늘에 꼬리에서 노란색 불빛을 깜빡깜빡하며 날아다니는 신비로운 '개똥벌레'라고도 불리는 친구야! 깨끗한 물과 풀숲이 있는 곳에서만 살 수 있는 아주 소중하고 예쁜 곤충이란다. 밤을 환하게 밝혀주는 이 자연의 전등 같은 친구는 누구일까요?",
    answer: "반딧불이",
  },
  {
    id: "insects010", category: "insects", difficulty: "medium",
    question: "몸이 매끄러운 바둑알처럼 둥글고 납작해서 물속을 아주 자유롭고 빠르게 헤엄칠 수 있는 수중 다이버야! 날개 아래에 공기 방울을 쏙 넣어서 잠수함처럼 물속에서도 오랫동안 숨을 쉴 수 있단다. 물고기나 올챙이를 사냥해서 먹는 이 멋진 물속 곤충은 누구일까요?",
    answer: "물방개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG/500px-%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG",
  },
  {
    id: "insects011", category: "insects", difficulty: "easy",
    question: "몸이 단단한 반짝이는 껍질로 덮여 있고 숲속의 나무 즙을 아주 맛있게 먹으며 사는 멋쟁이야! 예쁜 초록색이나 구릿빛으로 반짝이는 몸이 보석처럼 아름답고 둥글둥글 귀엽게 보인단다. 밤이 되면 불빛을 찾아 날아오기도 하는 이 딱딱한 친구는 누구일까요?",
    answer: "풍뎅이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Mimela_splendens.jpg/500px-Mimela_splendens.jpg",
  },
  {
    id: "insects012", category: "insects", difficulty: "medium",
    question: "다리가 8개나 되고 엉덩이에서 끈적끈적한 거미줄을 뽑아 아주 멋진 그물을 만드는 건축가야! 이 그물에 걸린 벌레들을 꽉 잡아서 식사를 해결하고 눈도 여러 개나 달려 있단다. 곤충은 아니지만 숲과 집안을 지켜주는 이 소중한 여덟 다리 친구는 누구일까요?",
    answer: "거미",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Spiders_Diversity.jpg/500px-Spiders_Diversity.jpg",
  },
  {
    id: "insects013", category: "insects", difficulty: "easy",
    question: "노란색과 검은색 줄무늬 옷을 입고 '부웅부웅' 소리를 내며 예쁜 꽃들을 찾아다니는 부지런한 일꾼이야! 꽃가루 보관함이 뒷다리에 있어서 꿀과 함께 집으로 가져가 맛있는 꿀떡을 만든단다. 화나면 엉덩이의 독침을 쏠 수도 있으니 조심해야 하는 이 친구는 누구일까요?",
    answer: "꿀벌",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Bee_on_Geraldton_Wax_Flower.JPG/500px-Bee_on_Geraldton_Wax_Flower.JPG",
  },
  {
    id: "insects014", category: "insects", difficulty: "medium",
    question: "꿀벌보다 덩치가 훨씬 크고 소리도 무시무시하며 사나운 성격을 가진 벌들의 대장이야! 아주 강력하고 치명적인 독침을 여러 번 쏠 수 있어서 보면 무조건 멀리 도망가야 한단다. 숲속 높은 나무에 커다란 집을 짓고 사는 이 조금은 무서운 벌은 누구일까요?",
    answer: "말벌",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Hornet-vespa.jpg/500px-Hornet-vespa.jpg",
  },
  {
    id: "insects015", category: "insects", difficulty: "medium",
    question: "나비와 아주 닮았지만 주로 밤에 활동하고 더듬이가 빗이나 깃털 모양처럼 아주 화려해! 밤에 밝은 불빛이나 가로등 주변을 빙글빙글 도는 것을 세상에서 제일 좋아한단다. 쉴 때는 날개를 평평하게 활짝 펴서 쉬는 이 밤의 비행사는 누구일까요?",
    answer: "나방",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Polyphemus_Moth.jpg/500px-Polyphemus_Moth.jpg",
  },
  {
    id: "insects016", category: "insects", difficulty: "medium",
    question: "날개가 아주 얇고 투명해서 속이 훤히 비치며 물가에서 아주 잠깐 동안만 예쁜 모습으로 나타나! 입이 없어서 아무것도 먹지 못하고 오직 아기를 낳기 위해 아주 짧고 고귀한 생을 산단다. 이름처럼 아주 짧은 시간 동안만 우리 곁에 머무는 이 곤충은 누구일까요?",
    answer: "하루살이",
  },
  {
    id: "insects017", category: "insects", difficulty: "easy",
    question: "여름밤 단잠을 방해하며 귀옆에서 '윙윙~' 소리를 내고 피를 빨아먹어 가렵게 만드는 얄미운 친구야! 물 위를 살랑거리며 아기 시절을 보내고 날카로운 입을 바늘처럼 찔러 피를 먹는단다. 우리가 여름마다 모기장을 치게 만드는 이 불청객은 누구일까요?",
    answer: "모기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Culex_pipiens.jpg/500px-Culex_pipiens.jpg",
  },
  {
    id: "insects018", category: "insects", difficulty: "easy",
    question: "눈이 엄청나게 커서 세상의 모든 곳을 다 보고 끈적한 발바닥으로 천장에도 찰딱 잘 붙어 있어! 사방팔방 아주 빠르게 날아다니고 병균을 옮길 수도 있어서 우리가 싫어하는 파리채의 주인공이란다. '윙~' 소리 내며 음식을 노리는 이 불청객 곤충은 누구일까요?",
    answer: "파리",
  },
  {
    id: "insects019", category: "insects", difficulty: "easy",
    question: "집 안 아주 좁고 어두운 구석을 좋아하며 엄청나게 빠른 속도로 기어 다녀 사람들을 깜짝 놀라게 해! 아주 옛날 공룡 시대부터 지금까지 살아남았을 정도로 끈질긴 생명력을 가진 걸로 유명하단다. 더러운 곳을 좋아해 꼭 없애야 하는 이 불청객은 누구일까요?",
    answer: "바퀴벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Blattella_germanica_1236168.jpg/500px-Blattella_germanica_1236168.jpg",
  },
  {
    id: "insects020", category: "insects", difficulty: "medium",
    question: "식물의 줄기에 개미와 옹기종기 모여 살며 달콤한 즙인 '감로'를 개미에게 선물하는 작은 친구야! 몸집이 아주 작고 가냘퍼서 무당벌레 같은 무서운 사냥꾼들에게는 아주 맛있는 식사가 되기도 한단다. 개미와 서로 돕고 사는 이 신비로운 벌레는 누구일까요?",
    answer: "진딧물",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Aphidoidea_fight.jpg/500px-Aphidoidea_fight.jpg",
  },
  {
    id: "insects021", category: "insects", difficulty: "easy",
    question: "나뭇가지와 몸 모양이 아주 똑같이 생겨서 숲속에서 가만히 있으면 아무도 찾지 못하는 변신의 천재야! 가느다란 다리와 긴 몸을 가졌으며 천천히 움직이거나 바람에 흔들리는 나뭇가지 흉내를 낸단다. 적을 속이기 위해 다리를 떼어버리고 도망치기도 하는 이 곤충은 누구일까요?",
    answer: "대나무벌레",
  },
  {
    id: "insects022", category: "insects", difficulty: "medium",
    question: "모래밭에 '개미지옥'이라는 깔때기 모양의 구덩이를 파고 모래 속에 숨어서 먹이가 떨어지기를 기다리는 사냥꾼이야! 개미가 구덩이에 빠지면 모래를 던져 도망가지 못하게 방해하고 강력한 턱으로 꽉 잡는단다. 나중에 자라서 '명주잠자리'가 되는 이 신기한 벌레는 누구일까요?",
    answer: "개미귀신",
  },
  {
    id: "insects023", category: "insects", difficulty: "easy",
    question: "가늘고 긴 다리에 미세한 털이 있어서 물에 빠지지 않고 물 위를 미끄러지듯이 스케이트 타듯 다닐 수 있어! 물 위에 떨어진 작은 곤충들의 진동을 느껴서 잽싸게 다가가 먹이를 잡는 물 위의 사냥꾼이란다. 물 위를 아장아장 걷는 신기하고 날렵한 이 곤충은 누구일까요?",
    answer: "소금쟁이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Aquarius_najas01.jpg/500px-Aquarius_najas01.jpg",
  },
  {
    id: "insects024", category: "insects", difficulty: "medium",
    question: "땅속에서 아주 오랫동안 썩은 나뭇잎이나 흙을 먹으며 포동포동하게 자라는 장수풍뎅이나 사슴벌레의 아기 시절이야! 몸이 하얗고 'C'자 모양으로 굽어 있으며 땅바닥을 꿈틀꿈틀 기어 다닌단다. 나중에 멋진 딱정벌레로 변신하기 위해 오랜 시간을 기다리는 이 벌레는 무엇일까요?",
    answer: "굼벵이",
  },
  {
    id: "insects025", category: "insects", difficulty: "easy",
    question: "숲속에서 죽은 작은 동물들을 땅속에 묻어주어서 숲을 깨끗하게 만들어주는 아주 고마운 청소부 친구야! 몸에 주황색 무늬가 있고 냄새를 아주 잘 맡아서 멀리서도 청소할 곳을 찾아낸단다. 땅속에 아기를 낳고 정성껏 돌보는 아주 부지런하고 지혜로운 이 곤충은 누구일까요?",
    answer: "송장벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/F6-15_Nicrophorus_japonicus_Harold%2C_1877.jpg/500px-F6-15_Nicrophorus_japonicus_Harold%2C_1877.jpg",
  },
  {
    id: "insects026", category: "insects", difficulty: "easy",
    question: "다리가 아주 많아서 '돈벌레'라고도 불리며 집 안의 어둡고 습한 곳에서 아주 빠르게 움직여! 다른 해로운 벌레들을 잡아먹어 주는 고마운 친구지만 생긴 모습이 조금 무서워 사람들이 깜짝 놀라기도 한단다. 위협을 느끼면 다리를 떼어놓고 도망가는 아주 빠른 이 벌레는 누구일까요?",
    answer: "그리마",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Scutigera_coleoptrata_MHNT.jpg/500px-Scutigera_coleoptrata_MHNT.jpg",
  },
  {
    id: "insects027", category: "insects", difficulty: "medium",
    question: "애벌레 시절에 뽕잎을 아주 많이 먹고 자라며, 입에서 가느다란 하얀 실을 뽑아 동그란 고치를 만들어! 이 고치에서 뽑아낸 실로 우리가 입는 부드러운 '비단' 옷감을 만든단다. 사람들에게 아주 오랫동안 도움을 주어 온 정겨운 이 곤충 친구는 누구일까요?",
    answer: "누에나방",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Silkworms3000px.jpg/500px-Silkworms3000px.jpg",
  },
  {
    id: "insects028", category: "insects", difficulty: "easy",
    question: "몸 길이보다 더 길 수도 있는 아주 긴 더듬이를 휘저으며 나무 위를 엉금엉금 기어 다니는 친구야! 딱딱한 껍질을 가졌으며 튼튼한 턱으로 나무껍질을 갉아먹거나 나무 즙을 쪽쪽 빨아 먹는단다. '하늘에서 내려온 소'라는 뜻의 예쁜 이름을 가진 이 곤충은 무엇일까요?",
    answer: "하늘소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Neocerambyx_raddei.png/500px-Neocerambyx_raddei.png",
  },
  {
    id: "insects029", category: "insects", difficulty: "medium",
    question: "깨끗한 시냇물 속에서 모래알이나 나뭇잎 조각을 모아 거미줄로 붙여서 예쁜 집을 짓고 사는 건축가야! 이 집 속에 쏙 들어가서 몸을 보호하며 아기 시절을 보내고 나중에 나방처럼 생긴 어른이 된단다. 물속에서 성실하게 집을 짓는 이 신비로운 친구는 누구일까요?",
    answer: "날도래",
  },
  {
    id: "insects030", category: "insects", difficulty: "easy",
    question: "꿀벌과 아주 닮은 노란 줄무늬 옷을 입고 예쁜 꽃 사이를 윙윙거리며 날아다니는 파리의 친척이야! 벌처럼 보이지만 침이 없어서 쏘지 않고 꽃가루를 옮겨주어 식물들이 열매를 맺게 도와주는 착한 친구란다. 공중에 멈춰 서서 비행하는 것을 참 잘하는 이 곤충은 누구일까요?",
    answer: "꽃등에",
  },
  {
    id: "insects031", category: "insects", difficulty: "medium",
    question: "동물의 똥을 뒷다리로 영차영차 둥글게 굴려서 집으로 가져가는 세상에서 가장 성실한 곤충이야! 거꾸로 서서 똥 경사를 오르는 모습이 아주 힘차 보이고 아기들이 먹을 소중한 양식을 모으는 거란다. 자연의 순환을 도와주는 아주 고마운 이 일꾼은 누구일까요?",
    answer: "소똥구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Gymnopleurus_mopsus.jpg/500px-Gymnopleurus_mopsus.jpg",
  },
  {
    id: "insects032", category: "insects", difficulty: "easy",
    question: "가을 밤이 되면 풀숲에서 '귀뚤귀뚤' 맑고 고운 목소리로 노래하며 우리 마음을 편안하게 해주는 친구야! 날개를 서로 비벼서 소리를 내는데 수컷만 이 아름다운 노래를 부를 수 있단다. 긴 뒷다리로 점프도 아주 잘 하는 숲속의 낭만 음악가인 이 곤충은 누구일까요?",
    answer: "귀뚜라미",
  },
  {
    id: "insects033", category: "insects", difficulty: "medium",
    question: "알에서 태어나 아주 많이 먹고 쑥쑥 자라서 멋진 곤충이 되기 전의 꿈틀꿈틀 아기 시절이야! 다리가 여러 개 있고 초록색이나 알록달록한 옷을 입고 나뭇잎을 아주 맛있게 냠냠 먹는단다. 나중에 멋진 나비나 벌레로 변신할 준비를 하는 이 친구는 누구일까요?",
    answer: "애벌레",
  },
  {
    id: "insects034", category: "insects", difficulty: "easy",
    question: "딱정벌레의 일종으로 나무속에 아주 작은 구멍을 뚫고 들어가 나무를 병들게 할 수도 있는 작은 벌레야! 몸집은 아주 작지만 많은 수가 모이면 큰 나무도 쓰러뜨릴 수 있을 만큼 힘이 아주 세단다. 나무 껍질 아래에 복잡한 길을 만들며 사는 이 곤충은 누구일까요?",
    answer: "나무좀",
  },
  {
    id: "insects035", category: "insects", difficulty: "medium",
    question: "나뭇잎을 정교하게 동그랗게 돌돌 말아서 그 속에 소중한 알을 쏙 넣는 아주 지혜로운 엄마야! 목이 기린처럼 길게 솟아 있는 종류도 있고 튼튼한 부리 같은 입으로 잎을 다듬는단다. '숲속의 요람'을 만드는 예술가 같은 이 신비로운 곤충은 누구일까요?",
    answer: "거위벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Giraffe_Weevil_Apoderus_Longicollis.jpg",
  },
  {
    id: "insects036", category: "insects", difficulty: "easy",
    question: "물속에서 아주 둥글고 매끄러운 몸으로 빙글빙글 원을 그리며 춤을 추듯 노는 신기한 친구야! 뒷다리가 노처럼 넓적해서 물살을 아주 잘 가르고 잠시 물 밖으로 나와 날 수 있는 날개도 가졌단다. 물속의 검은 보석처럼 반짝이는 이 곤충은 누구일까요?",
    answer: "물방개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG/500px-%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG",
  },
  {
    id: "insects037", category: "insects", difficulty: "medium",
    question: "머리에 커다란 사슴 뿔 같은 멋진 턱이 달려 있어서 아주 위세 당당해 보이는 숲속의 전사야! 이 튼튼한 집게 턱으로 나무 즙을 차지하기 위해 친구들과 힘겨루기를 하기도 한단다. 반짝이는 검은색 갑옷을 입고 밤의 숲을 누비는 이 곤충은 누구일까요?",
    answer: "사슴벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Lucanus70.JPG/500px-Lucanus70.JPG",
  },
  {
    id: "insects038", category: "insects", difficulty: "easy",
    question: "머리에 아주 커다랗고 튼튼한 'Y'자 모양의 뿔이 솟아 있는 곤충 세상의 가장 힘센 왕이야! 둥글고 단단한 갑옷을 입었으며 나무 즙을 아주 좋아하고 힘이 장사라 무엇이든 번쩍 들어 올린단다. 숲속을 당당하게 걸어 다니는 이 멋진 곤충은 누구일까요?",
    answer: "장수풍뎅이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Kabutomushi-JapaneseBeetle-July2004.jpg/500px-Kabutomushi-JapaneseBeetle-July2004.jpg",
  },
  {
    id: "insects039", category: "insects", difficulty: "medium",
    question: "물귀신이라는 별명이 있을 정도로 물속에서 아주 무서운 사냥꾼으로 통하는 긴 몸을 가진 친구야! 꼬리 끝에 숨을 쉬는 관을 물 밖으로 쏙 내밀고 숨을 쉬며 앞다리로 물고기를 꽉 잡는단다. 사마귀와 아주 닮았지만 물속에서 사는 이 든든한 곤충은 누구일까요?",
    answer: "장구애비",
  },
  {
    id: "insects040", category: "insects", difficulty: "easy",
    question: "둥근 몸에 짧은 날개를 가졌지만 날지 못하고 땅 위를 엉금엉금 기어 다니는 아주 독특한 친구야! 적이 나타나면 몸에서 고약한 냄새가 나는 칸타리딘이라는 액체를 내뿜어 자신을 지킨단다. 아주 옛날부터 우리와 함께 살아온 신기하고 조금은 통통한 이 곤충은 누구일까요?",
    answer: "가뢰",
  },
  {
    id: "insects041", category: "insects", difficulty: "medium",
    question: "밤하늘을 날아다니며 꼬리 끝에서 환한 노란색 불빛을 깜빡거리는 숲속의 작은 등불 같은 친구야! 깨끗한 시냇물 근처에서 살며 사랑하는 친구를 찾기 위해 빛을 낸단다. '개똥벌레'라는 정겨운 옛 이름으로도 불리는 이 신비로운 곤충은 무엇일까요?",
    answer: "반딧불이",
  },
  {
    id: "insects042", category: "insects", difficulty: "easy",
    question: "나비와 아주 닮았지만 주로 밤에 활동하고 더듬이가 빗 모양이나 깃털 모양인 밤의 비행사야! 날개가 검은색이거나 어두운 색깔이라 밤의 숲속에 조용히 앉아 있으면 찾기가 아주 힘들단다. 밝은 불빛을 아주 좋아해서 밤마다 윙윙 찾아드는 이 곤충은 누구일까요?",
    answer: "나방",
  },
  {
    id: "insects043", category: "insects", difficulty: "medium",
    question: "깨끗한 계곡물 속에서 작은 돌맹이나 모래알을 모아 아주 정교한 관 모양의 집을 짓는 수중 건축가야! 이 집은 나방이 되기 전까지 몸을 보호해 주는 아주 튼튼하고 아늑한 요람이 된단다. 물속에서 성실하게 일하는 이 신비로운 곤충 친구는 누구일까요?",
    answer: "날도래",
  },
  {
    id: "insects044", category: "insects", difficulty: "easy",
    question: "빨간색 동그란 등에 검은색 점무늬가 일곱 개 콕콕 박혀 있는 아주 귀엽고 예쁜 딱정벌레야! 진딧물을 맛있게 잡아먹어 주어 농사를 돕는 고마운 곤충 일꾼이란다. 위협을 느끼면 죽은 척 가만히 멈춰 서서 자신을 지키는 지혜로운 이 친구는 누구일까요?",
    answer: "칠성무당벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/BIEDRONA.JPG/500px-BIEDRONA.JPG",
  },
  {
    id: "insects045", category: "insects", difficulty: "medium",
    question: "온몸이 빨간색으로 물든 가을의 상징으로, 맑은 가을 하늘을 헬리콥터처럼 멋지게 날아다녀! 커다란 눈과 투명한 날개를 가졌으며 물가 풀잎에 앉아 꼬리를 살랑살랑 흔들기도 한단다. 가을이 왔음을 알려주는 이 빨간색 날개 친구는 누구일까요?",
    answer: "고추잠자리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Crocothemis_servilia_mariannae.jpg/500px-Crocothemis_servilia_mariannae.jpg",
  },
  {
    id: "insects046", category: "insects", difficulty: "easy",
    question: "가을 밤 풀숲에서 '리리리리~' 하고 아주 맑고 고운 방울 소리 같은 노래를 들려주는 음악가야! 몸집은 작고 갈색이지만 노래 실력만큼은 숲속에서 최고로 손꼽히는 정겨운 친구란다. 시원한 가을바람과 함께 노래하는 이 곤충 친구는 누구일까요?",
    answer: "방울벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Suzumushi.jpg/500px-Suzumushi.jpg",
  },
  {
    id: "insects047", category: "insects", difficulty: "medium",
    question: "아주 옛날 공룡 시대보다 더 전부터 지구에 살았던 아주 오래된 역사를 가진 신비로운 곤충이야! 몸이 납작하고 은빛으로 반짝이며 어둡고 습한 곳을 좋아해서 우리 몰래 숨어서 산단다. 아주 작은 생물이라 눈에 잘 안 띄는 이 은색 벌레는 누구일까요?",
    answer: "좀벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Ctenolepisma_longicaudata_%28long-tailed_silverfish%29%2C_Mook%2C_the_Netherlands.JPG/500px-Ctenolepisma_longicaudata_%28long-tailed_silverfish%29%2C_Mook%2C_the_Netherlands.JPG",
  },
  {
    id: "insects048", category: "insects", difficulty: "easy",
    question: "커다랗고 둥근 눈과 가느다란 몸을 가졌으며 나뭇잎 뒤에 숨어서 작은 곤충들을 잡아먹는 사냥꾼이야! 날개가 아주 얇고 투명하며 풀숲 사이를 슉슉 빠르게 날아다니는 날렵한 숲속의 비행사란다. 초록색이나 갈색 옷을 입고 풀숲을 지키는 이 친구는 누구일까요?",
    answer: "풀잠자리",
  },
  {
    id: "insects049", category: "insects", difficulty: "medium",
    question: "물 밑 모래 속에 숨어 있다가 물고기를 잡아먹는 아주 사나운 수중 생물은 누구일까요?",
    answer: "게아재비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Ranatra_chinensis.jpg/500px-Ranatra_chinensis.jpg",
  },
  {
    id: "insects050", category: "insects", difficulty: "easy",
    question: "나무 껍질과 아주 똑같이 생긴 갈색 옷을 입고 나무에 딱 붙어서 즙을 빨아 먹는 변신의 대장이야! 커다란 날개로 나무 사이를 윙윙거리며 아주 힘차게 날아다니는 여름의 가수이기도 하단다. 숲속 나무의 수액을 아주 즐겨 먹는 이 듬직한 곤충은 누구일까요?",
    answer: "말매미",
  },
  {
    id: "insects051", category: "insects", difficulty: "medium",
    question: "비가 오기 전에 떼를 지어 아주 낮게 날아다니는 숲속의 기상 예보관은 누구일까요?",
    answer: "잠자리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Orthetrum_cancellatum.jpg/500px-Orthetrum_cancellatum.jpg",
  },
  {
    id: "insects052", category: "insects", difficulty: "easy",
    question: "하얀 솜사탕 같은 것을 몸에 붙이고 식물 즙을 먹으며 사는 벌레는 누구일까요?",
    answer: "솜깍지벌레",
    customOptions: ["솜깍지벌레", "개미귀신", "하루살이"],
  },
  {
    id: "insects053", category: "insects", difficulty: "medium",
    question: "모래 속에 깔때기 모양의 함정을 파고 숨어서 개미가 빠지기를 기다리는 은밀한 사냥꾼이야! 뒷걸음질을 아주 잘 해서 모래 속으로 쏙 숨어버리는 부지런하고 영리한 아기 곤충이란다. 나중에 자라서 예쁜 명주잠자리가 되는 이 친구는 무엇일까요?",
    answer: "개미귀신",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Giraffe_Weevil_Apoderus_Longicollis.jpg",
  },
  {
    id: "insects054", category: "insects", difficulty: "easy",
    question: "여름밤 우리 귓가에서 '윙윙' 소리를 내며 잠을 깨우는 얄미운 곤충은 누구일까요?",
    answer: "빨간집모기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Culex_pipiens_2007-1.jpg/500px-Culex_pipiens_2007-1.jpg",
  },
  {
    id: "insects055", category: "insects", difficulty: "medium",
    question: "껍질 속에 몸을 숨기고 봄이 되어 나비로 변하기만을 기다리는 잠자는 성은 무엇일까요?",
    answer: "번데기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Cetoine_global.jpg/500px-Cetoine_global.jpg",
  },
  {
    id: "insects056", category: "insects", difficulty: "easy",
    question: "꿀을 찾아 아주 먼 길을 여행하는 부지런하고 노란색 줄무늬가 있는 친구는 누구일까요?",
    answer: "재래꿀벌",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Apis_cerana%2C_Asiatic_honey_bee_-_Khao_Yai_National_Park.jpg/500px-Apis_cerana%2C_Asiatic_honey_bee_-_Khao_Yai_National_Park.jpg",
  },
  {
    id: "insects057", category: "insects", difficulty: "medium",
    question: "물 표면을 스케이트 타듯이 미끄러져 다니는 신기한 발을 가진 곤충은 누구일까요?",
    answer: "소금쟁이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Aquarius_najas01.jpg/500px-Aquarius_najas01.jpg",
  },
  {
    id: "insects058", category: "insects", difficulty: "easy",
    question: "숲속의 청소부라 불리며 먹이를 찾아 부지런히 움직이는 개미 친구는 누구일까요?",
    answer: "곰개미",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Hard_work.jpg/500px-Hard_work.jpg",
  },
  {
    id: "insects059", category: "insects", difficulty: "medium",
    question: "여름철 나무 줄기에 붙어서 '매앰매앰' 하고 가장 큰 소리로 노래 부르는 숲속 최고의 가수야! 땅속에서 아주 오랜 시간 동안 애벌레로 살며 어른이 되기를 기다린 뒤 맑은 여름 하늘로 날아오른단다. 일주일 정도 짧게 살며 노래를 부르는 이 열정적인 곤충은 누구일까요?",
    answer: "매미",
  },
  {
    id: "insects060", category: "insects", difficulty: "easy",
    question: "예쁜 꽃들 사이를 날아다니며 꿀을 먹고 사는 숲속의 작은 요정은 누구일까요?",
    answer: "배추흰나비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Pieris.rapae.mounted.jpg/500px-Pieris.rapae.mounted.jpg",
  },
  // --- NEW FISH QUESTIONS (40 more) ---
  {
    id: "fish_marine061", category: "fish_marine", question: "몸이 납작하고 눈이 한쪽으로 쏠려 있는 바다의 넓적이는?", answer: "넙치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Paralichthys-olivaceus-Federal-Way-3583.jpg/500px-Paralichthys-olivaceus-Federal-Way-3583.jpg",
  },
  { id: "fish_marine062", category: "fish_marine", question: "지느러미가 화려하고 싸움을 잘해서 '베타'라고 불리는 물고기는?", answer: "베타" },
  { id: "fish_marine063", category: "fish_marine", question: "몸이 투명하고 뼈가 훤히 보이는 작은 물고기는?", answer: "뱅어" },
  { id: "fish_marine064", category: "fish_marine", question: "입이 뾰족하고 몸이 가늘며 물 표면을 헤엄치는 학을 닮은 물고기는?", answer: "학꽁치" },
  {
    id: "fish_marine065", category: "fish_marine", question: "바다의 산삼이라고 불리며 몸에 좋은 성분이 많은 해산물은?", answer: "전복",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/5/55/AbaloneOutside.jpg",
  },
  { id: "fish_marine066", category: "fish_marine", question: "다리가 10개이고 옆으로 걷지 않고 앞으로 걷는 게는?", answer: "밤게" },
  {
    id: "fish_marine067", category: "fish_marine", question: "껍질이 아주 딱딱하고 꼬리가 뾰족하며 살아있는 화석이라 불리는 친구는?", answer: "투구게",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Tachypleus_tridentatus.jpg/500px-Tachypleus_tridentatus.jpg",
  },
  {
    id: "fish_marine068", category: "fish_marine", question: "아주 깊은 바다에 살며 눈이 퇴화된 심해어는?", answer: "심해어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Messina_Straits_Chauliodus_sloani.jpg/500px-Messina_Straits_Chauliodus_sloani.jpg",
  },
  {
    id: "fish_marine069", category: "fish_marine", question: "고둥 껍데기를 집처럼 등에 지고 사는 귀여운 바다 친구는?",
    answer: "소라게",
    customOptions: ["소라게", "성게", "해삼"],
  },
  {
    id: "fish_marine070", category: "fish_marine", question: "몸에서 끈적한 액체가 나오고 바다의 청소부 역할을 하는 것은?", answer: "먹장어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Eptatretus_hexatrema_15727711.jpg/500px-Eptatretus_hexatrema_15727711.jpg",
  },
  {
    id: "fish_marine071", category: "fish_marine", question: "이빨이 앵무새 부리처럼 생긴 화려한 물고기는?", answer: "앵무고기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Scarus_frenatus_by_Ewa_Barska.jpg/500px-Scarus_frenatus_by_Ewa_Barska.jpg",
  },
  { id: "fish_marine072", category: "fish_marine", question: "노란색과 파란색 줄무늬가 있는 열대어의 여왕은?", answer: "엔젤피쉬" },
  {
    id: "fish_marine073", category: "fish_marine", question: "눈이 튀어나와 있고 갯벌을 껑충껑충 뛰어다니는 물고기는?",
    answer: "짱뚱어",
    customOptions: ["짱뚱어", "실고기", "학꽁치"],
  },
  {
    id: "fish_marine074", category: "fish_marine", question: "몸이 둥글고 가시가 돋아 있는 복어의 친구는?", answer: "가시복",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Long-spine_porcupinefish_%28Diodon_holocanthus%29.jpg/500px-Long-spine_porcupinefish_%28Diodon_holocanthus%29.jpg",
  },
  {
    id: "fish_marine075", category: "fish_marine", question: "길쭉한 입으로 먹이를 쏙 빨아들이는 해마의 사촌은?", answer: "실고기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/YojiUO.jpg/500px-YojiUO.jpg",
  },
  {
    id: "fish_marine076", category: "fish_marine", question: "지느러미가 화려하고 독이 있는 가시를 가진 물고기는?", answer: "쏠종개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Plotosidae_-_Plotosus_lineatus.jpg/500px-Plotosidae_-_Plotosus_lineatus.jpg",
  },
  {
    id: "fish_marine077", category: "fish_marine", question: "바다의 파인애플이라고 불리는 울퉁불퉁한 해산물은?", answer: "멍게",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Halocynthia_roretzi-Sea_pineapples_at_Tsukiji_Market-01.jpg/500px-Halocynthia_roretzi-Sea_pineapples_at_Tsukiji_Market-01.jpg",
  },
  {
    id: "fish_marine078", category: "fish_marine", question: "매끄러운 몸과 긴 수염을 가진 바다의 신사는?", answer: "물개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Northfursealbull.jpg/500px-Northfursealbull.jpg",
  },
  { id: "fish_marine079", category: "fish_marine", question: "상어 빨판을 가지고 상어 배에 붙어 사는 물고기는?", answer: "빨판상어" },
  {
    id: "fish_marine080", category: "fish_marine", question: "아주 커다란 입을 벌리고 플랑크톤을 먹는 가오리는?", answer: "쥐가오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Atlantic_mobula_lisbon.jpg/500px-Atlantic_mobula_lisbon.jpg",
  },
  {
    id: "fish_marine081", category: "fish_marine", question: "가을에 제철이며 집 나간 며느리도 돌아오게 한다는 물고기는?", answer: "전어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Konosirus_punctatus_in_store.jpg/500px-Konosirus_punctatus_in_store.jpg",
  },
  {
    id: "fish_marine082", category: "fish_marine", question: "눈이 아주 크고 빨간색 몸을 가진 깊은 바다 물고기는?", answer: "금눈돔",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Beryx_decadactylus.jpg/500px-Beryx_decadactylus.jpg",
  },
  {
    id: "fish_marine083", category: "fish_marine", question: "몸이 아주 길고 은색이며 칼처럼 생긴 물고기는?", answer: "갈치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Trichiurus_lepturus_by_OpenCage.jpg/500px-Trichiurus_lepturus_by_OpenCage.jpg",
  },
  {
    id: "fish_marine084", category: "fish_marine", question: "바다 밑바닥에 납작하게 엎드려 사는 홍어의 사촌은?", answer: "가오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Dasyatis_americana_bonaire.jpg/500px-Dasyatis_americana_bonaire.jpg",
  },
  { id: "fish_marine085", category: "fish_marine", question: "등이 굽어 있고 수염이 긴 바다의 노인 같은 새우는?", answer: "대하" },
  { id: "fish_marine086", category: "fish_marine", question: "껍질이 단단하고 살이 꽉 찬 바다의 킹!", answer: "킹크랩" },
  { id: "fish_marine087", category: "fish_marine", question: "다리가 8개이고 머리가 둥근 문어와 비슷하지만 더 작은 친구는?", answer: "쭈꾸미" },
  {
    id: "fish_marine088", category: "fish_marine", question: "다리가 10개이고 뼈가 있는 오징어의 친구는?", answer: "갑오징어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Kalamar.jpg/500px-Kalamar.jpg",
  },
  {
    id: "fish_marine089", category: "fish_marine", question: "바다의 우유라고 불리는 영양 만점 조개는?", answer: "굴",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Rock-oyster.jpg/500px-Rock-oyster.jpg",
  },
  {
    id: "fish_marine090", category: "fish_marine", question: "작고 귀여운 껍데기를 가진 바다의 주머니는?", answer: "꼬막",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Coque_blanche_%28Cerastoderma_edule%29.jpg/500px-Coque_blanche_%28Cerastoderma_edule%29.jpg",
  },
  { id: "fish_marine091", category: "fish_marine", question: "길쭉한 맛조개처럼 생겼지만 대나무처럼 생긴 조개는?", answer: "대나무조개" },
  {
    id: "fish_marine092", category: "fish_marine", question: "아주 큰 입으로 무엇이든 삼키는 바다의 먹보?", answer: "아귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Chaunax_stigmaeus_dorsal_view2.jpg/500px-Chaunax_stigmaeus_dorsal_view2.jpg",
  },
  { id: "fish_marine093", category: "fish_marine", question: "가시가 많지만 살이 맛있는 생선은?", answer: "도미" },
  {
    id: "fish_marine094", category: "fish_marine", question: "비늘이 없고 미끌미끌하며 추어탕의 재료가 되는 물고기는?", answer: "미꾸라지",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Misgurnus_fossilis_2009_G1.jpg/500px-Misgurnus_fossilis_2009_G1.jpg",
  },
  {
    id: "fish_marine095", category: "fish_marine", question: "일급수 맑은 물에만 사는 산천어의 친구는?", answer: "송어",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b8/Yamame.jpg",
  },
  { id: "fish_marine096", category: "fish_marine", question: "강과 바다를 오가며 사는 작은 물고기는?", answer: "은어" },
  {
    id: "fish_marine097", category: "fish_marine", question: "입이 삐죽 나와 있고 물을 쏘아 벌레를 잡는 물고기는?", answer: "물총고기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/ArcherFish01.jpg/500px-ArcherFish01.jpg",
  },
  { id: "fish_marine098", category: "fish_marine", question: "투명한 머리를 가진 심해의 신비한 물고기는?", answer: "배럴아이" },
  { id: "fish_marine099", category: "fish_marine", question: "세상에서 가장 못생긴 물고기로 불리는 친구는?", answer: "블롭피쉬" },
  {
    id: "fish_marine100", category: "fish_marine", question: "어두운 바다에서 스스로 빛을 내는 낚시꾼 물고기는?", answer: "초롱아귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Himantolophus_groenlandicus_by_OpenCage.jpg/500px-Himantolophus_groenlandicus_by_OpenCage.jpg",
  },

  // --- NEW ANIMAL QUESTIONS (40 more) ---
  {
    id: "animals061", category: "animals", question: "산타클로스 할아버지의 썰매를 끄는 사슴은?", answer: "순록",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Reinbukken_p%C3%A5_frisk_gr%C3%B8nt_beite._-_panoramio.jpg/500px-Reinbukken_p%C3%A5_frisk_gr%C3%B8nt_beite._-_panoramio.jpg",
  },
  { id: "animals062", category: "animals", question: "털이 복슬복슬하고 '메에' 하고 우는 양과 비슷한 동물은?", answer: "염소" },
  { id: "animals063", category: "animals", question: "아주 빠른 다리를 가졌고 경주를 좋아하는 동물은?", answer: "말" },
  {
    id: "animals064", category: "animals", question: "짐을 나르는 힘 센 동물로, 말과 비슷하지만 귀가 긴 친구는?", answer: "당나귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Donkey_%28Equus_asinus%29_at_Disney%27s_Animal_Kingdom_%2816-01-2005%29.jpg/500px-Donkey_%28Equus_asinus%29_at_Disney%27s_Animal_Kingdom_%2816-01-2005%29.jpg",
  },
  {
    id: "animals065", category: "animals", question: "코에 뿔이 나 있고 튼튼한 갑옷 같은 피부를 가진 동물은?", answer: "코뿔소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Rhinoceros_in_South_Africa_adjusted.jpg/500px-Rhinoceros_in_South_Africa_adjusted.jpg",
  },
  { id: "animals066", category: "animals", question: "아프리카 초원에 살며 떼를 지어 이동하는 소의 친척은?", answer: "누" },
  { id: "animals067", category: "animals", question: "커다란 뿔이 아주 멋진 사슴의 왕은?", answer: "엘크" },
  { id: "animals068", category: "animals", question: "사막에서 굴을 파고 사는 작은 여우는?", answer: "사막여우" },
  {
    id: "animals069", category: "animals", question: "눈 주변에 검은 무늬가 있어 안경 쓴 것 같은 곰은?", answer: "안경곰",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Spectacled_Bear_Tennoji_2.jpg/500px-Spectacled_Bear_Tennoji_2.jpg",
  },
  {
    id: "animals070", category: "animals", question: "나무 위에서 살며 꼬리가 긴 작은 곰 같은 동물은?", answer: "레서판다",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Ailurus_fulgens_RoterPanda_LesserPanda.jpg/500px-Ailurus_fulgens_RoterPanda_LesserPanda.jpg",
  },
  {
    id: "animals071", category: "animals", question: "하얀 털을 가졌고 북극의 얼음 위를 돌아다니는 여우는?", answer: "북극여우",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Arctic-fox.jpg/500px-Arctic-fox.jpg",
  },
  {
    id: "animals072", category: "animals", question: "물갈퀴가 있고 꼬리가 넓적한 댐 건설자는?", answer: "비버",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Beaver.jpg/500px-Beaver.jpg",
  },
  {
    id: "animals073", category: "animals", question: "가시가 돋친 몸으로 자신을 보호하는 산속의 작은 친구는?", answer: "고슴도치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d1/Erinaceus_amurensis.jpg",
  },
  {
    id: "animals074", category: "animals", question: "땅속에 굴을 파고 사는 토끼의 친척은?", answer: "굴토끼",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Oryctolagus_cuniculus_Tasmania_2.jpg/500px-Oryctolagus_cuniculus_Tasmania_2.jpg",
  },
  {
    id: "animals075", category: "animals", question: "뒷발로 깡충깡충 뛰며 권투를 잘하는 동물은?", answer: "캥거루",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Kangaroo1.jpg/500px-Kangaroo1.jpg",
  },
  {
    id: "animals076", category: "animals", question: "주머니에 아기를 넣고 다니는 캥거루보다 작은 동물은?", answer: "왈라비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Bennetwallaby.jpg",
  },
  {
    id: "animals077", category: "animals", question: "유칼립투스 잎만 먹고 하루 종일 잠만 자는 동물은?", answer: "코알라",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/A_koala_at_Featherdale_Wildlife_Park_2025_%286%29.jpg/500px-A_koala_at_Featherdale_Wildlife_Park_2025_%286%29.jpg",
  },
  {
    id: "animals078", category: "animals", question: "알을 낳는 포유류로, 오리 부리를 가진 신기한 동물은?", answer: "오리너구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Wild_Platypus_4.jpg/500px-Wild_Platypus_4.jpg",
  },
  {
    id: "animals079",
    category: "animals",
    question: "가시가 돋친 바늘두더지는 알을 낳을까요, 새끼를 낳을까요?",
    answer: "알을 낳아요",
    customOptions: ["알을 낳아요", "새끼를 낳아요", "둘 다 아니에요"],
  },
  {
    id: "animals080", category: "animals", question: "나무와 나무 사이를 날아다니는 다람쥐는?", answer: "하늘다람쥐",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Pteromys_volans.jpg/500px-Pteromys_volans.jpg",
  },
  {
    id: "animals081", category: "animals", question: "냄새 지독한 방귀를 뀌어 적을 쫓아내는 동물은?", answer: "스컹크",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/6/63/Striped_skunk.jpg",
  },
  {
    id: "animals082", category: "animals", question: "온몸이 비늘로 덮여 있고 공처럼 둥글게 말리는 동물은?", answer: "천산갑",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Manidae.jpg/500px-Manidae.jpg",
  },
  {
    id: "animals083", category: "animals", question: "개미를 핥아먹는 긴 혀를 가진 동물은?", answer: "개미핥기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/8/80/DirkvdM_tamandua.jpg",
  },
  {
    id: "animals084", category: "animals", question: "나무에 매달려 아주 느리게 움직이는 동물은?", answer: "나무늘보",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Bradypus.jpg/500px-Bradypus.jpg",
  },
  {
    id: "animals085", category: "animals", question: "팔이 길어서 나무를 잘 타는 숲속의 사람 같은 동물은?", answer: "오랑우탄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/7/70/Orangutangus.PNG",
  },
  {
    id: "animals086", category: "animals", question: "머리가 좋고 도구를 사용할 줄 아는 침팬지의 친구는?", answer: "보노보",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Apeldoorn_Apenheul_zoo_Bonobo.jpg/500px-Apeldoorn_Apenheul_zoo_Bonobo.jpg",
  },
  {
    id: "animals087", category: "animals", question: "얼굴에 화려한 색깔이 있는 원숭이의 리더는?", answer: "맨드릴",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Mandril.jpg/500px-Mandril.jpg",
  },
  {
    id: "animals088", category: "animals", question: "아주 작은 원숭이로 손가락만 한 크기는?", answer: "피그미마모셋",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Dv%C3%A6rgsilkeabe_Callithrix_pygmaea.jpg/500px-Dv%C3%A6rgsilkeabe_Callithrix_pygmaea.jpg",
  },
  { id: "animals089", category: "animals", question: "사자처럼 갈기가 있는 원숭이는?", answer: "사자원숭이" },
  {
    id: "animals090", category: "animals", question: "눈이 아주 크고 밤에 활동하는 원숭이는?", answer: "안경원숭이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Tarsier-GG.jpg/500px-Tarsier-GG.jpg",
  },
  {
    id: "animals091", category: "animals", question: "꼬리에 링 무늬가 있고 너구리를 닮은 동물은?", answer: "라쿤",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Raccoon_climbing_in_tree_-_Cropped_and_color_corrected.jpg/500px-Raccoon_climbing_in_tree_-_Cropped_and_color_corrected.jpg",
  },
  {
    id: "animals092", category: "animals", question: "사막의 파수꾼으로, 서서 망을 보는 동물은?", answer: "미어캣",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Suricata.suricatta.6861.jpg/500px-Suricata.suricatta.6861.jpg",
  },
  {
    id: "animals093", category: "animals", question: "고양이과 동물 중 가장 날렵하고 나무를 잘 타는 동물은?", answer: "표범",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Amur_leopard._Frame_from_a_camera_trap_%28cropped%29.jpg/500px-Amur_leopard._Frame_from_a_camera_trap_%28cropped%29.jpg",
  },
  { id: "animals094", category: "animals", question: "눈 덮인 산에 사는 신비한 표범은?", answer: "설표" },
  {
    id: "animals095", category: "animals", question: "검은색 털을 가진 멋진 표범은?", answer: "흑표범",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/5/5e/Blackleopard.JPG",
  },
  {
    id: "animals096", category: "animals", question: "귀 끝에 털이 뾰족하게 난 야생 고양이는?", answer: "스라소니",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Lynx_lynx2.jpg/500px-Lynx_lynx2.jpg",
  },
  {
    id: "animals097", category: "animals", question: "달리기가 가장 빠르고 눈물 자국 무늬가 있는 동물은?", answer: "치타",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cheetah_%28Acinonyx_jubatus%29_female_2.jpg/500px-Cheetah_%28Acinonyx_jubatus%29_female_2.jpg",
  },
  {
    id: "animals098", category: "animals", question: "물속에서 수영을 잘하고 조개를 까먹는 동물은?", answer: "해달",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Enhydra_lutris_face.jpg/500px-Enhydra_lutris_face.jpg",
  },
  {
    id: "animals099", category: "animals", question: "강가의 둑에 굴을 파고 사는 수달의 친구는?", answer: "수달",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Fischotter_Lutra_lutra1.jpg/500px-Fischotter_Lutra_lutra1.jpg",
  },
  { id: "animals100", category: "animals", question: "하얀 배를 드러내고 자는 숲속의 잠꾸러기는?", answer: "반달가슴곰" },

  // --- NEW INSECT QUESTIONS (40 more) ---
  { id: "insects061", category: "insects", question: "가을에 '귀뚤귀뚤' 우는 곤충은?", answer: "귀뚜라미" },
  {
    id: "insects062", category: "insects", question: "풀숲에서 '찌르르' 우는 초록색 곤충은?", answer: "여치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Gampsocleis_sedakovii_ssp._obscura_male.jpg/500px-Gampsocleis_sedakovii_ssp._obscura_male.jpg",
  },
  {
    id: "insects063", category: "insects", question: "아주 긴 더듬이를 가진 곤충은?", answer: "하늘소",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Neocerambyx_raddei.png/500px-Neocerambyx_raddei.png",
  },
  {
    id: "insects064", category: "insects", question: "물속에서 숨을 쉬기 위해 꼬리 대롱을 내놓는 곤충은?", answer: "장구애비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Laccotrephes_japonensis.jpg/500px-Laccotrephes_japonensis.jpg",
  },
  {
    id: "insects065", category: "insects", question: "물 위를 빙글빙글 도는 곤충은?", answer: "물방개",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG/500px-%E9%A3%BC%E8%82%B2%E4%B8%8B%E3%81%A7%E3%81%AE%E3%82%B2%E3%83%B3%E3%82%B4%E3%83%AD%E3%82%A6.JPG",
  },
  {
    id: "insects066", category: "insects", question: "똥을 굴려서 집으로 가져가는 부지런한 곤충은?", answer: "소똥구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Gymnopleurus_mopsus.jpg/500px-Gymnopleurus_mopsus.jpg",
  },
  { id: "insects067", category: "insects", question: "반짝반짝 빛나는 딱지날개를 가진 아름다운 곤충은?", answer: "비단벌레" },
  {
    id: "insects068", category: "insects", question: "나뭇가지처럼 생겨서 눈에 잘 띄지 않는 곤충은?", answer: "대벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Baculum_irregulariterdentatum.jpg/500px-Baculum_irregulariterdentatum.jpg",
  },
  { id: "insects069", category: "insects", question: "꽃처럼 생겨서 사마귀인 줄 모르게 숨어 있는 곤충은?", answer: "꽃사마귀" },
  { id: "insects070", category: "insects", question: "엉덩이에서 고약한 냄새를 풍기는 곤충은?", answer: "노린재" },
  { id: "insects071", category: "insects", question: "하루만 살고 죽는다고 잘못 알려진 곤충은?", answer: "하루살이" },
  {
    id: "insects072", category: "insects", question: "집 안에 살며 헌 책을 갉아먹는 작은 벌레는?", answer: "좀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Ctenolepisma_longicaudata_%28long-tailed_silverfish%29%2C_Mook%2C_the_Netherlands.JPG/500px-Ctenolepisma_longicaudata_%28long-tailed_silverfish%29%2C_Mook%2C_the_Netherlands.JPG",
  },
  {
    id: "insects073", category: "insects", question: "머리에 뿔이 하나 달린 힘센 장수풍뎅이는?", answer: "장수풍뎅이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Kabutomushi-JapaneseBeetle-July2004.jpg/500px-Kabutomushi-JapaneseBeetle-July2004.jpg",
  },
  {
    id: "insects074", category: "insects", question: "가위처럼 큰 턱을 가진 사슴벌레는?", answer: "사슴벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Lucanus70.JPG/500px-Lucanus70.JPG",
  },
  {
    id: "insects075", category: "insects", question: "반딧불이의 애벌레가 좋아하는 먹이는?", answer: "다슬기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Semisulcospira_kurodai2.jpg/500px-Semisulcospira_kurodai2.jpg",
  },
  {
    id: "insects076",
    category: "insects",
    question: "꿀벌이 춤을 추며 친구들에게 알려주는 것은?",
    answer: "꽃이 있는 곳",
    customOptions: ["꽃이 있는 곳", "비 오는 시간", "잠자는 방법"],
  },
  {
    id: "insects077", category: "insects", question: "여왕벌을 위해 일만 하는 벌은?", answer: "일벌",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Todd_Huffman_-_Lattice_%28by%29.jpg/500px-Todd_Huffman_-_Lattice_%28by%29.jpg",
  },
  {
    id: "insects078", category: "insects", question: "침이 아주 무섭고 꿀벌을 공격하는 나쁜 벌은?", answer: "장수말벌",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/20200512-P1100071_Vespa_mandarinia_japonica.jpg/500px-20200512-P1100071_Vespa_mandarinia_japonica.jpg",
  },
  { id: "insects079", category: "insects", question: "흙으로 집을 짓는 벌은?", answer: "호리병벌" },
  {
    id: "insects080",
    category: "insects",
    question: "나비의 입은 어떻게 생겼을까요?",
    answer: "빨대처럼 생겼어요",
    customOptions: ["빨대처럼 생겼어요", "숟가락처럼 생겼어요", "가위처럼 생겼어요"],
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Drink_with_straw.jpg/500px-Drink_with_straw.jpg",
  },
  {
    id: "insects081",
    category: "insects",
    question: "나비의 날개에 있는 가루는 무엇일까요?",
    answer: "비늘가루",
    customOptions: ["비늘가루", "솜털", "모래"],
  },
  {
    id: "insects082",
    category: "insects",
    question: "누에나방의 애벌레가 짓는 집은?",
    answer: "고치",
    customOptions: ["고치", "개미집", "벌집"],
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Actias_luna_cocoons_sjh.JPG/500px-Actias_luna_cocoons_sjh.JPG",
  },
  { id: "insects083", category: "insects", question: "옷을 갉아먹는 나방의 애벌레는?", answer: "좀나방" },
  {
    id: "insects084", category: "insects", question: "불빛을 보고 모여드는 털이 많은 곤충은?", answer: "나방",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Polyphemus_Moth.jpg/500px-Polyphemus_Moth.jpg",
  },
  {
    id: "insects085",
    category: "insects",
    question: "거미는 곤충일까요, 아닐까요?",
    answer: "아니에요",
    customOptions: ["곤충이에요", "아니에요", "잘 모르겠어요"],
  },
  { id: "insects086", category: "insects", question: "거미줄을 치지 않고 땅 위를 돌아다니며 사냥하는 거미는?", answer: "늑대거미" },
  { id: "insects087", category: "insects", question: "아주 큰 거미로 새도 잡아먹는다는 거미는?", answer: "타란튤라" },
  {
    id: "insects088",
    category: "insects",
    question: "전갈은 꼬리에 무엇이 있을까요?",
    answer: "독침",
    customOptions: ["독침", "리본", "집게"],
  },
  {
    id: "insects089",
    category: "insects",
    question: "지네는 다리가 많을까요, 적을까요?",
    answer: "많아요",
    customOptions: ["많아요", "적어요", "하나도 없어요"],
  },
  {
    id: "insects090",
    category: "insects",
    question: "공벌레를 건드리면 어떻게 될까요?",
    answer: "동그랗게 말려요",
    customOptions: ["동그랗게 말려요", "하늘로 날아요", "색이 바뀌어요"],
  },
  {
    id: "insects091",
    category: "insects",
    question: "노래기에서는 무슨 냄새가 날까요?",
    answer: "고약한 냄새",
    customOptions: ["고약한 냄새", "달콤한 냄새", "아무 냄새도 안 나요"],
  },
  {
    id: "insects092",
    category: "insects",
    question: "달팽이는 곤충일까요?",
    answer: "아니에요",
    customOptions: ["곤충이에요", "아니에요", "잘 모르겠어요"],
  },
  {
    id: "insects093",
    category: "insects",
    question: "지렁이는 눈이 있을까요?",
    answer: "없어요",
    customOptions: ["없어요", "두 개 있어요", "여섯 개 있어요"],
  },
  {
    id: "insects094",
    category: "insects",
    question: "개미는 페로몬으로 무엇을 할까요?",
    answer: "서로 신호를 주고받아요",
    customOptions: ["서로 신호를 주고받아요", "잠을 더 오래 자요", "색을 바꿔요"],
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Meat_eater_ant_feeding_on_honey02.jpg/500px-Meat_eater_ant_feeding_on_honey02.jpg",
  },
  {
    id: "insects095",
    category: "insects",
    question: "흰개미는 나무를 먹을까요?",
    answer: "먹어요",
    customOptions: ["먹어요", "안 먹어요", "물에서만 먹어요"],
  },
  {
    id: "insects096", category: "insects", question: "진딧물의 천적은 누구일까요?", answer: "무당벌레",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Asian_lady_beetle-%28Harmonia-axyridis%29.jpg/500px-Asian_lady_beetle-%28Harmonia-axyridis%29.jpg",
  },
  {
    id: "insects097", category: "insects", question: "개미가 키우는 가축이라고 불리는 곤충은?", answer: "진딧물",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Aphidoidea_fight.jpg/500px-Aphidoidea_fight.jpg",
  },
  {
    id: "insects098",
    category: "insects",
    question: "물방개의 애벌레는 무엇을 먹을까요?",
    answer: "올챙이",
    customOptions: ["올챙이", "꽃가루", "나뭇잎"],
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Bullfrog_Tadpole.jpg/500px-Bullfrog_Tadpole.jpg",
  },
  {
    id: "insects099",
    category: "insects",
    question: "잠자리의 애벌레 이름은?",
    answer: "수채",
    customOptions: ["수채", "고치", "번데기"],
  },
  {
    id: "insects100",
    category: "insects",
    question: "매미는 땅속에서 얼마나 오래 살까요?",
    answer: "여러 해",
    customOptions: ["여러 해", "하루만", "한 달만"],
  },

  // --- BIRDS QUESTIONS (20 questions) ---
  {
    id: "birds001", category: "birds", difficulty: "easy",
    question: "하얀 눈처럼 깨끗한 털을 가진 평화의 상징인 새야! 구구구 소리를 내며 나뭇가지에 집을 짓고 산단다. 편지를 전해주는 아주 영리한 친구로도 알려져 있고, 우리 주변 공원에서 아주 쉽게 만나볼 수 있는 이 친근한 새는 누구일까요?",
    answer: "비둘기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Feral_pigeon_%28Columba_livia_domestica%29_in_London.jpg/500px-Feral_pigeon_%28Columba_livia_domestica%29_in_London.jpg",
  },
  {
    id: "birds002", category: "birds", difficulty: "easy",
    question: "검은색과 하얀색 옷을 멋지게 차려입은 숲속의 신사야! 아침마다 반가운 손님이 올 때 깍깍 소리를 내며 소식을 전해준다고 믿어왔단다. 나뭇가지 끝에 튼튼한 집을 짓고 사는 아주 영리하고 용감한 이 새는 누구일까요?",
    answer: "까치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Pica_pica_-_Common_Magpie_01.jpg/500px-Pica_pica_-_Common_Magpie_01.jpg",
  },
  {
    id: "birds003", category: "birds", difficulty: "easy",
    question: "작고 귀여운 갈색 몸에 하얀 뺨을 가진 우리 주변의 귀염둥이야! 짹짹하며 즐겁게 노래 부르고 가을에는 곡식을 먹으러 논에 나타나기도 한단다. 예로부터 우리와 아주 가깝게 지내온 작고 소중한 이 새는 누구일까요?",
    answer: "참새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Tree_Sparrow_July_2009_Osaka_Japan.jpg/500px-Tree_Sparrow_July_2009_Osaka_Japan.jpg",
  },
  {
    id: "birds004", category: "birds", difficulty: "medium",
    question: "머리 위에 멋진 깃털 왕관을 쓰고 화려한 줄무늬 날개를 가진 특별한 새야! 긴 부리로 땅속 벌레를 잘 찾고 나무 구멍에 집을 짓고 살지. 멀리서도 눈에 띄는 독특한 모양을 가진 이 새는 누구일까요?",
    answer: "후투티",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Hoopoe_%28Upupa_epops%29_2.jpg/500px-Hoopoe_%28Upupa_epops%29_2.jpg",
  },
  {
    id: "birds005", category: "birds", difficulty: "easy",
    question: "커다란 날개를 활짝 펴고 하늘 높이 날아다니는 용맹한 사냥꾼이야! 아주 먼 곳까지 볼 수 있는 밝은 눈과 단단한 갈고리 부리를 가졌단다. 높은 하늘에서 먹이를 발견하면 빠르게 내려와 발톱으로 낚아채는 이 멋진 새는 누구일까요?",
    answer: "검독수리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Golden_Eagle_in_flight_2.jpg/500px-Golden_Eagle_in_flight_2.jpg",
  },
  {
    id: "birds006", category: "birds", difficulty: "medium",
    question: "밤이 되면 커다란 눈을 번쩍이며 숲속을 지키는 밤의 파수꾼이야! 고개를 뒤로 휙휙 돌릴 수 있고 소리 없이 날아서 쥐를 잡는 사냥의 명수란다. 낮에는 잠을 자고 밤에 활동하는 지혜로운 이 새는 누구일까요?",
    answer: "부엉이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Eurasian_Eagle_Owl_Kruidhof.JPG/500px-Eurasian_Eagle_Owl_Kruidhof.JPG",
  },
  {
    id: "birds007", category: "birds", difficulty: "medium",
    question: "다른 새의 둥지에 몰래 알을 낳아 키우게 하는 얌체 같지만 신비한 새야! '뻐꾹뻐꾹' 정겨운 소리를 내어 우리에게 봄 소식을 가장 먼저 알려준단다. 여름에 찾아오는 철새로 숲속 깊은 곳에서 노래하는 이 새는 누구일까요?",
    answer: "뻐꾸기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Common_Cuckoo_%28Cuculus_canorus%29.jpg/500px-Common_Cuckoo_%28Cuculus_canorus%29.jpg",
  },
  {
    id: "birds008", category: "birds", difficulty: "easy",
    question: "추운 남극의 얼음 위에서 뒤뚱뒤뚱 걷는 귀여운 신사야! 날개가 있지만 하늘을 날지는 못하고 대신 바닷속을 물고기처럼 아주 빠르게 헤엄친단다. 배는 하얗고 등은 검은색인 이 멋진 수영 선수는 누구일까요?",
    answer: "펭귄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Emperor_Penguin_Manchot_empereur.jpg/500px-Emperor_Penguin_Manchot_empereur.jpg",
  },
  {
    id: "birds009", category: "birds", difficulty: "easy",
    question: "세상에서 가장 몸집이 크고 다리가 아주 튼튼해서 엄청나게 빨리 달리는 새야! 몸이 너무 무거워 하늘을 날지는 못하지만 위협을 느끼면 강력한 발차기를 한단다. 커다란 눈과 긴 목을 가진 사막의 달리기 왕은 누구일까요?",
    answer: "타조",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Ostrich_male_amboseli.jpg/500px-Ostrich_male_amboseli.jpg",
  },
  {
    id: "birds010", category: "birds", difficulty: "medium",
    question: "벌처럼 아주 작고 날개를 엄청나게 빨리 저어 공중에 가만히 떠 있을 수 있어! 꽃 속의 달콤한 꿀을 먹으며 꽃가루를 옮겨주는 꽃의 친구란다. 알록달록 무지개 빛깔 깃털을 가진 세상에서 가장 작은 이 새는 누구일까요?",
    answer: "벌새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Broad-tailed_Hummingbird_at_feeder.jpg/500px-Broad-tailed_Hummingbird_at_feeder.jpg",
  },
  {
    id: "birds011", category: "birds", difficulty: "easy",
    question: "바닷가나 항구에서 '끼룩끼룩' 소리를 내며 하늘을 나는 바다의 친구야! 물고기를 잡기도 하고 가끔은 사람들이 주는 과자를 뺏어 먹기도 하는 장난꾸러기지. 하얀 날개와 노란 부리를 가진 이 바다 새는 누구일까요?",
    answer: "갈매기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Larus_canus1.jpg/500px-Larus_canus1.jpg",
  },
  {
    id: "birds012", category: "birds", difficulty: "easy",
    question: "사람의 말을 아주 잘 흉내 내는 똑똑하고 화려한 숲속의 재주꾼이야! 초록색, 빨간색 등 알록달록한 옷을 입고 정글에서 살며 과일이나 견과류를 좋아한단다. 사람과 친구가 될 수 있는 매력 만점 이 새는 누구일까요?",
    answer: "앵무새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Macaw_at_Jurong_Bird_Park.jpg/500px-Macaw_at_Jurong_Bird_Park.jpg",
  },
  {
    id: "birds013", category: "birds", difficulty: "medium",
    question: "긴 다리와 긴 목을 가진 우아하고 깨끗한 물가의 귀족 같은 새야! 논이나 냇가에서 조용히 서 있다가 긴 부리로 물고기를 콕 찍어 잡는단다. 온몸이 하얀 깃털로 덮여 있어 마치 천사처럼 보이는 이 예쁜 새는 누구일까요?",
    answer: "백로",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Egretta_garzetta_1_italy.jpg/500px-Egretta_garzetta_1_italy.jpg",
  },
  {
    id: "birds014", category: "birds", difficulty: "hard",
    question: "부리가 몸집만큼이나 엄청나게 크고 화려한 색깔을 가진 정글의 멋쟁이야! 커다란 부리는 보기와 다르게 아주 가벼워서 나무 위를 날아다니기에 편하단다. 바나나나 열매를 좋아하며 무지개 같은 부리를 뽐내는 이 새는 누구일까요?",
    answer: "토코투칸",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Tucan_Toco_1.jpg/500px-Tucan_Toco_1.jpg",
  },
  {
    id: "birds015", category: "birds", difficulty: "easy",
    question: "호수 위를 우아하게 떠다니는 하얀 깃털의 아름다운 여왕이야! 긴 목을 S자 모양으로 굽히고 물속의 풀을 뜯어 먹으며 평화롭게 산단다. 동화 '미운 아기 오리'가 자라서 변신한 것으로 유명한 이 고급스러운 새는 누구일까요?",
    answer: "백조",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Mute_swan_at_Stotfold_Mill.jpg/500px-Mute_swan_at_Stotfold_Mill.jpg",
  },
  {
    id: "birds016", category: "birds", difficulty: "medium",
    question: "한쪽 다리로 서 있는 모습이 아주 신기하고 핑크빛 옷을 입은 물의 요정이야! 갯벌이나 호수에서 부리를 물속에 넣고 먹이를 걸러 먹는 독특한 습관이 있단다. 새우나 게를 많이 먹어서 깃털이 예쁜 분홍색이 된 이 새는 누구일까요?",
    answer: "플라밍고",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Greater_flamingo_Lesser_flamingo.jpg/500px-Greater_flamingo_Lesser_flamingo.jpg",
  },
  {
    id: "birds017", category: "birds", difficulty: "easy",
    question: "농장에서 사는 아주 친근한 새야! 머리 위에 빨간 볏이 있는 친구도 있고, 우리가 먹는 달걀을 낳는 가족으로도 잘 알려져 있단다. '꼬끼오' 하며 아침을 알리는 모습으로도 유명한 이 새는 누구일까요?",
    answer: "닭",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cock-Side_View_2-08.jpg/500px-Cock-Side_View_2-08.jpg",
  },
  {
    id: "birds018", category: "birds", difficulty: "easy",
    question: "노란색 작은 몸에 귀여운 부리를 가진 마당의 인기 만점 꼬마 친구야! 삐약삐약 소리를 내며 엄마 닭을 쫄쫄 따라다니는 모습이 정말 사랑스럽단다. 부드러운 털을 가지고 씨앗을 콕콕 쪼아 먹는 이 아기 새는 누구일까요?",
    answer: "병아리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Day_Old_Chick_sitting.jpg/500px-Day_Old_Chick_sitting.jpg",
  },
  {
    id: "birds019", category: "birds", difficulty: "easy",
    question: "물을 아주 좋아하고 발에 물갈퀴가 있어 수영을 정말 잘하는 뒤뚱뒤뚱 친구야! 노란 부리로 '꽉꽉' 소리를 내며 호수에서 친구들과 장난치는 걸 좋아한단다. 엉덩이를 실룩거리며 걷는 모습이 재미있는 이 귀여운 새는 누구일까요?",
    answer: "오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Anas_platyrhynchos_male_female_quadrat.jpg/500px-Anas_platyrhynchos_male_female_quadrat.jpg",
  },
  {
    id: "birds020", category: "birds", difficulty: "medium",
    question: "나무줄기를 부리로 '톡톡톡' 두드려 속에 숨은 벌레를 잡아먹는 숲속의 의사 선생님이야! 아주 튼튼한 부리와 긴 혀를 가지고 있으며 꼬리 깃털로 몸을 지탱하며 나무에 매달린단다. 숲을 건강하게 지켜주는 고마운 이 새는 누구일까요?",
    answer: "딱따구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/DendrocoposMajor.jpg/500px-DendrocoposMajor.jpg",
  },
  {
    id: "birds021", category: "birds", difficulty: "hard",
    question: "머리 위에 빨간 깃털 점이 있고 나무줄기를 수직으로 오르내리는 산속의 작은 대장님이야! '뵤뵤뵤' 하는 독특한 울음소리를 내며 썩은 나무속의 벌레를 찾아 먹는단다. 우리나라 산에서 흔히 볼 수 있는 아주 부지런한 이 새는 누구일까요?",
    answer: "오색딱따구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/DendrocoposMajor.jpg/500px-DendrocoposMajor.jpg",
  },
  {
    id: "birds022", category: "birds", difficulty: "medium",
    question: "겨울이 되면 우리나라를 찾아오는 아주 반가운 손님으로, 하늘을 'V'자 모양으로 줄지어 날아가는 멋쟁이야! 논에서 떨어진 이삭을 주워 먹으며 추운 겨울을 보내고 봄이 되면 다시 북쪽으로 떠난단다. 회갈색 깃털과 주황색 발을 가진 이 겨울 철새는 누구일까요?",
    answer: "기러기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Anser_anser_1_%288919121322%29.jpg/500px-Anser_anser_1_%288919121322%29.jpg",
  },
  {
    id: "birds023", category: "birds", difficulty: "medium",
    question: "머리에 멋진 깃털 장식이 있고 꼬리 깃털을 부채처럼 활짝 펴는 화려한 숲속의 주인공이야! 수컷은 눈부시게 아름다운 무지개색 날개를 뽐내며 암컷에게 사랑을 고백한단다. 커다란 눈 모양 무늬가 가득한 꼬리를 가진 이 화려한 새는 누구일까요?",
    answer: "공작",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Peacock_Plumage.jpg/500px-Peacock_Plumage.jpg",
  },
  {
    id: "birds024", category: "birds", difficulty: "medium",
    question: "얼굴이 하트 모양으로 생겨서 아주 귀엽고 신비로운 밤의 사냥꾼이야! 소리 없이 날아다니며 쥐를 잘 잡아서 농부들에게 아주 인기가 많은 고마운 친구란다. 하얀 깃털과 커다란 눈을 가진 이 신비스러운 새는 누구일까요?",
    answer: "가면올빼미",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Tyto_alba_close_up.jpg/500px-Tyto_alba_close_up.jpg",
  },
  {
    id: "birds025", category: "birds", difficulty: "medium",
    question: "여름철 논이나 개울가에서 긴 다리로 우아하게 걷는 노란 부리의 멋쟁이야! 물고기를 잡기 위해 한참 동안 가만히 서 있는 모습이 마치 명상을 하는 것 같단다. 온몸이 뽀얀 하얀색이고 날개가 아주 큰 이 새는 누구일까요?",
    answer: "중대백로",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Egretta_garzetta_1_italy.jpg/500px-Egretta_garzetta_1_italy.jpg",
  },
  {
    id: "birds026", category: "birds", difficulty: "hard",
    question: "머리와 가슴 쪽이 검고 부리가 아주 길어서 갯벌 속의 먹이를 잘 찾아 먹는 용감한 새야! 밝은 주황빛 부리와 다리가 눈에 띄고 우리나라 서해안 갯벌에서도 만날 수 있는 친구란다. 바다 가까운 곳을 좋아하는 이 새는 누구일까요?",
    answer: "검은머리물떼새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Haematopus_ostralegus_walking.jpg/500px-Haematopus_ostralegus_walking.jpg",
  },
  {
    id: "birds027", category: "birds", difficulty: "medium",
    question: "호수나 강가에서 물속으로 쏜살같이 들어가 물고기를 사냥하는 사냥의 달인이야! 선명한 주황색 배와 비취색 등을 가진 아주 아름다운 옷을 입었단다. 뾰족하고 긴 부리를 가진 물가의 보석이라고 불리는 이 새는 누구일까요?",
    answer: "물총새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Alcedo_atthis_2_%28Lukasz_Lukasik%29.jpg/500px-Alcedo_atthis_2_%28Lukasz_Lukasik%29.jpg",
  },
  {
    id: "birds028", category: "birds", difficulty: "hard",
    question: "절벽이나 높은 건물에 둥지를 틀고 세상에서 가장 빠른 속도로 하늘을 날아다니는 멋진 사냥꾼이야! 먹이를 발견하면 날개를 접고 아래로 쌩! 하고 낙하하며 먹이를 낚아챈단다. 하늘의 무법자라고 불리는 아주 용맹한 이 새는 누구일까요?",
    answer: "매",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Falco_peregrinus_-Morro_Rock%2C_California%2C_USA_-adult-8.jpg/500px-Falco_peregrinus_-Morro_Rock%2C_California%2C_USA_-adult-8.jpg",
  },
  {
    id: "birds029", category: "birds", difficulty: "medium",
    question: "머리에 커다란 주머니 같은 부리가 있어 물고기를 통째로 담아 먹는 신기한 바다의 사냥꾼이야! 하얀 날개를 활짝 펴고 물 위를 유유히 떠다니며 친구들과 함께 사냥을 즐긴단다. 아주 독특한 부리를 가진 이 새는 누구일까요?",
    answer: "펠리컨",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Great_White_Pelican_Manchot_empereur.jpg/500px-Great_White_Pelican_Manchot_empereur.jpg",
  },
  {
    id: "birds030", category: "birds", difficulty: "medium",
    question: "날개가 아주 길어서 한 번도 쉬지 않고 바다 위를 며칠 동안 날아다닐 수 있는 대단한 여행가야! 거센 바람을 타고 하늘 높이 솟구쳐 오르는 모습이 정말 웅장하단다. 바다의 제왕이라고 불리는 아주 커다란 날개를 가진 이 새는 누구일까요?",
    answer: "알바트로스",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Wandering_Albatross_in_flight.jpg/500px-Wandering_Albatross_in_flight.jpg",
  },
  {
    id: "birds031", category: "birds", difficulty: "medium",
    question: "나무 구멍 속에 알을 낳고 암컷이 나가지 못하게 진흙으로 입구를 막아 정성껏 아기를 키우는 독특한 새야! 수컷은 구멍 사이로 먹이를 넣어주며 가족을 지키는 사랑꾼이란다. 아주 크고 구부러진 부리를 가진 정글의 수호신은 누구일까요?",
    answer: "코뿔새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Great_Hornbill_%28Buceros_bicornis%29.jpg/500px-Great_Hornbill_%28Buceros_bicornis%29.jpg",
  },
  {
    id: "birds032", category: "birds", difficulty: "medium",
    question: "하늘 높이 솟구쳐 올라서 '지르르 지르르' 예쁘고 맑은 목소리로 노래하는 초원의 가수야! 보리밭이나 풀밭에 집을 짓고 살며 아주 높이 날아가는 특징이 있단다. 봄날 하늘에서 들려오는 행복한 노래의 주인공인 이 새는 누구일까요?",
    answer: "종다리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Sky_Lark_Lanius_bucephalus.jpg/500px-Sky_Lark_Lanius_bucephalus.jpg",
  },
  {
    id: "birds041", category: "birds", difficulty: "medium",
    question: "머리 위에 삐죽삐죽 솟은 깃털이 마치 왕관을 쓴 것처럼 멋진 숲속의 가수야! '직직' 하는 소리를 내며 나무 사이를 바쁘게 날아다니고 열매나 벌레를 아주 맛있게 먹는단다. 회갈색 털에 뺨에는 귀여운 갈색 점이 있는 이 새는 누구일까요?",
    answer: "직박구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Brown-eared_Bulbul_Hypsipetes_amaurotis.jpg/500px-Brown-eared_Bulbul_Hypsipetes_amaurotis.jpg",
  },
  {
    id: "birds042", category: "birds", difficulty: "medium",
    question: "겨울철 논이나 밭에서 커다란 무리를 붙어 다니며 '기럭기럭' 소리를 내는 하늘의 여행가야! 추운 북쪽 나라에서 날아와 따뜻한 남쪽에서 겨울을 나고 다시 돌아가는 아주 부지런한 친구란다. 줄지어 날아가는 모습이 정말 멋진 이 겨울 기사님은 누구일까요?",
    answer: "쇠기러기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Greater_White-fronted_Goose_Anser_albifrons.jpg/500px-Greater_White-fronted_Goose_Anser_albifrons.jpg",
  },
  {
    id: "birds043", category: "birds", difficulty: "hard",
    question: "부리가 숫가락처럼 넓적하게 생겨서 얕은 물 속을 휘저으며 먹이를 걸러 먹는 신기한 오리야! 수컷은 머리가 반짝이는 초록색이고 가슴은 하얀색인 아주 화려한 옷을 입었단다. 독특한 부리 모양 때문에 한 번 보면 잊을 수 없는 이 새는 누구일까요?",
    answer: "넓적부리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Northern_Shoveler_Spatula_clypeata.jpg/500px-Northern_Shoveler_Spatula_clypeata.jpg",
  },
  {
    id: "birds044", category: "birds", difficulty: "medium",
    question: "꼬리 깃털이 아주 길고 예쁘며 숲속에서 '홀딱벗고' 하는 독특한 소리로 노래하는 신비로운 새야! 머리에는 파란색 깃털이 있고 몸은 갈색인 아주 세련된 차림을 하고 있단다. 깊은 산속에서 만날 수 있는 이 아름다운 가수는 누구일까요?",
    answer: "검은등뻐꾸기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Common_Cuckoo_%28Cuculus_canorus%29.jpg/500px-Common_Cuckoo_%28Cuculus_canorus%29.jpg",
  },
  {
    id: "birds045", category: "birds", difficulty: "hard",
    question: "눈썹 위에 하얀 줄이 있어 아주 귀엽고 또렷해 보이는 숲속 친구야! 나뭇가지 사이를 바쁘게 날아다니며 작은 벌레를 잡아먹는 아주 부지런한 성격을 가졌단다. 여름철 숲에서 만날 수 있는 이 작은 새는 누구일까요?",
    answer: "흰눈썹황금새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Ficedula_zanthopygia_male.jpg/500px-Ficedula_zanthopygia_male.jpg",
  },
  {
    id: "birds046", category: "birds", difficulty: "medium",
    question: "머리는 검은색이고 뺨은 하얀색인 아주 깔끔한 디자인의 옷을 입은 숲속의 요정이야! 박새와 비슷하게 생겼지만 조금 더 크고 씩씩하게 노래부르는 모습이 인상적인 친구란다. 나무 구멍에 둥지를 틀고 정성껏 아기를 키우는 이 새는 누구일까요?",
    answer: "곤줄박이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Varied_Tit_Sittiparus_varius.jpg/500px-Varied_Tit_Sittiparus_varius.jpg",
  },
  {
    id: "birds047", category: "birds", difficulty: "medium",
    question: "온몸이 샛노란 금가루를 뿌려놓은 듯 화려하고 눈 주변에는 검은 안경 무늬가 있는 숲속의 미남이야! 꾀꼬리 같은 목소리라는 말의 주인공답게 아주 맑고 고운 노래를 부른단다. 여름에 우리나라를 찾아와 아름다운 노래를 들려주는 이 새는 누구일까요?",
    answer: "꾀꼬리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Eurasian_Golden_Oriole_Oriolus_oriolus.jpg/500px-Eurasian_Golden_Oriole_Oriolus_oriolus.jpg",
  },
  {
    id: "birds048", category: "birds", difficulty: "hard",
    question: "바다의 절벽에 살며 부리가 알록달록 무지개 색깔인 아주 귀엽고 우스꽝스러운 외모의 새야! 짧은 날개를 파닥거리며 바다 위를 날다가 물속으로 쏙 잠수해서 물고기를 잡는단다. 광대처럼 생긴 코믹한 얼굴을 가진 이 바다 새는 누구일까요?",
    answer: "퍼핀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Puffin_Latrabjarg_Iceland.jpg/500px-Puffin_Latrabjarg_Iceland.jpg",
  },
  {
    id: "birds049", category: "birds", difficulty: "medium",
    question: "커다란 날개를 가지고 하늘 높이 유유히 떠다니며 죽은 동물을 찾아 청소해주는 숲속의 환경 미화원이야! 머리에 털이 별로 없어서 조금 무섭게 보일 수도 있지만 생태계를 깨끗하게 유지해주는 아주 고마운 친구란다. 웅장한 날개짓을 보여주는 이 새는 누구일까요?",
    answer: "독수리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Golden_Eagle_in_flight_2.jpg/500px-Golden_Eagle_in_flight_2.jpg",
  },
  {
    id: "birds050", category: "birds", difficulty: "medium",
    question: "사람들이 사는 마을 근처 연못이나 냇가에서 뒤뚱뒤뚱 헤엄치는 아주 친근한 물새야! 부리가 납작하고 노란색이며 '꽉꽉' 소리를 내며 친구들과 수다 떠는 걸 좋아한단다. 물갈퀴가 있는 발로 물살을 가르며 수영하는 이 귀여운 친구는 누구일까요?",
    answer: "흰뺨검둥오리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Anas_zonorhyncha_male.jpg/500px-Anas_zonorhyncha_male.jpg",
  },
  {
    id: "birds051", category: "birds", difficulty: "medium",
    question: "꼬리를 위아래로 까딱까딱 흔들며 냇가를 바쁘게 걸어 다니는 귀여운 물가의 친구야! 얕은 물가나 돌 위를 폴짝폴짝 오가며 작은 벌레를 잡아먹고, 맑은 소리로 노래하기도 한단다. 아주 작은 몸집에 부지런한 성격을 가진 이 새는 누구일까요?",
    answer: "할미새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/White_Wagtail_Motacilla_alba.jpg/500px-White_Wagtail_Motacilla_alba.jpg",
  },
  {
    id: "birds052", category: "birds", difficulty: "hard",
    question: "호랑이 무늬처럼 갈색 줄무늬가 몸 전체에 가득해서 숲속에서 완벽하게 숨을 수 있는 신비로운 새야! 밤이 되면 '포! 포!' 하는 독특한 소리를 내며 활동하고 낮에는 나무 뒤에서 잠을 잔단다. 숲속의 위장술사라고 불리는 이 신비한 새는 누구일까요?",
    answer: "호랑지빠귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/White%27s_Thrush_Zoothera_dauma.jpg/500px-White%27s_Thrush_Zoothera_dauma.jpg",
  },
  {
    id: "birds053", category: "birds", difficulty: "medium",
    question: "머리가 검은색이고 넥타이를 맨 것처럼 가슴에 검은 줄무늬가 있는 아주 단정한 숲속의 신사야! 박새과 중에서도 가장 흔하게 볼 수 있고 '찌찌찌' 하며 명랑한 소리로 노래부르는 귀염둥이란다. 우리 주변 공원에서도 자주 만날 수 있는 이 새는 누구일까요?",
    answer: "박새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Great_Tit_Parus_major.jpg/500px-Great_Tit_Parus_major.jpg",
  },
  {
    id: "birds054", category: "birds", difficulty: "hard",
    question: "부리가 숫가락처럼 생겼는데 끝이 평평하고 까만색인 아주 독특한 모습을 한 물새야! 얕은 물 속에서 부리를 좌우로 저으며 작은 먹이를 찾아내는 특별한 사냥법을 가지고 있단다. 전 세계적으로 아주 희귀해서 보호받아야 하는 소중한 이 새는 누구일까요?",
    answer: "저어새",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Black-faced_Spoonbill_Platalea_minor.jpg/500px-Black-faced_Spoonbill_Platalea_minor.jpg",
  },
  {
    id: "birds055", category: "birds", difficulty: "hard",
    question: "겨울철 바닷가 절벽이나 섬에서 물속으로 깊게 잠수해서 물고기를 잡는 잠수의 왕자야! 온몸이 까만색이고 날개는 짧지만 발에는 큰 물갈퀴가 있어 잠수하기에 아주 유리하게 생겼단다. 바다의 잠수함이라고 불리는 이 용감한 새는 누구일까요?",
    answer: "가마우지",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Great_Cormorant_Phalacrocorax_carbo.jpg/500px-Great_Cormorant_Phalacrocorax_carbo.jpg",
  },
  {
    id: "birds056", category: "birds", difficulty: "medium",
    question: "머리 위에 빨간 깃털이 있고 화려한 무늬가 있는 옷을 입은 숲속의 사냥꾼이야! 나무를 부리로 '톡톡톡' 두드리는 소리가 숲속 어디서나 들려오고 썩은 나무 속의 벌레들을 치료해주듯 잡아먹는단다. 아주 건강한 숲의 지킴이인 이 새는 누구일까요?",
    answer: "쇠딱따구리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/DendrocoposMajor.jpg/500px-DendrocoposMajor.jpg",
  },
  {
    id: "birds057", category: "birds", difficulty: "hard",
    question: "산호초 사이를 헤엄치는 물고기처럼 아주 화려한 원색의 깃털을 가진 남쪽 나라의 아름다운 새야! 부리가 아주 크고 힘이 세서 딱딱한 열매도 잘 깨뜨려 먹고 사람과도 친구가 될 수 있는 아주 영리한 친구란다. 정글의 보물 같은 이 새는 누구일까요?",
    answer: "금강앵무",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Macaw_at_Jurong_Bird_Park.jpg/500px-Macaw_at_Jurong_Bird_Park.jpg",
  },
  {
    id: "birds058", category: "birds", difficulty: "medium",
    question: "하늘 높이 멈춰 서서 날개를 파닥거리며 아래에 있는 생쥐를 노려보는 아주 멋진 매의 사촌이야! '정지 비행'이라는 특별한 기술을 가지고 있으며 공중에서 가만히 떠 있는 모습이 정말 신기하단다. 날카로운 눈과 발톱을 가진 이 용맹한 새는 누구일까요?",
    answer: "황조롱이",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Falco_tinnunculus_male.jpg/500px-Falco_tinnunculus_male.jpg",
  },
  {
    id: "birds059", category: "birds", difficulty: "hard",
    question: "온몸이 노란빛으로 반짝이고 눈 주변에 검은 무늬가 있어 숲속에서 금방 눈에 띄는 아름다운 가수야! 여름에 우리나라를 찾아와 맑고 고운 노래를 들려주고 가을이 되면 다시 먼 여행을 떠나는 철새란다. 이름만 들어도 노래가 떠오르는 이 새는 누구일까요?",
    answer: "꾀꼬리",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Eurasian_Golden_Oriole_Oriolus_oriolus.jpg/500px-Eurasian_Golden_Oriole_Oriolus_oriolus.jpg",
  },
  {
    id: "birds060", category: "birds", difficulty: "hard",
    question: "온몸이 눈부신 하얀색이고 날개가 엄청나게 커서 하늘을 날아오를 때 정말 장엄한 바다의 여왕이야! 부리는 노란색이고 꼬리 깃털은 하늘하늘해서 마치 천사의 옷자락처럼 보인단다. 평화를 상징하는 세상에서 가장 아름다운 하얀 새 중 하나인 이것은 누구일까요?",
    answer: "고니",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Mute_swan_at_Stotfold_Mill.jpg/500px-Mute_swan_at_Stotfold_Mill.jpg",
  },
  {
    id: "birds033", category: "birds", difficulty: "easy",
    question: "봄이 되면 처마 밑에 진흙으로 집을 짓고 돌아오는 아주 반가운 봄 손님이야! 매끈한 검은색 날개와 하얀 배, 그리고 제비 꼬리라고 부르는 갈라진 꼬리를 가졌단다. 해충을 잡아먹는 아주 고마운 이 새는 누구일까요?",
    answer: "제비",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Barn_Swallow_Hirundo_rustica.jpg/500px-Barn_Swallow_Hirundo_rustica.jpg",
  },
  {
    id: "birds034", category: "birds", difficulty: "medium",
    question: "추운 겨울에 우리나라 호수를 찾아와 머무는 아주 아름다운 오리 친구야! 수컷은 머리에 멋진 깃털 장식이 있고 몸의 색깔이 아주 화려해서 '숲속의 요정' 같단다. 사이좋은 부부를 상징하는 것으로도 유명한 이 예쁜 새는 누구일까요?",
    answer: "원앙",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Aix_galericulata_male_female.jpg/500px-Aix_galericulata_male_female.jpg",
  },
  {
    id: "birds035", category: "birds", difficulty: "hard",
    question: "부리가 길고 아래로 굽어 있어 흙 속의 벌레를 아주 잘 찾아 먹는 멋쟁이야! 갈색 반점 무늬가 있는 옷을 입고 평원을 유유히 걸어 다니는 모습을 볼 수 있단다. 우리나라를 지나가는 나그네 새 중 하나인 이 신비로운 친구는 누구일까요?",
    answer: "마도요",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Eurasian_Curlew_Numenius_arquata.jpg/500px-Eurasian_Curlew_Numenius_arquata.jpg",
  },
  {
    id: "birds036", category: "birds", difficulty: "medium",
    question: "사람들이 기르는 새 중에서 아주 화려한 꼬리를 가진 종류가 많고 '구구구' 하며 사랑스럽게 울기도 해! 꼬리 날개를 부채처럼 펴서 멋을 부리는 종류도 있고, 다양한 색깔과 모양을 가진 평화로운 친구란다. 집이나 전시회에서 만날 수 있는 이 예쁜 새는 누구일까요?",
    answer: "관상비둘기",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Feral_pigeon_%28Columba_livia_domestica%29_in_London.jpg/500px-Feral_pigeon_%28Columba_livia_domestica%29_in_London.jpg",
  },
  {
    id: "birds037", category: "birds", difficulty: "medium",
    question: "바닷속으로 잠수해서 들어가 날개를 지느러미처럼 사용하며 수영하는 신기한 새야! 날개가 있지만 하늘을 날지는 못하고 대신 물고기를 아주 잘 잡는 잠수의 명수란다. 하얀 배를 땅에 대고 얼음 위를 미끄러지는 이 귀여운 새는 누구일까요?",
    answer: "아델리펭귄",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Adelie_Penguin.jpg/500px-Adelie_Penguin.jpg",
  },
  {
    id: "birds038", category: "birds", difficulty: "medium",
    question: "머리가 아주 좋아서 도구를 사용하기도 하고 반짝이는 물건을 모으는 취미가 있는 영리한 새야! 온몸이 까만색이라 조금 무서워 보일 수도 있지만 친구들과 협력해서 사냥을 하는 아주 똑똑한 친구란다. '까악까악' 소리를 내는 숲속의 우두머리는 누구일까요?",
    answer: "까마귀",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Corvus_corone_in_Tokyo.jpg/500px-Corvus_corone_in_Tokyo.jpg",
  },
  {
    id: "birds039", category: "birds", difficulty: "easy",
    question: "머리 위에 빨간색 모자를 쓴 것처럼 깃털이 붉고 우아하게 춤을 추는 새야! 긴 다리와 긴 목을 가졌으며 영원한 우정과 장수를 상징하는 아주 귀한 동물로 여겨져 왔단다. 하늘을 천천히 날아가는 모습이 정말 아름다운 이 새는 누구일까요?",
    answer: "학",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Red-crowned_Crane_in_Hokkaido.jpg/500px-Red-crowned_Crane_in_Hokkaido.jpg",
  },
  {
    id: "birds040", category: "birds", difficulty: "medium",
    question: "몸집은 작지만 아주 힘이 세고 사나워서 숲속의 작은 새들이 무서워하는 사냥꾼이야! 갈색 옷을 차려입고 땔나무 더미나 덤불 속에 숨어 있다가 먹이를 낚아챈단다. 매동구리라고도 불리며 아주 날렵한 이 새는 누구일까요?",
    answer: "때까치",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Lanius_bucephalus_male.jpg/500px-Lanius_bucephalus_male.jpg",
  },
];

const normalizeDifficulty = (difficulty) => {
  if (difficulty === "easy" || difficulty === "medium" || difficulty === "hard") {
    return difficulty;
  }

  return "medium";
};

const optionPoolByCategory = quizQuestions.reduce((accumulator, question) => {
  if (question.customOptions) {
    return accumulator;
  }

  if (!accumulator[question.category]) {
    accumulator[question.category] = new Set();
  }

  accumulator[question.category].add(question.answer);
  return accumulator;
}, {});

const processedQuizData = quizQuestions.map(q => {
  const categoryAnswers = optionPoolByCategory[q.category]
    ? Array.from(optionPoolByCategory[q.category])
    : allQuizAnswers[q.category] || [];
  const options = q.customOptions || generateOptions(q.answer, q.category, categoryAnswers);
  const correctAnswerIndex = options.indexOf(q.answer);
  return {
    ...q,
    difficulty: normalizeDifficulty(q.difficulty),
    options,
    correctAnswerIndex
  };
});

export default processedQuizData;
